import React, { Component, useState } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { connect } from "react-redux";
import _ from "lodash";
import SelectRouteActiveCall from "../components/SelectRouteActiveCall/SelectRouteActiveCall";

import { ReactComponent as VOZICONDISABLED } from "../build/new-midias-icons/voz.svg";
import { ReactComponent as WHATSAPPICONDISABLED } from "../build/new-midias-icons/whatsapp.svg";
import { ReactComponent as FACEBOOKICONDISABLED } from "../build/new-midias-icons/facebook.svg";
import { ReactComponent as INSTAGRAMDISABLED } from "../build/new-midias-icons/instagram.svg";
import { ReactComponent as EMAILICONDISABLED } from "../build/new-midias-icons/email.svg";
import { ReactComponent as TELEGRAMICONDISABLED } from "../build/new-midias-icons/telegram.svg";
import { ReactComponent as TWITTERICONDISABLED } from "../build/new-midias-icons/twitter.svg";
import { ReactComponent as LINKEDINICONDISABLED } from "../build/new-midias-icons/linkedin.svg";
import { ReactComponent as WEBCHATICONDISABLED } from "../build/new-midias-icons/webchat.svg";
import { ReactComponent as SMSICONDISABLED } from "../build/new-midias-icons/sms-icon.svg";
import { ReactComponent as TEAMSICONDISABLED } from "../build/new-midias-icons/teams.svg";
import { ReactComponent as WHATSAPPVOZICONDISABLED } from "../build/new-midias-icons/whatsapp-voz.svg";
import { ArrowDown2 } from "iconsax-reactjs";

import "../build/css/contact-new.css";

import {
  ShowVisibleNextAtd,
  ShowModalsMenu,
  getContacts,
  SearchingHistoryData,
  InsertCompany,
  UpdateCompany,
  DelCompany,
  GetCompanys,
  SearchCompany,
  getCompanys,
  GetHistory,
  getNumbersContact,
  GetNumbersContact,
  InteracoesContactNumber,
  CarregamentoInteractions,
  InsertContactNew,
  deleteNumberContact,
  ReturningCallback,
  returnListCallQueue,
  deleteNumber,
  AddNumberContact,
  UpdateContactNumber,
  editNumber,
  editTypeNumber,
  DelContact,
  UpdateContact,
  UpdateCompanyContact,
  getCep,
  InsertCompanyContact,
  RequestActiveCall,
  ClearContacts,
  getTypeNumbers,
  dbfileSize,
  getPhoneMidia,
  GetPhoneMidia,
  GetInteractionsContact,
  RequestActiveCallSocketVoz,
  InterationNotifier,
  ErrorNumberExist,
  ShowInfoDisplay,
  DownloadFile,
  GetInteractionsModal,
  GetDetailsContacts,
  GetTypeNumbers,
  getCepApi,
  getCompanysPaginated,
  getCompanysPaginatedV3,
  getContactsV3,
  InsertCompanyV2,
  SearchCompanyV2,
  UpdateCompanyV2,
  UpdateSearchCompany,
  updateContactOnEdit,
  deleteNumberContactOnEdit,
  updateContactNumberOnEdit,
  editClientName,
  updateContactOnEditV2,
  getCompanyInfo,
  clearGetCEP,
  editMenuBotAndAditionalInformationOfContactAndEnterprise,
  getContactPositions,
  getContactRelations,
  GetHistoryCalls,
  fetchListContactResponsibleCompany,
  insertContactResponsibleCompany,
  changeResponsavelPor,
} from "../actions";
import {
  RequestActiveCallSocket,
  UpdateContactInteraction,
} from "../actions/websocket";
import MicroModal from "micromodal";
import latinize from "latinize";
import { Form, Input } from "@rocketseat/unform";
import ICONWZ from "../build/images/whatsapp.svg";
import ICONVOZ from "../build/images/voz_icon.svg";
import ICONFACE from "../build/images/facebook.svg";
import SelectSearchWithPagination from "../components/SelectSearchWithPagination";
import SelectSearchWithPaginationV2 from "../components/SelectSearchWithPaginationV2/index";
import NewPaginationV2 from "../components/NewPaginationV2";

import "tippy.js/dist/tippy.css";
import AVI from "../build/images/avi-file.png";
import { Tooltip, Popover, Topover, Tooltippy } from "../actions/Tippy";
import FLAG from "../build/images/flag-br.png";
import DEFAULT from "../build/images/default.png";
import MIDIAZAPLARGE from "../build/images/icons-channels/whatsapp2-large.svg";
import CONTATOSALVO from "../build/images/adicionado.svg";
import PdfDocument from "../components/templates/PdfDocument";
import * as yup from "yup";
import Select from "react-select";
import InputMask from "react-input-mask";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import Moment from "moment";
import WHATSAPP from "../build/images/t-whatsapp.svg";
import Highlighter from "react-highlight-words";
import JPG from "../build/images/jpg-file.png";
import XLS from "../build/images/media-icon.png";
import PDF from "../build/images/pdf-file.png";
import MP3 from "../build/images/mp3-file.png";
import VIDEO from "../build/images/video.jpg";
import AUDIO from "../build/images/audio.svg";
import FOTO from "../build/images/foto.svg";
import DOC from "../build/images/doc.svg";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { PHONEMIDIA } from "../constants/ActionTypes";
import ICONPDFEXPORT from "../build/images/pdf.svg";
import TEAMS from "../build/images/channelsNew/teamsBig.svg";

import WEBCHATICON from "../build/images/webchat-new.svg";
// import MIDIAFACE from "../build/images/facebook_new.svg";
import { ReactComponent as SMSICON } from "../build/images/sms-new.svg";
import MIDIAFACE from "../build/images/channelsNew/facebook.svg";
// import MIDIAZAP from "../build/images/whatsapp_new.svg";
import MIDIAZAP from "../build/images/whatsapp_new2.svg";
import MIDIAZAPVOZ from "../build/images/whatsapp_voice.svg";
// import MIDIAZAP from "../build/images/icons-channels/whatsapp2-large.svg";
import MIDIAWEB from "../build/images/webchat-new.svg";
import CALLCHAT from "../build/images/callchat-new.svg";
import TWITTER from "../build/images/twitter-new.svg";
import MIDIAEMAIL from "../build/images/email-new.svg";
import MIDIATELEGRAM from "../build/images/telegram-new.svg";
import LINKEDIN from "../build/images/linkedin-new.svg";
import INSTAGRAM from "../build/images/instagram_new.svg";
// import INSTAGRAM from "../build/images/channelsNew/instagram.svg";
// import GOOGLEGBM from "../build/images/googlegbm-new.svg";
import GOOGLEGBM from "../build/images/icons-channels/googlegbm-large2.svg";
import { ReactComponent as IconMinus } from "../build/images/minus-circle.svg";

import ModalsDetails from "../components/modals/NewModals";
import UserPhoto from "../components/UserPhoto/userphoto";

import "../build/css/contacts.css";
import Typography from "../components/Typography";
import Checkbox from "../components/manager-section/CheckboxIng/CheckboxIng";
import DropdownChannel from "../components/DropdownChannel/DropdownChannel";
import NewSelect from "../components/NewSelect/NewSelect";
import { toast } from "react-toastify";

import { reduceString } from "../utils/reduceString";
import { promiseLimit } from "../utils/promiseLimit";
import { CircularProgress } from "@mui/material";
import { addContactInIngDesk } from "../thunks/IngDeskIntegration/addIngDeskInformationIfNotExists";
import SelectTagV2 from "../components/SelectTagV2/SelectTagV2";
import MuiMultiSelect from "../components/MuiMultiSelect/MuiMultiSelect";
import ListOfTags from "../components/ListOfTags/ListOfTags";
import {
  DeleteContactResponsibleCompany,
  getResponsavelPorToAdd,
  getResponsavelPorToDelete,
  InsertContactsResponsibleCompany,
} from "../utils/responsavelPorUtils";
import { codeBase64Convert } from "../utils/codeBase64Convert";
/*
import {
  getCompanysPaginated,
  getCompanysPaginatedV3,
} from "../services/contact/getCompanysPaginated";
*/
/*
import {
  getContactsV2,
  InsertCompanyV2,
  SearchCompanyV2,
  UpdateCompanyV2,
  UpdateSearchCompany,
} from "../actions/contactActions";
*/

const { connection_platform } = require("../services/api");

const { meses } = require("../services/data");

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
var checkreply = false;
var numeroCliente = "";
var optionsUsers = [];

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  //if(parseInt(connection_platform.port_apache_view_extern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

port = localStorage.getItem("port");
pathname = localStorage.getItem("pathname");

async function getListCompanys(searchParams, page) {
  let companysData = [];
  if (
    searchParams === "" ||
    searchParams === null ||
    searchParams === undefined
  ) {
    const data = await getCompanysPaginated(page, searchParams, 50);
    if (data && data.length) {
      companysData = data.map((companyInfo) => {
        if (
          (companyInfo.externcode || companyInfo.externcode === 0) &&
          (companyInfo.cnpj || companyInfo.cnpj === 0)
        ) {
          return {
            ...companyInfo,
            caption1: companyInfo.cnpj,
            caption2: companyInfo.externcode,
          };
        }
        if (companyInfo.cnpj || companyInfo.cnpj === 0) {
          return { ...companyInfo, caption1: companyInfo.cnpj };
        }
        if (companyInfo.externcode || companyInfo.externcode === 0) {
          return { ...companyInfo, caption1: companyInfo.externcode };
        }
        return { ...companyInfo };
      });
    }
  } else {
    const data = await getCompanysPaginatedV3(page, searchParams, 50);
    if (data && data.length) {
      companysData = data.map((companyInfo) => {
        if (
          (companyInfo.externcode || companyInfo.externcode === 0) &&
          (companyInfo.cnpj || companyInfo.cnpj === 0)
        ) {
          return {
            ...companyInfo,
            caption1: companyInfo.cnpj,
            caption2: companyInfo.externcode,
          };
        }
        if (companyInfo.cnpj || companyInfo.cnpj === 0) {
          return { ...companyInfo, caption1: companyInfo.cnpj };
        }
        if (companyInfo.externcode || companyInfo.externcode === 0) {
          return { ...companyInfo, caption1: companyInfo.externcode };
        }
        return { ...companyInfo };
      });
    }
  }

  return companysData;
}

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

function tratarMSG(item) {
  var mensagem_tratada = item;
  mensagem_tratada = item.replace(/¿/gi, "\n");
  mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
  let valor = 1;
  try {
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    var obj = JSON.parse(mensagem_tratada);
    mensagem_tratada = obj[1][0].mensagem_tratada;
  } catch (e) {
    mensagem_tratada = item;
    mensagem_tratada = mensagem_tratada.replace(/\r\n/gi, "ªª");
    mensagem_tratada = mensagem_tratada.replace(/\r\n/gi, "ªª");
    mensagem_tratada = mensagem_tratada.replace(/"/gi, "");
    mensagem_tratada = mensagem_tratada.replace(
      /[^A-ZÀ-Ú a-zà-ú 0-9 , . ? ! *  # ; : '-' _ + § ¿ { } ' " ª \\ \ ]/g,
      "",
    );
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    try {
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
      mensagem_tratada = mensagem_tratada.replace(/ªª/gi, "\r\n");
    } catch (e) {
      mensagem_tratada = item;
    }
  }
  return mensagem_tratada;
}

function isJson(item) {
  item = typeof item != "string" ? JSON.stringify(item) : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    return false;
  }

  if (typeof item === "object" && item != null) {
    return true;
  }

  return false;
}

MicroModal.init();

const schema = yup.object().shape({
  nome: yup.string(),
  telefone: yup.string(),
  codext: yup.string(),
  email: yup.string(),
  empresa: yup.string(),
  contato: yup.string(),
});

const mapStateToProps = (state) => {
  return {
    DisplayNextAtd: state.displaynextatd,
    Modals: state.modals,
    Contacts: state.contacts,
    UsersAgents: state.agents,
    Companys: state.companys,
    NumbersContact: state.numberscontact,
    PhoneMidia: state.phonemidia,
    TypeNumbers: state.typenumbers,
    PermissionRouter: state.routergroups,
    OutBandService: state.outservices,
    InfoUsers: state.informationusers,
    ShowActiveCall: state.showactivecall,
    Messages: state.messages,
    StatusAgent: state.status,
    listCallQueue: state.listcallqueue,
    returnCep: state.cep,
    InteractionsNumber: state.interactions,
    IPCurrent: state.ipcurrent,
    History: state.history,
    AtdSimult: state.atdsimult,
    DetailsContacts: state.detailscontacts,
    ContactId: state.atendimento,
    HistoryCalls: state.historycalls ? state.historycalls.historycalls : [],
  };
};

const mapDispatchToProps = (dispatch) => ({
  ShowVisibleNextAtdIn: (post, temp) => {
    dispatch(ShowVisibleNextAtd(post, temp));
  },
  DownloadFile: (post, temp) => {
    dispatch(DownloadFile(post, temp));
  },
  ShowInfoDisplay: (post) => {
    dispatch(ShowInfoDisplay(post));
  },
  ShowModalsMenu: (post) => {
    dispatch(ShowModalsMenu(post));
  },
  getCep: (post) => {
    dispatch(getCep(post));
  },
  SearchingContacts: (post, contatoof, empresa) => {
    dispatch(getContacts(post, contatoof, empresa));
  },
  SearchingContactsV2: (post, contatoof, empresa, codeExtEmp) => {
    dispatch(getContactsV3(post, contatoof, empresa, codeExtEmp));
  },
  UpdateCompanyContact: (contactid, companyid) => {
    dispatch(UpdateCompanyContact(contactid, companyid));
  },
  InsertCompanyContact: (contactid, companyid) => {
    dispatch(InsertCompanyContact(contactid, companyid));
  },
  ErrorNumberExist: (number) => {
    dispatch(ErrorNumberExist(number));
  },
  GetNumbersContact: (post) => {
    dispatch(getNumbersContact(post));
    dispatch(getPhoneMidia(post));
  },
  ClearCompany: (post) => {
    dispatch(getCompanys([]));
  },
  ShowCompanys: (post) => {
    dispatch(GetCompanys(post));
  },
  InterationNotifier: (text, type) => {
    dispatch(InterationNotifier(text, type));
  },
  InteracoesContactNumber: (
    number,
    datainit,
    datafim,
    mensagem,
    idgroup,
    contactid,
  ) => {
    dispatch(
      InteracoesContactNumber(
        number,
        datainit,
        datafim,
        mensagem,
        idgroup,
        contactid,
      ),
    );
    dispatch(GetInteractionsContact([]));
    dispatch(GetPhoneMidia([]));
  },
  DelContact: (post, iduser) => {
    dispatch(DelContact(post, iduser));
  },
  DelCompany: (post, iduser) => {
    dispatch(DelCompany(post, iduser));
  },
  UpdateContact: (
    contactid,
    displayname,
    name,
    email,
    cpf,
    rg,
    codigoexterno,
    nascimento,
    endereco,
    numero,
    district,
    cepassociationid,
    numberdel,
    particular,
    contatode,
  ) => {
    dispatch(
      UpdateContact(
        contactid,
        displayname,
        name,
        email,
        cpf,
        rg,
        codigoexterno,
        nascimento,
        endereco,
        numero,
        district,
        cepassociationid,
        numberdel,
        particular,
        contatode,
      ),
    );
    dispatch(deleteNumberContact(numberdel));
  },
  UpdateCompany: (
    inscricaoestadual,
    estadualmunicipal,
    site,
    emailcompany,
    cnpj,
    business,
    idcompany,
  ) => {
    dispatch(
      UpdateCompany(
        inscricaoestadual,
        estadualmunicipal,
        site,
        emailcompany,
        cnpj,
        business,
        idcompany,
      ),
    );
  },
  UpdateCompanyV2: (
    inscricaoestadual,
    estadualmunicipal,
    site,
    emailcompany,
    cnpj,
    business,
    idcompany,
    codeext,
  ) => {
    dispatch(
      UpdateCompanyV2(
        inscricaoestadual,
        estadualmunicipal,
        site,
        emailcompany,
        cnpj,
        business,
        idcompany,
        codeext,
      ),
    );
  },
  InsertCompany: (
    inscricaoestadual,
    estadualmunicipal,
    site,
    emailcompany,
    cnpj,
    business,
    userid,
  ) => {
    dispatch(
      InsertCompany(
        inscricaoestadual,
        estadualmunicipal,
        site,
        emailcompany,
        cnpj,
        business,
        userid,
      ),
    );
  },
  InsertCompanyV2: (
    inscricaoestadual,
    estadualmunicipal,
    site,
    emailcompany,
    cnpj,
    business,
    userid,
    codext,
  ) => {
    dispatch(
      InsertCompanyV2(
        inscricaoestadual,
        estadualmunicipal,
        site,
        emailcompany,
        cnpj,
        business,
        userid,
        codext,
      ),
    );
  },
  InsertContactNew: (
    displayname,
    name,
    email,
    cpf,
    rg,
    codigoexterno,
    nascimento,
    endereco,
    numero,
    district,
    cepassociationid,
    particular,
    usercreate,
    numberscontact,
    contatode,
    empresa,
    detailscontact,
    detailsScript,
    idrelacao = "",
    idcargo = "",
    responsavelPorToAdd = [],
  ) => {
    dispatch(
      InsertContactNew(
        displayname,
        name,
        email,
        cpf,
        rg,
        codigoexterno,
        nascimento,
        endereco,
        numero,
        district,
        cepassociationid,
        particular,
        usercreate,
        numberscontact,
        contatode,
        empresa,
        "",
        detailscontact,
        detailsScript,
        idrelacao,
        idcargo,
        responsavelPorToAdd,
      ),
    );
  },
  ReturningCallbackIn: (
    queueid,
    inforetorno,
    recvcount,
    cdrid,
    mediaid,
    srvin,
    caller,
    called,
    cbackcount,
  ) => {
    ReturningCallback(
      queueid,
      inforetorno,
      recvcount,
      cdrid,
      mediaid,
      srvin,
      caller,
      called,
    )(dispatch);
    dispatch(returnListCallQueue("", queueid, "2", parseInt(cbackcount + 1)));
  },
  deleteNumber: (idnumber) => {
    dispatch(deleteNumber(idnumber));
  },
  editTypeNumber: (idphone, typenumber, description, midiaid) => {
    dispatch(editTypeNumber(idphone, typenumber, description, midiaid));
  },
  editNumber: (idphone, number) => {
    dispatch(editNumber(idphone, number));
  },
  AddNumberContact: (post, number) => {
    dispatch(AddNumberContact(post, number));
    dispatch(GetPhoneMidia([]));
  },
  UpdateContactNumber: (number, iduser, contactid) => {
    dispatch(UpdateContactNumber(number, iduser, contactid));
  },
  ClearNumbersContact: (post) => {
    dispatch(GetNumbersContact([]));
  },
  CarregamentoCDR: (cdrid, idgroup) => {
    dispatch(GetHistory([]));
    CarregamentoInteractions(cdrid, idgroup)(dispatch);
  },
  SearchingHistory: (histstart, histend, idatendimento, telefone, idgroup) => {
    dispatch(
      SearchingHistoryData(
        histstart,
        histend,
        idatendimento,
        telefone,
        idgroup,
      ),
    );
  },
  SearchCompany: (cnpj, empresa) => {
    dispatch(SearchCompany(cnpj, empresa));
  },
  SearchCompanyV2: (cnpj, empresa, setTotalOfRows = () => {}, codextemp) => {
    dispatch(SearchCompanyV2(cnpj, empresa, setTotalOfRows, codextemp));
  },
  UpdateSearchCompany: (cnpj, empresa, page, codextemp) => {
    dispatch(UpdateSearchCompany(cnpj, empresa, page, codextemp));
  },
  ClearHistory: (post) => {
    dispatch(GetHistory([]));
  },
  RequestActiveCall: (
    outband,
    infouser,
    trunk,
    mediaid,
    calledDigitado,
    addtech,
    scriptrunk,
    operator,
    returning,
    queueid,
    recvcount,
    cbackcount,
    idgrupo_transb,
    cdrold,
    rawNumber,
  ) => {
    dispatch(
      RequestActiveCall(
        outband,
        infouser,
        trunk,
        mediaid,
        calledDigitado,
        addtech,
        scriptrunk,
        operator,
        returning,
        queueid,
        recvcount,
        cbackcount,
        idgrupo_transb,
        cdrold,
        undefined,
        undefined,
        rawNumber,
      ),
    );
  },
  ClearningContacts: (post) => {
    dispatch(ClearContacts([]));
    dispatch(getTypeNumbers([]));
  },
  RequestActiveCallSocketVoz: (
    outband,
    infouser,
    trunk,
    mediaid,
    chamado,
    addtech,
    scriptrunk,
    operator,
    returning,
    queueid,
    recvcount,
    callback_count,
    tech,
    idgrupo_rota,
    idgrupo_transb,
    ipcurrent,
    cdrid,
    rotaencontrada,
  ) => {
    dispatch(
      RequestActiveCallSocketVoz(
        outband,
        infouser,
        trunk,
        mediaid,
        chamado,
        addtech,
        scriptrunk,
        operator,
        returning,
        queueid,
        recvcount,
        callback_count,
        tech,
        idgrupo_rota,
        idgrupo_transb,
        ipcurrent,
        cdrid,
        rotaencontrada,
      ),
    );
  },
  GetInteractionsModal: (client, number, contactid) => {
    dispatch(GetInteractionsModal(client, number, contactid));
  },
  GetDetailsContacts: (value, data, datacontact) => {
    dispatch(GetDetailsContacts(value, data, datacontact));
  },
  GetTypeNumbers: (data) => {
    dispatch(GetTypeNumbers(data));
  },
  getCepApi: (post) => {
    dispatch(getCepApi(post));
  },
  editClient: (numberscontact, displayname) => {
    dispatch(editClientName(numberscontact, displayname));
  },
  AddContactInIngDesk: async (contactInfos) => {
    await dispatch(addContactInIngDesk(contactInfos));
  },
  ClearGetCEP: () => {
    dispatch(clearGetCEP());
  },
  EditMenuBotAndAditionalInformationOfContactAndEnterprise: (
    numberscontact,
    newInfosToMenuBot,
  ) => {
    dispatch(
      editMenuBotAndAditionalInformationOfContactAndEnterprise(
        numberscontact,
        newInfosToMenuBot,
      ),
    );
  },
  DispatchGetHistoryCalls: (data) => {
    dispatch(GetHistoryCalls(data));
  },
  ChangeResponsavelPor: (cdr, responsavelPor, contactId) => {
    let formatedResponsavelPor = [];
    if (Array.isArray(responsavelPor)) {
      formatedResponsavelPor = responsavelPor.map((empresa) => ({
        id: empresa.id,
        nome: empresa.label,
        cnpj: empresa.caption1,
        externcode: empresa.caption2,
      }));
    }
    dispatch(changeResponsavelPor(cdr, formatedResponsavelPor, contactId));
  },
});

class Modals extends Component {
  constructor(props) {
    super(props);
    this.SearchHistoryContact = this.SearchHistoryContact.bind(this);
    this.updateContact = this.updateContact.bind(this);
    this.updateContactV2 = this.updateContactV2.bind(this);
    this.addItemsToResponsavelPorInDb =
      this.addItemsToResponsavelPorInDb.bind(this);
    this.removeItemsToResponsavelPorInDb =
      this.removeItemsToResponsavelPorInDb.bind(this);
    this.state = {
      externalCodeInsideLegalPerson: "",
      totalOfRows: 0,
      pagination: 20,
      rowsPage: 20,
      pageOfTable: 0,
      externalCodeCompanyInCompanyPage: "",
      externalCodeCompany: "",
      visible: "",
      Contacts: [],
      empresa: "",
      contatoof: "",
      buttonshowpfpj: false,
      companys: [],
      history: [],
      numberinteract: "0",
      searchText: "",
      numbercontact: "",
      contactid: 0,
      numberDel: [],
      value: "",
      module: "edit",
      buttonnewcontact: false,
      empresaC: "",
      empresa: "",
      person: "",
      numberC: "",
      contatoname: "",
      contatoid: 0,
      numberscontact: [],
      private: null,
      interactions: [],
      mensagem: "",
      moreinfo: false,
      maskCustom: "",
      nomeContato: "",
      emailContato: "",
      telefoneContato: "",
      codigoExternoContato: "",
      isLoadingSavingAlterations: false,
      detailsScript: "",
      errosDiv: {
        nome: false,
        contato: false,
        displayName: false,
        empresa: false,
      },
      todosCargos: [],
      cargoSelecionado: undefined,
      todasRelacoes: [],
      relacaoSelecionada: undefined,
      historicData: null,
      responsavelPor: [],
      responsavelPorInDb: [],
      isLoadingResponsavelPor: true,
    };
  }

  componentDidMount() {
    this.listUsers();
    this.listarCargos();
    this.listarRelacoes();
    this.setState({ historicData: null });
  }

  componentDidUpdate(prevProps, prevState) {
    let empresa = this.nameempresa.value;
    let cnpj = this.cnpj.value;
    let codextemp = "";

    if (this.state.externalCodeInsideLegalPerson) {
      codextemp = this.state.externalCodeInsideLegalPerson;
    }

    // Verifica se o estado page foi alterado
    if (this.state.pageOfTable !== prevState.pageOfTable) {
      // Chama a função para fazer a requisição à API
      this.props.UpdateSearchCompany(
        cnpj,
        empresa,
        this.state.pageOfTable + 1,
        codextemp,
      );
    }

    const isUsersAgentsChanged = !_.isEqual(
      prevProps.user,
      this.props.UsersAgents,
    );
    if (isUsersAgentsChanged) {
      this.listUsers();
    }

    const isHistoricDataChanged = !_.isEqual(
      prevProps.DetailsContacts.historicData,
      this.props.DetailsContacts.historicData,
    );
    if (isHistoricDataChanged) {
      const isToUpdateHistoric = Boolean(
        this.props.DetailsContacts.historicData,
      );

      if (isToUpdateHistoric) {
        this.setState({
          disabled: false,
          module: "edit",
          historicData: this.props.DetailsContacts.historicData,
        });
      }
    }

    if (prevState.contactid !== this.state.contactid) {
      this.ObterListaResponsaveisPor(this.state.contactid);
    }
  }

  CloseModals(e, modal) {
    this.props.ShowModalsMenu(modal);
    this.props.ClearningContacts();
  }
  download(file, name) {
    this.props.DownloadFile(file, name);
  }

  async ObterListaResponsaveisPor(contactId) {
    this.setState({
      isLoadingResponsavelPor: true,
    });

    const response = await fetchListContactResponsibleCompany(contactId);
    if (!Boolean(contactId)) {
      this.setState({
        isLoadingResponsavelPor: false,
      });
      return;
    }
    const hasData =
      Boolean(response) &&
      response.status === 200 &&
      Boolean(response.data) &&
      Array.isArray(response.data.empresas);
    if (!hasData) {
      toast.error("Ocorreu um erro, tente novamente!");
      this.setState({
        responsavelPor: [],
        responsavelPorInDb: [],
        isLoadingResponsavelPor: false,
      });
      return;
    }
    const formatedData = response.data.empresas.map((empresa) => {
      return {
        label: empresa.company_name || "",
        id: empresa.companyid || null,
        caption1: empresa.cnpj || null,
        caption2: empresa.externcode || null,
        isFromDb: true,
      };
    });
    this.setState({
      responsavelPor: formatedData,
      responsavelPorInDb: formatedData,
      isLoadingResponsavelPor: false,
    });
  }

  renderPopoverPhoto = (e, ip, file) => (
    <>
      {file ? (
        <div className="img">
          <img
            src={
              file ? connection_platform.type_connect + "://" + ip + file : null
            }
            width="100"
            alt=""
          />
        </div>
      ) : (
        ""
      )}
    </>
  );

  renderPopoverPhotoContact = (e, url) => (
    <>
      {url ? (
        <div className="img">
          <img src={url ? url : null} width="100" alt="" />
        </div>
      ) : (
        ""
      )}
    </>
  );

  handleKeyUp(inf) {
    var elems = document.getElementsByTagName("mark");
    var tam = elems.length;

    if (tam >= this.state.arrowterm + 1) {
      elems[this.state.arrowterm].scrollIntoView(false);
      if (inf == "less") {
        if (this.state.arrowterm != 0) {
          this.state.arrowterm = this.state.arrowterm - 1;
          if (this.state.expand_less_count != 1)
            this.setState({
              expand_less_count: this.state.expand_less_count - 1,
            });
        }
      } else {
        this.state.arrowterm = this.state.arrowterm + 1;
        if (this.state.expand_less_count != this.state.expand_more_count)
          this.setState({
            expand_less_count: this.state.expand_less_count + 1,
          });
      }
    } else {
      if (elems[this.state.arrowterm]) {
        this.state.arrowterm = 1;
        elems[this.state.arrowterm].scrollIntoView(false);
      }
    }
    if (tam === this.state.arrowterm) {
      if (inf == "less") {
        this.state.arrowterm = this.state.arrowterm - 1;
        this.setState({ expand_less_count: this.state.expand_less_count - 1 });
      }
    }
  }

  GetTermText(event) {
    var elems = document.getElementsByTagName("mark");
    var tam = elems.length;
    this.setState({
      searchText: event.target.value,
      arrowterm: 0,
      expand_more_count: tam,
    });

    if (tam === 0) {
      this.setState({ expand_less_count: 0 });
    } else {
      this.setState({ expand_less_count: 1 });
    }
  }

  // SolicitarChamadaAtiva(
  //   e,
  //   permrouter,
  //   mediaid,
  //   outband,
  //   infouser,
  //   status,
  //   queue,
  //   number,
  //   AtdSimult,
  //   ipcurrent,
  //   statusAgent
  // ) {
  //   if (statusAgent.allowCall === false) {
  //     this.props.InterationNotifier("Pausa não permite ativo", "permission");
  //     return true;
  //   }
  //   if (document.getElementById("chat-message"))
  //     document.getElementById("chat-message").innerText = "";
  //   if (permrouter != "undefined" && permrouter != "") {
  //     var existeRota = false;
  //     var rotaencontrada = false;
  //     var checkRota = false;
  //     var rotaDefault = false;
  //     var rotaAlternativa = false;
  //     var trunk = "";
  //     var addtech = "";
  //     var scriptrunk = "";
  //     var operator = "";
  //     var trunkDef = "";
  //     var addtechDef = "";
  //     var scriptrunkDef = "";
  //     var operatorDef = "";
  //     var tech = "";
  //     var techDef = "";
  //     var idgrupo_rota = "";
  //     var idgrupo_rotaDef = "";
  //     var idgrupo_transb = "";
  //     var idgrupo_transbDef = "";
  //     var chamado = number;
  //     var retorno = 0;
  //     var checkAtd = false;
  //     var tipochamada = 0;
  //     var dddValidado = "";

  //     if (mediaid === 5 || mediaid === 1 || mediaid === 8 || mediaid === 12) {
  //       chamado = chamado.replace(/\D/g, "");
  //     }

  //     if (
  //       permrouter[0].areacodeid != "undefined" &&
  //       permrouter[0].areacodeid != ""
  //     ) {
  //       var DDD = permrouter[0].areacodeid;
  //       var DDDPadrao = permrouter[0].areacodeid;
  //     } else {
  //       var DDD = "";
  //       var DDDPadrao = "";
  //     }

  //     var calledDigitado = chamado;
  //     var valorfixo = [1, 2, 3, 4];
  //     var valormovel = [5, 6, 7, 8, 9];
  //     if (connection_platform.remove_digits || parseInt(mediaid) !== 1) {
  //       if (
  //         chamado[0] === "0" &&
  //         chamado.substr(0, 2) != "00" &&
  //         chamado.substr(0, 4) != "0800"
  //       ) {
  //         chamado = chamado.substr(1, chamado.length - 1);
  //       }
  //     }
  //     if (
  //       (chamado.length === 12 || chamado.length === 13) &&
  //       chamado.substr(0, 2) != "00"
  //     ) {
  //       if (chamado.substr(0, 2) === "55") {
  //         chamado = chamado.substr(2, chamado.length - 1);
  //         calledDigitado = calledDigitado.substr(2, calledDigitado.length - 1);
  //       }

  //       dddValidado = chamado.substr(2, 2);

  //       if (
  //         !connection_platform.remove_digits &&
  //         parseInt(mediaid) === 1 &&
  //         chamado.startsWith("0")
  //       ) {
  //         dddValidado = chamado.substr(1, 2);
  //       }

  //       if (parseInt(dddValidado) != parseInt(DDDPadrao)) {
  //         if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
  //           if (mediaid == 1) tipochamada = 3;
  //           else if (mediaid == 5) tipochamada = 17;
  //           else if (mediaid == 8) tipochamada = 19;
  //           else if (mediaid === 4) tipochamada = 18;
  //           else if (mediaid === 6) tipochamada = 20;
  //           else if (mediaid === 9) tipochamada = 21;
  //           else if (mediaid === 10) tipochamada = 23;
  //           else if (mediaid === 3) tipochamada = 22;
  //           else if (mediaid === 2) tipochamada = 24;
  //           else if (mediaid === 11) tipochamada = 25;
  //           else if (mediaid === 12) tipochamada = 13;
  //         } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
  //           if (mediaid == 1) tipochamada = 4;
  //           else if (mediaid == 5) tipochamada = 17;
  //           else if (mediaid == 8) tipochamada = 19;
  //           else if (mediaid === 4) tipochamada = 18;
  //           else if (mediaid === 6) tipochamada = 20;
  //           else if (mediaid === 9) tipochamada = 21;
  //           else if (mediaid === 10) tipochamada = 23;
  //           else if (mediaid === 3) tipochamada = 22;
  //           else if (mediaid === 2) tipochamada = 24;
  //           else if (mediaid === 11) tipochamada = 25;
  //           else if (mediaid === 12) tipochamada = 13;
  //         }
  //       } else if (parseInt(dddValidado) == parseInt(DDDPadrao)) {
  //         if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
  //           if (mediaid == 1) tipochamada = 1;
  //           else if (mediaid == 5) tipochamada = 17;
  //           else if (mediaid == 8) tipochamada = 19;
  //           else if (mediaid === 4) tipochamada = 18;
  //           else if (mediaid === 6) tipochamada = 20;
  //           else if (mediaid === 9) tipochamada = 21;
  //           else if (mediaid === 10) tipochamada = 23;
  //           else if (mediaid === 3) tipochamada = 22;
  //           else if (mediaid === 2) tipochamada = 24;
  //           else if (mediaid === 11) tipochamada = 25;
  //           else if (mediaid === 12) tipochamada = 13;
  //         } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
  //           if (mediaid == 1) tipochamada = 2;
  //           else if (mediaid == 5) tipochamada = 17;
  //           else if (mediaid == 8) tipochamada = 19;
  //           else if (mediaid === 4) tipochamada = 18;
  //           else if (mediaid === 6) tipochamada = 20;
  //           else if (mediaid === 9) tipochamada = 21;
  //           else if (mediaid === 10) tipochamada = 23;
  //           else if (mediaid === 3) tipochamada = 22;
  //           else if (mediaid === 2) tipochamada = 24;
  //           else if (mediaid === 11) tipochamada = 25;
  //           else if (mediaid === 12) tipochamada = 13;
  //         }
  //       }
  //     }
  //     if (
  //       (chamado.length === 10 || chamado.length === 11) &&
  //       chamado.substr(0, 4) != "0800" &&
  //       chamado.substr(0, 2) != "00"
  //     ) {
  //       if (!connection_platform.remove_digits && chamado[0] === "0") {
  //         DDD = chamado.substr(1, 2);
  //         chamado = chamado.substr(3, chamado.length - 1);
  //       } else {
  //         DDD = chamado.substr(0, 2);
  //         chamado = chamado.substr(2, chamado.length - 1);
  //       }

  //       if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
  //         if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
  //           chamado = "9" + chamado;
  //         }
  //       }

  //       if (
  //         parseInt(parseInt(DDD)) != parseInt(DDDPadrao) &&
  //         chamado.substr(0, 2) != "00"
  //       ) {
  //         if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
  //           if (mediaid == 1) tipochamada = 3;
  //           else if (mediaid == 5) tipochamada = 17;
  //           else if (mediaid == 8) tipochamada = 19;
  //           else if (mediaid === 4) tipochamada = 18;
  //           else if (mediaid === 6) tipochamada = 20;
  //           else if (mediaid === 9) tipochamada = 21;
  //           else if (mediaid === 10) tipochamada = 23;
  //           else if (mediaid === 3) tipochamada = 22;
  //           else if (mediaid === 2) tipochamada = 24;
  //           else if (mediaid === 11) tipochamada = 25;
  //           else if (mediaid === 12) tipochamada = 13;
  //         } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
  //           if (mediaid == 1) tipochamada = 4;
  //           else if (mediaid == 5) tipochamada = 17;
  //           else if (mediaid == 8) tipochamada = 19;
  //           else if (mediaid === 4) tipochamada = 18;
  //           else if (mediaid === 6) tipochamada = 20;
  //           else if (mediaid === 9) tipochamada = 21;
  //           else if (mediaid === 10) tipochamada = 23;
  //           else if (mediaid === 3) tipochamada = 22;
  //           else if (mediaid === 2) tipochamada = 24;
  //           else if (mediaid === 11) tipochamada = 25;
  //           else if (mediaid === 12) tipochamada = 13;
  //         }
  //       } else if (parseInt(DDD) == parseInt(DDDPadrao)) {
  //         if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
  //           if (mediaid == 1) tipochamada = 1;
  //           else if (mediaid == 5) tipochamada = 17;
  //           else if (mediaid == 8) tipochamada = 19;
  //           else if (mediaid === 4) tipochamada = 18;
  //           else if (mediaid === 6) tipochamada = 20;
  //           else if (mediaid === 9) tipochamada = 21;
  //           else if (mediaid === 10) tipochamada = 23;
  //           else if (mediaid === 3) tipochamada = 22;
  //           else if (mediaid === 2) tipochamada = 24;
  //           else if (mediaid === 11) tipochamada = 25;
  //         } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
  //           if (mediaid == 1) tipochamada = 2;
  //           else if (mediaid == 5) tipochamada = 17;
  //           else if (mediaid == 8) tipochamada = 19;
  //           else if (mediaid === 4) tipochamada = 18;
  //           else if (mediaid === 6) tipochamada = 20;
  //           else if (mediaid === 9) tipochamada = 21;
  //           else if (mediaid === 10) tipochamada = 23;
  //           else if (mediaid === 3) tipochamada = 22;
  //           else if (mediaid === 2) tipochamada = 24;
  //           else if (mediaid === 11) tipochamada = 25;
  //           else if (mediaid === 12) tipochamada = 13;
  //         }
  //       }
  //       if (mediaid !== 8) {
  //         chamado = DDD + chamado;
  //       }
  //     } else if (chamado.length === 8 || chamado.length === 9) {
  //       if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
  //         if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
  //           chamado = "9" + chamado;
  //         }
  //       }

  //       if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
  //         if (mediaid == 1) tipochamada = 1;
  //         else if (mediaid == 5) tipochamada = 17;
  //         else if (mediaid == 8) tipochamada = 19;
  //         else if (mediaid === 4) tipochamada = 18;
  //         else if (mediaid === 6) tipochamada = 20;
  //         else if (mediaid === 9) tipochamada = 21;
  //         else if (mediaid === 10) tipochamada = 23;
  //         else if (mediaid === 3) tipochamada = 22;
  //         else if (mediaid === 2) tipochamada = 24;
  //         else if (mediaid === 11) tipochamada = 25;
  //         else if (mediaid === 12) tipochamada = 13;
  //       } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
  //         if (mediaid == 1) tipochamada = 2;
  //         else if (mediaid == 5) tipochamada = 17;
  //         else if (mediaid == 8) tipochamada = 19;
  //         else if (mediaid === 4) tipochamada = 18;
  //         else if (mediaid === 6) tipochamada = 20;
  //         else if (mediaid === 9) tipochamada = 21;
  //         else if (mediaid === 10) tipochamada = 23;
  //         else if (mediaid === 3) tipochamada = 22;
  //         else if (mediaid === 2) tipochamada = 24;
  //         else if (mediaid === 11) tipochamada = 25;
  //         else if (mediaid === 12) tipochamada = 13;
  //       }
  //       if (mediaid !== 1 && mediaid !== 8) {
  //         chamado = DDD + chamado;
  //         calledDigitado = DDD + calledDigitado;
  //       }
  //     } else if (chamado.substr(0, 4) == "0800" && chamado.length > 9) {
  //       //chamado = '0'+chamado;
  //       tipochamada = 8;
  //     } else if (chamado.substr(0, 2) == "00") {
  //       if (mediaid == 1) tipochamada = 5;
  //       else if (mediaid == 5) tipochamada = 17;
  //       else if (mediaid == 8) tipochamada = 19;
  //       else if (mediaid === 4) tipochamada = 18;
  //       else if (mediaid === 6) tipochamada = 20;
  //       else if (mediaid === 9) tipochamada = 21;
  //       else if (mediaid === 10) tipochamada = 23;
  //       else if (mediaid === 3) tipochamada = 22;
  //       else if (mediaid === 2) tipochamada = 24;
  //       else if (mediaid === 11) tipochamada = 25;
  //       else if (mediaid === 12) tipochamada = 13;
  //     } else {
  //       permrouter.map((result) => {
  //         if (result.calltypeid == 11) {
  //           if (
  //             parseInt(chamado) >= parseInt(result.partialnumber) &&
  //             parseInt(chamado) <= parseInt(result.partialnumber_end)
  //           ) {
  //             tipochamada = 11;
  //           }
  //         } else if (result.calltypeid == 6) {
  //           if (parseInt(chamado) === parseInt(result.partialnumber)) {
  //             tipochamada = 6;
  //           }
  //         }
  //       });
  //     }

  //     AtdSimult.map((atend) => {
  //       if (
  //         String(atend.telefone) === String(chamado) &&
  //         parseInt(mediaid) === parseInt(atend.idmidia)
  //       )
  //         checkAtd = true;
  //     });

  //     if (mediaid === 4) tipochamada = 18;
  //     else if (mediaid === 6) tipochamada = 20;
  //     else if (mediaid === 9) tipochamada = 21;
  //     else if (mediaid === 10) tipochamada = 23;
  //     else if (mediaid === 3) tipochamada = 22;
  //     else if (mediaid === 2) tipochamada = 24;
  //     else if (mediaid === 11) tipochamada = 25;
  //     else if (mediaid === 12) tipochamada = 13;
  //     if (checkAtd === false) {
  //       if (chamado !== "") {
  //         if (!isNaN(chamado)) {
  //           this.setState({ senhaincorreta: "none" });
  //           permrouter.map((result) => {
  //             if (parseInt(result.idmidia) === parseInt(mediaid)) {
  //               if (parseInt(tipochamada) == result.calltypeid) {
  //                 if (parseInt(tipochamada) == 1) {
  //                   if (
  //                     (parseInt(chamado) >=
  //                       parseInt(result.areacode + result.partialnumber) &&
  //                       chamado <=
  //                         parseInt(
  //                           result.areacode + result.partialnumber_end
  //                         )) ||
  //                     parseInt(chamado) ==
  //                       parseInt(result.areacode + result.partialnumber)
  //                   ) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     checkRota = true;
  //                     existeRota = true;
  //                   } else if (
  //                     (parseInt(
  //                       chamado.substr(parseInt(chamado.length) - 8, 4)
  //                     ) >= parseInt(result.partialnumber) &&
  //                       chamado.substr(parseInt(chamado.length) - 8, 4) <=
  //                         parseInt(result.partialnumber_end)) ||
  //                     parseInt(
  //                       chamado.substr(parseInt(chamado.length) - 8, 4)
  //                     ) == parseInt(result.partialnumber)
  //                   ) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     checkRota = true;
  //                     existeRota = true;
  //                   } else if (
  //                     result.operator !== null &&
  //                     result.operator != "" &&
  //                     result.areacode ===
  //                       parseInt(
  //                         chamado.substr(parseInt(chamado.length) - 10, 2)
  //                       )
  //                   ) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     existeRota = true;
  //                     checkRota = true;
  //                   } else if (rotaencontrada == false) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     existeRota = true;
  //                     checkRota = true;
  //                   }
  //                 } else if (parseInt(tipochamada) == 2) {
  //                   if (
  //                     (parseInt(chamado) >=
  //                       parseInt(result.areacode + result.partialnumber) &&
  //                       chamado <=
  //                         parseInt(
  //                           result.areacode + result.partialnumber_end
  //                         )) ||
  //                     parseInt(chamado) ==
  //                       parseInt(result.areacode + result.partialnumber)
  //                   ) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     checkRota = true;
  //                     existeRota = true;
  //                   } else if (
  //                     (parseInt(
  //                       chamado.substr(parseInt(chamado.length) - 8, 4)
  //                     ) >= parseInt(result.partialnumber) &&
  //                       chamado.substr(parseInt(chamado.length) - 8, 4) <=
  //                         parseInt(result.partialnumber_end)) ||
  //                     parseInt(
  //                       chamado.substr(parseInt(chamado.length) - 8, 4)
  //                     ) == parseInt(result.partialnumber)
  //                   ) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     checkRota = true;
  //                     existeRota = true;
  //                   } else if (
  //                     result.operator !== null &&
  //                     result.operator != "" &&
  //                     result.areacode ===
  //                       parseInt(
  //                         chamado.substr(parseInt(chamado.length) - 11, 2)
  //                       )
  //                   ) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     existeRota = true;
  //                     checkRota = true;
  //                   } else if (rotaencontrada == false) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     existeRota = true;
  //                     checkRota = true;
  //                   }
  //                 } else if (parseInt(tipochamada) == 3) {
  //                   if (
  //                     (parseInt(chamado) >=
  //                       parseInt(result.areacode + result.partialnumber) &&
  //                       chamado <=
  //                         parseInt(
  //                           result.areacode + result.partialnumber_end
  //                         )) ||
  //                     parseInt(chamado) ==
  //                       parseInt(result.areacode + result.partialnumber)
  //                   ) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     checkRota = true;
  //                     existeRota = true;
  //                   } else if (
  //                     (parseInt(
  //                       chamado.substr(parseInt(chamado.length) - 8, 4)
  //                     ) >= parseInt(result.partialnumber) &&
  //                       chamado.substr(parseInt(chamado.length) - 8, 4) <=
  //                         parseInt(result.partialnumber_end)) ||
  //                     parseInt(
  //                       chamado.substr(parseInt(chamado.length) - 8, 4)
  //                     ) == parseInt(result.partialnumber)
  //                   ) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     checkRota = true;
  //                     existeRota = true;
  //                   } else if (
  //                     parseInt(
  //                       chamado.substr(parseInt(chamado.length) - 10, 2)
  //                     ) == parseInt(result.areacode)
  //                   ) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     checkRota = true;
  //                     existeRota = true;
  //                   } else if (rotaencontrada == false) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     existeRota = true;
  //                     checkRota = true;
  //                   }
  //                 } else if (parseInt(tipochamada) == 4) {
  //                   if (
  //                     (parseInt(chamado) >=
  //                       parseInt(result.areacode + result.partialnumber) &&
  //                       chamado <=
  //                         parseInt(
  //                           result.areacode + result.partialnumber_end
  //                         )) ||
  //                     parseInt(chamado) ==
  //                       parseInt(result.areacode + result.partialnumber)
  //                   ) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     existeRota = true;
  //                     checkRota = true;
  //                   } else if (
  //                     (parseInt(
  //                       chamado.substr(parseInt(chamado.length) - 8, 4)
  //                     ) >= parseInt(result.partialnumber) &&
  //                       chamado.substr(parseInt(chamado.length) - 8, 4) <=
  //                         parseInt(result.partialnumber_end)) ||
  //                     parseInt(
  //                       chamado.substr(parseInt(chamado.length) - 8, 4)
  //                     ) == parseInt(result.partialnumber)
  //                   ) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     checkRota = true;
  //                     existeRota = true;
  //                   } else if (
  //                     parseInt(
  //                       chamado.substr(parseInt(chamado.length) - 11, 2)
  //                     ) == parseInt(result.areacode)
  //                   ) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     checkRota = true;
  //                     existeRota = true;
  //                   } else if (rotaencontrada == false) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     existeRota = true;
  //                     checkRota = true;
  //                   }
  //                 } else if (parseInt(tipochamada) == 5) {
  //                   if (rotaencontrada == false) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     existeRota = true;
  //                     checkRota = true;
  //                   }
  //                 } else if (parseInt(tipochamada) == 8) {
  //                   if (rotaencontrada == false) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     existeRota = true;
  //                     checkRota = true;
  //                   }
  //                 } else if (
  //                   parseInt(tipochamada) != 5 &&
  //                   chamado.substr(0, 2) == "00" &&
  //                   parseInt(result.operator) == parseInt(chamado.substr(0, 2))
  //                 ) {
  //                   trunk = result.idtrunk;
  //                   addtech = result.addtech;
  //                   scriptrunk = result.scripttrunk;
  //                   operator = "";
  //                   tech = result.tech;
  //                   idgrupo_rota = result.idgrupo_rota;
  //                   idgrupo_transb = result.idgrupo_transb;
  //                   rotaencontrada = true;
  //                   existeRota = true;
  //                   checkRota = true;
  //                 } else if (parseInt(tipochamada) == 11) {
  //                   permrouter.map((result) => {
  //                     if (result.calltypeid == 11) {
  //                       if (
  //                         parseInt(chamado) >= parseInt(result.partialnumber) &&
  //                         parseInt(chamado) <=
  //                           parseInt(result.partialnumber_end)
  //                       ) {
  //                         trunk = result.idtrunk;
  //                         addtech = result.addtech;
  //                         scriptrunk = result.scripttrunk;
  //                         operator = "";
  //                         tech = result.tech;
  //                         idgrupo_rota = result.idgrupo_rota;
  //                         idgrupo_transb = result.idgrupo_transb;
  //                         rotaencontrada = true;
  //                         existeRota = true;
  //                         checkRota = true;
  //                       }
  //                     }
  //                   });
  //                 } else if (parseInt(tipochamada) == 6) {
  //                   permrouter.map((result) => {
  //                     if (result.calltypeid == 6) {
  //                       if (
  //                         parseInt(chamado) === parseInt(result.partialnumber)
  //                       ) {
  //                         trunk = result.idtrunk;
  //                         addtech = result.addtech;
  //                         scriptrunk = result.scripttrunk;
  //                         operator = "";
  //                         tech = result.tech;
  //                         idgrupo_rota = result.idgrupo_rota;
  //                         idgrupo_transb = result.idgrupo_transb;
  //                         rotaencontrada = true;
  //                         existeRota = true;
  //                         checkRota = true;
  //                       }
  //                     }
  //                   });
  //                 } else {
  //                   if (rotaencontrada == false) {
  //                     trunk = result.idtrunk;
  //                     addtech = result.addtech;
  //                     scriptrunk = result.scripttrunk;
  //                     operator = result.operator;
  //                     tech = result.tech;
  //                     idgrupo_rota = result.idgrupo_rota;
  //                     idgrupo_transb = result.idgrupo_transb;
  //                     rotaencontrada = true;
  //                     existeRota = true;
  //                   }
  //                 }
  //               }
  //             }
  //           });
  //           if (existeRota == true) {
  //             for (let i = 0; i < queue.length; i++) {
  //               var numberqueue = queue[i].caller;
  //               //if(chamado === numberqueue){
  //               if (numberqueue.search(chamado) !== -1) {
  //                 retorno = 1;
  //                 var queueid = queue[i].queueid;
  //                 var recvcount = queue[i].recv_count;
  //                 var cdrid = queue[i].cdrid;
  //                 var srvin = queue[i].serviceinid;
  //                 var caller = queue[i].caller;
  //                 var called = queue[i].called;
  //                 var cbackcount = queue[i].callback_count;
  //                 var status = queue[i].status;
  //               }
  //             }

  //             if (mediaid === 5) {
  //               chamado = chamado.toString();
  //               chamado = chamado.trim();
  //               calledDigitado = calledDigitado.toString();
  //               calledDigitado = calledDigitado.trim();
  //             }

  //             if (parseInt(mediaid) === 1) {
  //               if (retorno === 1) {
  //                 this.props.RequestActiveCallSocketVoz(
  //                   outband,
  //                   infouser,
  //                   trunk,
  //                   mediaid,
  //                   chamado,
  //                   addtech,
  //                   scriptrunk,
  //                   operator,
  //                   true,
  //                   queueid,
  //                   recvcount,
  //                   null,
  //                   tech,
  //                   idgrupo_rota,
  //                   idgrupo_transb,
  //                   ipcurrent,
  //                   cdrid,
  //                   checkRota
  //                 );
  //                 this.props.ReturningCallbackIn(
  //                   queueid,
  //                   true,
  //                   recvcount,
  //                   cdrid,
  //                   mediaid,
  //                   srvin,
  //                   caller,
  //                   called,
  //                   cbackcount,
  //                   status
  //                 );
  //                 this.props.ShowInfoDisplay("Clientes");
  //                 MicroModal.close("modal__agenda-pf-usuario-detalhes");
  //               } else {
  //                 this.props.RequestActiveCallSocketVoz(
  //                   outband,
  //                   infouser,
  //                   trunk,
  //                   mediaid,
  //                   chamado,
  //                   addtech,
  //                   scriptrunk,
  //                   operator,
  //                   false,
  //                   queueid,
  //                   recvcount,
  //                   null,
  //                   tech,
  //                   idgrupo_rota,
  //                   idgrupo_transb,
  //                   ipcurrent,
  //                   cdrid,
  //                   checkRota
  //                 );
  //                 this.props.ReturningCallbackIn(
  //                   queueid,
  //                   true,
  //                   recvcount,
  //                   cdrid,
  //                   mediaid,
  //                   srvin,
  //                   caller,
  //                   called,
  //                   cbackcount,
  //                   status
  //                 );
  //                 this.props.ShowInfoDisplay("Clientes");
  //                 MicroModal.close("modal__agenda-pf-usuario-detalhes");
  //               }
  //             } else {
  //               if (retorno === 1) {
  //                 this.props.RequestActiveCall(
  //                   outband,
  //                   infouser,
  //                   trunk,
  //                   mediaid,
  //                   calledDigitado,
  //                   addtech,
  //                   scriptrunk,
  //                   operator,
  //                   true,
  //                   queueid,
  //                   recvcount,
  //                   cbackcount,
  //                   idgrupo_transb,
  //                   cdrid
  //                 );
  //                 this.props.ReturningCallbackIn(
  //                   queueid,
  //                   true,
  //                   recvcount,
  //                   cdrid,
  //                   mediaid,
  //                   srvin,
  //                   caller,
  //                   called,
  //                   cbackcount,
  //                   status
  //                 );
  //                 this.props.ShowInfoDisplay("Clientes");
  //                 MicroModal.close("modal__agenda-pf-usuario-detalhes");
  //                 // this.ExitModal(e, "modal__agenda-pf-usuario-detalhes");
  //               } else {
  //                 this.props.RequestActiveCall(
  //                   outband,
  //                   infouser,
  //                   trunk,
  //                   mediaid,
  //                   calledDigitado,
  //                   addtech,
  //                   scriptrunk,
  //                   operator,
  //                   false,
  //                   queueid,
  //                   recvcount,
  //                   cbackcount,
  //                   idgrupo_transb
  //                 );
  //                 this.props.ShowInfoDisplay("Clientes");
  //                 MicroModal.close("modal__agenda-pf-usuario-detalhes");
  //                 // this.ExitModal(e, "modal__agenda-pf-usuario-detalhes");
  //               }
  //             }
  //             //this.props.ShowActiveCallIn('')
  //             //MicroModal.close('modal__falar-com-cliente');
  //             //this.numberToActive.value = '';
  //           } else {
  //             this.setState({ senhaincorreta: "block" });
  //             document.getElementById("div_alert").innerHTML =
  //               "Sem rota de sa&iacute;da!";
  //           }
  //         } else {
  //           this.setState({ senhaincorreta: "block" });
  //           document.getElementById("div_alert").innerHTML =
  //             "Apenas n&uacute;meros!";
  //         }
  //       } else {
  //         this.setState({ senhaincorreta: "block" });
  //         document.getElementById("div_alert").innerHTML =
  //           "Informe o n&uacute;mero!";
  //       }
  //     } else {
  //       this.props.InterationNotifier(
  //         "Este cliente já está sendo atendido por você",
  //         "call"
  //       );
  //     }
  //   }
  // }

  //  SolicitarChamadaAtiva(
  //     e,
  //     permrouter,
  //     mediaid,
  //     outband,
  //     infouser,
  //     callStatus,
  //     queue,
  //     number,
  //     AtdSimult,
  //     ipcurrent,
  //     statusAgent
  //   ) {
  // SolicitarChamadaAtiva(
  //   e,
  //   permrouter,
  //   mediaid,
  //   outband,
  //   infouser,
  //   callStatus,
  //   queue,
  //   number,
  //   AtdSimult,
  //   ipcurrent,
  //   statusAgent
  // ) {
  //   document.getElementById("div_alert").innerHTML = "";

  //   if (this.props.ContactId.length !== 0) {
  //     localStorage.setItem(
  //       "current-service",
  //       this.props.ContactId.idatendimento
  //     );
  //   }

  //   if (statusAgent.allowCall === false) {
  //     this.props.InterationNotifier("Pausa não permite ativo", "permission");
  //     return true;
  //   }

  //   const chatMessage = document.getElementById("chat-message");
  //   if (chatMessage) chatMessage.innerText = "";

  //   if (!permrouter || permrouter.length === 0) return;

  //   let chamado = number.replace(/\D/g, "");
  //   let tipochamada = 0;
  //   let DDD = permrouter[0].areacodeid || "71";

  //   const valorfixo = [1, 2, 3, 4],
  //     valormovel = [5, 6, 7, 8, 9];
  //   const removeDigits =
  //     connection_platform.remove_digits || parseInt(mediaid) !== 1;

  //   if (
  //     removeDigits &&
  //     chamado.startsWith("0") &&
  //     !chamado.startsWith("00") &&
  //     !chamado.startsWith("0800")
  //   ) {
  //     chamado = chamado.substring(1);
  //   }

  //   function definirTipoChamada(mediaid, tipo) {
  //     const tipos = {
  //       fixoInterurbano: [3, 17, 19, 18, 20, 21, 23, 22, 24, 25],
  //       movelInterurbano: [4, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
  //       fixoLocal: [1, 17, 19, 18, 20, 21, 23, 22, 24, 25],
  //       movelLocal: [2, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
  //     };

  //     // Converte mediaid para inteiro
  //     const midiaConvertida = parseInt(mediaid, 10);

  //     // Se mediaid for 1, busca no objeto `tipos`, senão segue a lógica específica
  //     if (midiaConvertida === 1) {
  //       return tipos[tipo] ? tipos[tipo][midiaConvertida - 1] || 0 : 0;
  //     } else {
  //       const mapeamentoMidia = {
  //         2: 24,
  //         3: 22,
  //         4: 18,
  //         5: 17,
  //         6: 20,
  //         8: 19,
  //         9: 21,
  //         10: 23,
  //         12: 13,
  //         15: 26,
  //       };

  //       return mapeamentoMidia[midiaConvertida] || midiaConvertida;
  //     }
  //   }

  //   if (
  //     (chamado.length >= 10 || chamado.length === 8 || chamado.length === 9) &&
  //     !chamado.startsWith("00")
  //   ) {
  //     if (
  //       chamado.startsWith("55") &&
  //       (mediaid === 5 || mediaid === "5") &&
  //       chamado.length > 11
  //     )
  //       chamado = chamado.substr(2);
  //     if (chamado.length === 8 || chamado.length === 9) chamado = DDD + chamado;
  //   }

  //   let chamadoValidado = chamado.replace(/^0(?!0|800|300)/, "");
  //   console.log("INGENIUM_ACTVECALL_0 : ", chamado);

  //   let dddValidado =
  //     chamadoValidado.length >= 10 ? chamadoValidado.substr(0, 2) : "";

  //   console.log("INGENIUM_ACTVECALL_0 : ", chamadoValidado);

  //   if (
  //     chamadoValidado.length >= 10 &&
  //     !chamadoValidado.startsWith("00") &&
  //     !chamadoValidado.startsWith("0800")
  //   ) {
  //     if (valorfixo.includes(parseInt(chamadoValidado[2]))) {
  //       tipochamada = definirTipoChamada(
  //         mediaid,
  //         dddValidado && parseInt(dddValidado) !== parseInt(DDD)
  //           ? "fixoInterurbano"
  //           : "fixoLocal"
  //       );
  //     } else if (valormovel.includes(parseInt(chamadoValidado[2]))) {
  //       tipochamada = definirTipoChamada(
  //         mediaid,
  //         dddValidado && parseInt(dddValidado) !== parseInt(DDD)
  //           ? "movelInterurbano"
  //           : "movelLocal"
  //       );
  //     }
  //   } else if (chamadoValidado.startsWith("0800")) {
  //     tipochamada = 8;
  //   } else if (chamadoValidado.startsWith("00")) {
  //     tipochamada = 5;
  //   }

  //   console.log("INGENIUM_ACTVECALL_1 : ", tipochamada);

  //   function buscarRota() {
  //     let rota = [];

  //     console.log("INGENIUM_ACTVECALL_1 : ", permrouter);

  //     const doisPrimeirosDigitos = chamadoValidado.substring(0, 2);

  //     // Só verifica `areacode` se `mediaid` for 1
  //     const verificarAreacode = parseInt(mediaid) === 1;

  //     // Verifica se existe pelo menos um item com areacode correspondente (somente se `mediaid` for 1)
  //     const existeAreaCode = verificarAreacode
  //       ? permrouter.some(
  //           (result) =>
  //             result.areacode &&
  //             String(result.areacode).startsWith(doisPrimeirosDigitos)
  //         )
  //       : false;

  //     permrouter.forEach((result) => {
  //       if (
  //         result.calltypeid === tipochamada &&
  //         parseInt(result.idmidia) === parseInt(mediaid) &&
  //         (!verificarAreacode ||
  //           !existeAreaCode ||
  //           (result.areacode &&
  //             String(result.areacode).startsWith(doisPrimeirosDigitos)))
  //       ) {
  //         rota.push(result);
  //       }
  //       if (result.calltypeid === 11 && !rota) {
  //         if (
  //           parseInt(chamado) >= parseInt(result.partialnumber) &&
  //           parseInt(chamado) <= parseInt(result.partialnumber_end)
  //         ) {
  //           rota.push(result);
  //         }
  //       } else if (result.calltypeid === 6 && !rota) {
  //         if (parseInt(chamado) === parseInt(result.partialnumber)) {
  //           rota.push(result);
  //         }
  //       }
  //     });

  //     if (rota && rota.length > 1) {
  //       let isExistOther = false;
  //       rota.forEach((result) => {
  //         const lastEight = String(chamado).slice(-8);
  //         if (
  //           parseInt(lastEight) >= parseInt(result.partialnumber) &&
  //           parseInt(lastEight) <= parseInt(result.partialnumber_end)
  //         ) {
  //           rota = result;
  //           isExistOther = true;
  //         }
  //       });
  //       if (!isExistOther) {
  //         rota = rota.filter((temp) => temp.isdefault === "t");
  //         rota = rota.length !== 0 ? rota[0] : [];
  //       }
  //     } else if (rota.length === 1) {
  //       rota = rota[0];
  //     }

  //     return rota;
  //   }

  //   const rotaEncontrada = buscarRota();
  //   if (rotaEncontrada.length === 0) {
  //     this.setState({ senhaincorreta: "block" });
  //     document.getElementById("div_alert").innerHTML = "Sem rota de saída!";
  //     return;
  //   }

  //   let retorno = 0;
  //   let queueData = queue.find((q) => q.caller.includes(chamado));
  //   if (queueData) {
  //     retorno = 1;
  //   }

  //   let queueid = queueData && queueData.queueid ? queueData.queueid : null;
  //   let recvcount =
  //     queueData && queueData.recvcount ? queueData.recvcount : null;
  //   let cdrid = queueData && queueData.cdrid ? queueData.cdrid : null;
  //   let srvin =
  //     queueData && queueData.serviceinid ? queueData.serviceinid : null;
  //   let caller = queueData && queueData.caller ? queueData.caller : null;
  //   let called = queueData && queueData.called ? queueData.called : null;
  //   let cbackcount =
  //     queueData && queueData.callback_count ? queueData.callback_count : null;
  //   let queueStatus =
  //     queueData && queueData.queueStatus ? queueData.queueStatus : null;
  //   let tech = rotaEncontrada.tech;
  //   let idgrupo_rota = rotaEncontrada.idgrupo_rota;
  //   let idgrupo_transb = rotaEncontrada.idgrupo_transb;
  //   let checkRota = true;

  //   if (mediaid === 5 || mediaid === 8) {
  //     chamado = chamado.trim();
  //   }

  //   console.log("INGENIUM_ACTVECALL_2 : ", chamado);

  //   if (mediaid === 1) {
  //     if (retorno === 1) {
  //       this.props.RequestActiveCallSocketVoz(
  //         outband,
  //         infouser,
  //         rotaEncontrada.idtrunk,
  //         mediaid,
  //         chamado,
  //         rotaEncontrada.addtech,
  //         rotaEncontrada.scripttrunk,
  //         rotaEncontrada.operator,
  //         true,
  //         queueid,
  //         recvcount,
  //         null,
  //         tech,
  //         idgrupo_rota,
  //         idgrupo_transb,
  //         ipcurrent,
  //         cdrid,
  //         checkRota
  //       );
  //       this.props.ReturningCallbackIn(
  //         queueid,
  //         true,
  //         recvcount,
  //         cdrid,
  //         mediaid,
  //         srvin,
  //         caller,
  //         called,
  //         cbackcount,
  //         queueStatus
  //       );
  //     } else {
  //       this.props.RequestActiveCallSocketVoz(
  //         outband,
  //         infouser,
  //         rotaEncontrada.idtrunk,
  //         mediaid,
  //         chamado,
  //         rotaEncontrada.addtech,
  //         rotaEncontrada.scripttrunk,
  //         rotaEncontrada.operator,
  //         false,
  //         queueid,
  //         recvcount,
  //         null,
  //         tech,
  //         idgrupo_rota,
  //         idgrupo_transb,
  //         ipcurrent,
  //         cdrid,
  //         checkRota
  //       );
  //       this.props.ReturningCallbackIn(
  //         queueid,
  //         true,
  //         recvcount,
  //         cdrid,
  //         mediaid,
  //         srvin,
  //         caller,
  //         called,
  //         cbackcount,
  //         queueStatus
  //       );
  //     }
  //   } else {
  //     if (retorno === 1) {
  //       this.props.RequestActiveCall(
  //         outband,
  //         infouser,
  //         rotaEncontrada.idtrunk,
  //         mediaid,
  //         chamado,
  //         rotaEncontrada.addtech,
  //         rotaEncontrada.scripttrunk,
  //         rotaEncontrada.operator,
  //         true,
  //         queueid,
  //         recvcount,
  //         cbackcount,
  //         idgrupo_transb,
  //         cdrid
  //       );
  //       this.props.ReturningCallbackIn(
  //         queueid,
  //         true,
  //         recvcount,
  //         cdrid,
  //         mediaid,
  //         srvin,
  //         caller,
  //         called,
  //         cbackcount,
  //         queueStatus
  //       );
  //     } else {
  //       this.props.RequestActiveCall(
  //         outband,
  //         infouser,
  //         rotaEncontrada.idtrunk,
  //         mediaid,
  //         chamado,
  //         rotaEncontrada.addtech,
  //         rotaEncontrada.scripttrunk,
  //         rotaEncontrada.operator,
  //         false,
  //         queueid,
  //         recvcount,
  //         cbackcount,
  //         idgrupo_transb
  //       );
  //     }
  //   }

  //   this.props.ShowInfoDisplay("Clientes");
  // }

  SolicitarChamadaAtiva(
    e,
    permrouter,
    mediaid,
    outband,
    infouser,
    callStatus,
    queue,
    number,
    AtdSimult,
    ipcurrent,
    statusAgent,
  ) {
    try {
      document.getElementById("div_alert").innerHTML = "";

      if (this.props.ContactId.length !== 0) {
        localStorage.setItem(
          "current-service",
          this.props.ContactId.idatendimento,
        );
      }

      if (!statusAgent.allowCall) {
        this.props.InterationNotifier("Pausa não permite ativo", "permission");
        return true;
      }

      const chatMessage = document.getElementById("chat-message");
      if (chatMessage) chatMessage.innerText = "";

      if (!permrouter || permrouter.length === 0) return;

      let chamado = number.replace(/\D/g, "");
      const rawNumber = chamado;
      let tipochamada = 0;
      let DDD = permrouter[0].areacodeid || "71";

      const valorfixo = [1, 2, 3, 4],
        valormovel = [5, 6, 7, 8, 9];
      const removeDigits =
        connection_platform.remove_digits ||
        (parseInt(mediaid) !== 1 && parseInt(mediaid) !== 16);

      if (
        removeDigits &&
        chamado.startsWith("0") &&
        !chamado.startsWith("00") &&
        !chamado.startsWith("0800")
      ) {
        chamado = chamado.substring(1);
      }

      function definirTipoChamada(mediaid, tipo) {
        const tipos = {
          fixoInterurbano: [3, 17, 19, 18, 20, 21, 23, 22, 24, 25],
          movelInterurbano: [4, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
          fixoLocal: [1, 17, 19, 18, 20, 21, 23, 22, 24, 25],
          movelLocal: [2, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
        };

        // Converte mediaid para inteiro
        const midiaConvertida = parseInt(mediaid, 10);

        // Se mediaid for 1, busca no objeto `tipos`, senão segue a lógica específica
        if (midiaConvertida === 1) {
          return tipos[tipo] ? tipos[tipo][midiaConvertida - 1] || 0 : 0;
        } else {
          const mapeamentoMidia = {
            2: 24,
            3: 22,
            4: 18,
            5: 17,
            6: 20,
            8: 19,
            9: 21,
            10: 23,
            12: 13,
            15: 26,
            16: 27,
          };

          return mapeamentoMidia[midiaConvertida] || midiaConvertida;
        }
      }

      if (
        (chamado.length >= 10 ||
          chamado.length === 8 ||
          chamado.length === 9) &&
        !chamado.startsWith("00")
      ) {
        if (
          chamado.startsWith("55") &&
          (mediaid === 5 ||
            mediaid === "5" ||
            mediaid === 16 ||
            mediaid === "16") &&
          chamado.length > 11
        )
          chamado = chamado.substr(2);
        if (chamado.length === 8 || chamado.length === 9)
          chamado = DDD + chamado;
      }

      let chamadoValidado = chamado.replace(/^0(?!0|800|300)/, "");
      console.log("INGENIUM_ACTVECALL_0 : ", chamado);

      let dddValidado =
        chamadoValidado.length >= 10 ? chamadoValidado.substr(0, 2) : "";

      console.log("INGENIUM_ACTVECALL_0 : ", chamadoValidado);

      if (
        chamadoValidado.length >= 10 &&
        !chamadoValidado.startsWith("00") &&
        !chamadoValidado.startsWith("0800")
      ) {
        if (valorfixo.includes(parseInt(chamadoValidado[2]))) {
          tipochamada = definirTipoChamada(
            mediaid,
            dddValidado && parseInt(dddValidado) !== parseInt(DDD)
              ? "fixoInterurbano"
              : "fixoLocal",
          );
        } else if (valormovel.includes(parseInt(chamadoValidado[2]))) {
          tipochamada = definirTipoChamada(
            mediaid,
            dddValidado && parseInt(dddValidado) !== parseInt(DDD)
              ? "movelInterurbano"
              : "movelLocal",
          );
        }
      } else if (chamadoValidado.startsWith("0800")) {
        tipochamada = 8;
      } else if (chamadoValidado.startsWith("00")) {
        tipochamada = 5;
      } else {
      }

      console.log("INGENIUM_ACTVECALL_1 : ", tipochamada);

      function buscarRota() {
        let rota = [];

        console.log("INGENIUM_ACTVECALL_1 : ", permrouter);

        const doisPrimeirosDigitos = chamadoValidado.substring(0, 2);

        // Só verifica `areacode` se `mediaid` for 1
        const verificarAreacode = parseInt(mediaid) === 1;
        const verificarWhatsappInternacional = parseInt(mediaid) === 5;

        // Verifica se existe pelo menos um item com areacode correspondente (somente se `mediaid` for 1)
        const existeAreaCode = verificarAreacode
          ? permrouter.some(
              (result) =>
                result.areacode &&
                String(result.areacode).startsWith(doisPrimeirosDigitos),
            )
          : false;

        permrouter.forEach((result) => {
          if (
            result.calltypeid === tipochamada &&
            parseInt(result.idmidia) === parseInt(mediaid) &&
            (!verificarAreacode ||
              !existeAreaCode ||
              (result.areacode &&
                String(result.areacode).startsWith(doisPrimeirosDigitos)))
          ) {
            rota.push(result);
          }
          if (result.calltypeid === 11 && rota.length === 0) {
            if (
              parseInt(chamado) >= parseInt(result.partialnumber) &&
              parseInt(chamado) <= parseInt(result.partialnumber_end)
            ) {
              rota.push(result);
            }
          } else if (result.calltypeid === 6 && rota.length === 0) {
            if (parseInt(chamado) === parseInt(result.partialnumber)) {
              rota.push(result);
            }
          } else if (
            tipochamada === 5 &&
            mediaid === 5 &&
            result.calltypeid === 17
          ) {
            rota.push(result);
            chamado = chamado.replace(/^00/, "");
          }
        });

        console.log("INGENIUM_ACTVECALL_1222222 : ", rota);

        if (rota && rota.length > 1) {
          let isExistOther = false;
          rota.forEach((result) => {
            const lastEight = String(chamado).slice(-8);
            if (
              parseInt(lastEight) >= parseInt(result.partialnumber) &&
              parseInt(lastEight) <= parseInt(result.partialnumber_end)
            ) {
              rota = result;
              isExistOther = true;
            }
          });
          if (!isExistOther) {
            rota = rota.filter((temp) => temp.isdefault === "t");
            rota = rota.length !== 0 ? rota[0] : [];
          }
        } else if (rota.length === 1) {
          rota = rota[0];
        }

        return rota;
      }

      const rotaEncontrada = buscarRota();

      console.log("INGENIUMACTIVECALL", rotaEncontrada);

      if (rotaEncontrada.length === 0) {
        this.setState({ senhaincorreta: "block" });
        document.getElementById("div_alert").innerHTML = "Sem rota de saída!";
        return;
      }

      let retorno = 0;
      // let queueData = queue.find(q => q.caller.includes(chamado));
      let queueData = queue.find(
        (q) => q.caller.includes(chamado) && q.mediaid === mediaid,
      );
      if (queueData) {
        retorno = 1;
      }

      let queueid = queueData && queueData.queueid ? queueData.queueid : null;
      let recvcount =
        queueData && queueData.recvcount ? queueData.recvcount : null;
      let cdrid = queueData && queueData.cdrid ? queueData.cdrid : null;
      let srvin =
        queueData && queueData.serviceinid ? queueData.serviceinid : null;
      let caller = queueData && queueData.caller ? queueData.caller : null;
      let called = queueData && queueData.called ? queueData.called : null;
      let cbackcount =
        queueData && queueData.callback_count ? queueData.callback_count : null;
      let queueStatus =
        queueData && queueData.queueStatus ? queueData.queueStatus : null;
      let tech = rotaEncontrada.tech;
      let idgrupo_rota = rotaEncontrada.idgrupo_rota;
      let idgrupo_transb = rotaEncontrada.idgrupo_transb;
      let checkRota = true;

      if (mediaid === 5 || mediaid === 8 || parseInt(mediaid) === 16) {
        chamado = chamado.trim();
      }

      if (parseInt(mediaid) === 1 || parseInt(mediaid) === 16) {
        if (retorno === 1) {
          this.props.RequestActiveCallSocketVoz(
            outband,
            infouser,
            rotaEncontrada.idtrunk,
            mediaid,
            chamado,
            rotaEncontrada.addtech,
            rotaEncontrada.scripttrunk,
            rotaEncontrada.operator,
            true,
            queueid,
            recvcount,
            null,
            tech,
            idgrupo_rota,
            idgrupo_transb,
            ipcurrent,
            cdrid,
            checkRota,
          );
          this.props.ReturningCallbackIn(
            queueid,
            true,
            recvcount,
            cdrid,
            mediaid,
            srvin,
            caller,
            called,
            cbackcount,
            queueStatus,
          );
        } else {
          this.props.RequestActiveCallSocketVoz(
            outband,
            infouser,
            rotaEncontrada.idtrunk,
            mediaid,
            chamado,
            rotaEncontrada.addtech,
            rotaEncontrada.scripttrunk,
            rotaEncontrada.operator,
            false,
            queueid,
            recvcount,
            null,
            tech,
            idgrupo_rota,
            idgrupo_transb,
            ipcurrent,
            cdrid,
            checkRota,
          );
          this.props.ReturningCallbackIn(
            queueid,
            true,
            recvcount,
            cdrid,
            mediaid,
            srvin,
            caller,
            called,
            cbackcount,
            queueStatus,
          );
        }
      } else {
        if (retorno === 1) {
          this.props.RequestActiveCall(
            outband,
            infouser,
            rotaEncontrada.idtrunk,
            mediaid,
            chamado,
            rotaEncontrada.addtech,
            rotaEncontrada.scripttrunk,
            rotaEncontrada.operator,
            true,
            queueid,
            recvcount,
            cbackcount,
            idgrupo_transb,
            cdrid,
            rawNumber,
          );
          this.props.ReturningCallbackIn(
            queueid,
            true,
            recvcount,
            cdrid,
            mediaid,
            srvin,
            caller,
            called,
            cbackcount,
            queueStatus,
          );
        } else {
          this.props.RequestActiveCall(
            outband,
            infouser,
            rotaEncontrada.idtrunk,
            mediaid,
            chamado,
            rotaEncontrada.addtech,
            rotaEncontrada.scripttrunk,
            rotaEncontrada.operator,
            false,
            queueid,
            recvcount,
            cbackcount,
            idgrupo_transb,
            undefined,
            rawNumber,
          );
        }
      }

      this.props.ShowInfoDisplay("Clientes");
      // this.props.ShowActiveCallIn("");
      // MicroModal.close("modal__falar-com-cliente");
      // this.numberToActive.value = "";
    } catch (error) {}
  }
  GetCargoAndRelacao(contact) {
    const hasContact = Boolean(contact);
    if (!hasContact) {
      this.setState({
        cargoSelecionado: undefined,
        relacaoSelecionada: undefined,
      });
      return;
    }
    const hasCargo = Boolean(contact.id_cargo) || contact.id_cargo === 0;
    const cargo = hasCargo
      ? {
          id: contact.id_cargo,
          label: contact.desc_cargo,
          value: contact.id_cargo,
        }
      : undefined;
    const hasRelacao = Boolean(contact.id_relacao) || contact.id_relacao === 0;
    const relacao = hasRelacao
      ? {
          id: contact.id_relacao,
          label: contact.desc_relacao,
          value: contact.id_relacao,
        }
      : undefined;
    this.setState({
      cargoSelecionado: cargo,
      relacaoSelecionada: relacao,
    });
  }

  cleanResponsavelPor() {
    this.setState({
      responsavelPor: [],
      responsavelPorInDb: [],
    });
  }

  getResponsavelPor(contact) {
    const hasContact = Boolean(contact);
    if (!hasContact) {
      this.cleanResponsavelPor();
      return;
    }
    // const hasResponsavelPor = Boolean(contact.id_responsavel_por) || contact.id_responsavel_por === 0;
    // if(!hasResponsavelPor) {
    //   this.cleanResponsavelPor();
    //   return
    // }
    // this.setState({
    //     responsavelPor: []
    // })
  }

  GetCargoAndRelacaoType2(contact) {
    const hasContact = Boolean(contact);
    if (!hasContact) {
      this.setState({
        cargoSelecionado: undefined,
        relacaoSelecionada: undefined,
      });
      return;
    }
    const hasCargo = Boolean(contact.position_id) || contact.position_id === 0;
    const cargo = hasCargo
      ? {
          id: contact.position_id,
          label: contact.position_description,
          value: contact.position_id,
        }
      : undefined;
    const hasRelacao =
      Boolean(contact.relation_id) || contact.relation_id === 0;
    const relacao = hasRelacao
      ? {
          id: contact.relation_id,
          label: contact.relation_description,
          value: contact.relation_id,
        }
      : undefined;
    this.setState({
      cargoSelecionado: cargo,
      relacaoSelecionada: relacao,
    });
  }
  ShowModal(e, modal, contact, edit, number, router) {
    document.getElementById("simulation_click").click();
    switch (modal) {
      case "modal__agenda-pf-usuario-detalhes":
        // var mensagem_tratada = contact.displayname.replace(/¿/gi, "\n");
        // mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
        // var valor = 1
        // try{
        // mensagem_tratada = '{"'+valor+'": [{"mensagem_tratada":"'+mensagem_tratada+'"}]}';
        // var obj = JSON.parse(mensagem_tratada);
        // mensagem_tratada = obj[1][0].mensagem_tratada
        // } catch(e){
        //     mensagem_tratada = contact.displayname;
        // }

        var mensagem_tratada = createJSON(contact.displayname);
        this.setState({ person: mensagem_tratada });
        this.setState({ numberC: contact.number, pathfile: contact.pathfile });
        setTimeout(() => {
          MicroModal.close("modal__agenda");
          MicroModal.show("modal__agenda-pf-usuario-detalhes");
        }, 300);
        this.props.ShowModalsMenu(modal);
        // var mensagem_tratada = contact.name.replace(/¿/gi, "\n");
        // mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
        // var valor = 1
        // try{
        // mensagem_tratada = '{"'+valor+'": [{"mensagem_tratada":"'+mensagem_tratada+'"}]}';
        // var obj = JSON.parse(mensagem_tratada);
        // mensagem_tratada = obj[1][0].mensagem_tratada
        // } catch(e){
        //     mensagem_tratada = contact.name;
        // }
        this.GetCargoAndRelacao(contact);
        this.getResponsavelPor(contact);
        var mensagem_tratada = createJSON(contact.name);
        this.name.value = mensagem_tratada;
        this.checkValues(contact);
        var value = [{ value: contact.user_create, label: contact.username }];
        this.setState({ contatode: value });
        if (contact.idempresa) {
          var value = [{ value: contact.idempresa, label: contact.empresa }];
          this.setState({ empresaC: value, auxEmpresa: contact.idempresa });
        } else {
          this.setState({ empresaC: null });
          this.setState({ auxEmpresa: "" });
        }
        this.setState({ contactid: contact.id });
        this.setState({ private: contact.userid });

        if (contact.userid !== null && contact.userid !== "") {
          document.getElementById(
            "modal__content__form__group__radios__option--sim",
          ).checked = true;
        } else {
          document.getElementById(
            "modal__content__form__group__radios__option--nao",
          ).checked = true;
        }

        if (edit) {
          this.setState({ disabled: true });
        } else {
          this.setState({ disabled: false, module: "edit" });
        }
        this.props.GetNumbersContact(contact.id);
        this.ObterListaResponsaveisPor(contact.id);
        break;
      case "modal__agenda-pf-usuario-detalhes-mais-campos":
        MicroModal.close("modal__agenda");
        MicroModal.close("modal__agenda-pf-usuario-detalhes");
        MicroModal.show("modal__agenda-pf-usuario-detalhes-mais-campos");
        //colocar o id do usuario para o contatode
        break;
      case "modal__agenda-pf__cliente__interacoes":
        this.props.ShowModalsMenu(modal);
        let now = Moment().subtract(7, "days");
        const datainit = now.format("YYYY-MM-DD") + "T00:00";
        const datafim = Moment().format("YYYY-MM-DD") + "T23:59";
        // let datainit = this.dataInit.value;
        // let datafim = this.dataFim.value;
        setTimeout(() => {
          // MicroModal.close("modal__agenda");
          MicroModal.show("modal__historico-atendimento-details");
        }, 300);

        var verifyddd = "";
        if (router) {
          verifyddd = router[0].areacodeid;
        }
        number =
          parseInt(number.substr(0, 2)) === parseInt(verifyddd)
            ? number.substr(2, 12)
            : number;
        //Função que seta o nome e o número do contato pro modal de interações
        this.props.GetInteractionsModal(
          contact.displayname,
          number,
          contact.id,
        );
        //
        let idgroup = this.props.InfoUsers.idgroup;
        this.props.InteracoesContactNumber(
          number,
          datainit,
          datafim,
          this.state.mensagem,
          idgroup,
          contact.id,
        );
        var mensagem_tratada = createJSON(contact.displayname);
        this.setState({
          person: mensagem_tratada,
          numberinteract: number,
          cliente: mensagem_tratada,
          clientpdf: contact.number,
        });
        this.setState({ interactcontact: contact });
        this.setState({ numberC: contact.number, pathfile: contact.pathfile });
        break;
      case "modal_contato_salvo":
        this.props.ShowModalsMenu(modal);
        MicroModal.close("modal__agenda-pj-empresa-detalhes-editar-salvo");
        MicroModal.show("modal__agenda");
        break;
      case "modal_contato_salvo-company":
        this.props.ShowModalsMenu(modal);
        MicroModal.close(
          "modal__agenda-pj-empresa-detalhes-editar-salvo-company",
        );
        MicroModal.show("modal__agenda");
        break;
      case "modal__agenda-pj-empresa-detalhes":
        let company = contact;
        this.props.ShowModalsMenu(modal);
        MicroModal.close("modal__agenda");
        MicroModal.show("modal__agenda-pj-empresa-detalhes-editar");
        this.business.value = company.name;
        this.inscricaoestadual.value = company.inscricaomunicipal;
        if (company.inscricaoestadual) {
          this.inscricaoestadual.value = company.inscricaoestadual;
        } else {
          this.inscricaoestadual.value = "";
        }
        if (company.inscricaomunicipal) {
          this.estadualmunicipal.value = company.inscricaomunicipal;
        } else {
          this.estadualmunicipal.value = "";
        }
        if (company.cnpj) {
          this.cnpjinsert.value = company.cnpj;
        } else {
          this.cnpjinsert.value = "";
        }
        if (company.site) {
          this.site.value = company.site;
        } else {
          this.site.value = "";
        }
        if (company.email) {
          this.emailcompany.value = company.email;
        } else {
          this.emailcompany.value = "";
        }
        if (company.externcode || company.externcode === 0) {
          this.setState({
            externalCodeCompanyInCompanyPage: company.externcode,
          });
        } else {
          this.setState({ externalCodeCompanyInCompanyPage: "" });
        }
        this.setState({ disabledcompany: true, companyid: company.id });
        break;
      default:
        break;
    }
  }

  ShowContactDisplay(e, contact) {
    let edit = true;
    this.GetCargoAndRelacao(contact);
    this.getResponsavelPor(contact);

    // var mensagem_tratada = contact.displayname.replace(/¿/gi, "\n");
    // mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    // var valor = 1
    // try{
    // mensagem_tratada = '{"'+valor+'": [{"mensagem_tratada":"'+mensagem_tratada+'"}]}';
    // var obj = JSON.parse(mensagem_tratada);
    // mensagem_tratada = obj[1][0].mensagem_tratada
    // } catch(e){
    //     mensagem_tratada = contact.displayname;
    // }
    var mensagem_tratada = createJSON(contact.displayname);
    this.setState({ person: mensagem_tratada });
    this.setState({ numberC: contact.number, cliente: mensagem_tratada });
    MicroModal.close("modal__agenda-pf__cliente__interacoes");
    MicroModal.show("modal__agenda-pf-usuario-detalhes");
    this.props.ShowModalsMenu("modal_interacoes_contato");
    // var mensagem_tratada = contact.name.replace(/¿/gi, "\n");
    // mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    // var valor = 1
    // try{
    // mensagem_tratada = '{"'+valor+'": [{"mensagem_tratada":"'+mensagem_tratada+'"}]}';
    // var obj = JSON.parse(mensagem_tratada);
    // mensagem_tratada = obj[1][0].mensagem_tratada
    // } catch(e){
    //     mensagem_tratada = contact.name;
    // }
    var mensagem_tratada = createJSON(contact.name);
    this.name.value = mensagem_tratada;
    this.checkValues(contact);
    var value = [{ value: contact.user_create, label: contact.username }];
    this.setState({ contatode: value });

    if (contact.idempresa) {
      var value = [
        {
          value: contact.idempresa,
          label: contact.empresa,
          cnpj: contact.cnpj_empresa,
          externcode: contact.codigo_ext_empresa,
        },
      ];
      this.setState({ empresaC: value, auxEmpresa: contact.idempresa });
    } else {
      this.setState({ empresaC: null });
      this.setState({ auxEmpresa: "" });
    }
    this.setState({ contactid: contact.id });
    this.setState({ private: contact.userid });
    if (edit) {
      this.setState({ disabled: true });
    } else {
      this.setState({ disabled: false });
    }
    this.props.GetNumbersContact(contact.id);
    this.ObterListaResponsaveisPor(contact.id);
  }

  ShowModalAddContact(iduser, displayname, detailscontacts) {
    if (detailscontacts) {
      this.props.GetDetailsContacts(true, "", "");
    } else {
      MicroModal.close("modal__agenda");
    }
    this.props.AddNumberContact();
    this.props.ClearNumbersContact();
    MicroModal.show("modal__agenda-pf-usuario-detalhes");
    this.props.ShowModalsMenu("modal__agenda-pf-usuario-detalhess");
    this.clearValues(iduser, displayname);
  }

  ShowModalAddCompany(iduser, displayname) {
    MicroModal.close("modal__agenda");
    this.setState({ disabledcompany: false });
    this.clearValuesCompany(iduser, displayname);
    MicroModal.show("modal__agenda-pj-empresa-detalhes-editar");
    this.props.ShowModalsMenu("modal__agenda-pj-empresa-detalhes-editar");
  }

  deleteContact(contact, iduser) {
    this.props.DelContact(contact.id, iduser);
  }

  deleteCompany(company, iduser) {
    this.props.DelCompany(company.id, iduser);
  }

  SelectContato(e) {
    if (e != null) {
      var value = [{ value: e.value, label: e.label }];
      this.setState({ contatode: value });
    } else {
      this.setState({ empresaC: "" });
    }
  }

  SelectEmpresa(e) {
    if (e != null) {
      var value = [{ value: e.value, label: e.label }];
      this.setState({ empresaC: value });
    } else {
      this.setState({ empresaC: "" });
    }
  }

  SearchHistoryContact() {
    let histstart = this.datahistoryinitcontact.value;
    let histend = this.datahistoryfimcontact.value;
    let idgroup = this.props.InfoUsers.idgroup;
    this.props.SearchingHistory(histstart, histend, 33, numeroCliente, idgroup);
  }

  SearchInHistoryContact(e) {
    e.preventDefault();
    this.setState({ showHistory: !this.state.showHistory });
  }

  async getInformationsOfEnterprise(enterpriseId, retries = 7, delay = 1000) {
    let enterpriseInformation = null;

    let attempt = 0;
    while (attempt < retries) {
      const data = await getCompanyInfo(enterpriseId);
      const isDataArray = Array.isArray(data);
      if (isDataArray) {
        enterpriseInformation = data.length > 0 ? data[0] : null;
        break;
      }
      await new Promise((resolve) => setTimeout(resolve, delay));
      attempt++;
    }

    return enterpriseInformation;
  }

  formatChannelToSendToIngDesk(numberscontact) {
    let canais = [];
    const hasNumberscontact =
      Array.isArray(numberscontact) && numberscontact.length > 0;
    if (hasNumberscontact) {
      canais = numberscontact
        .map((number) => {
          const idsOfVoiceAndWhatsapp = [1, "1", 5, "5"];
          const isWhhatsappOrVoice = idsOfVoiceAndWhatsapp.includes(
            number.midiaid,
          );
          const isToRemoveFirstToDigits =
            isWhhatsappOrVoice &&
            typeof number.number === "string" &&
            (number.number.length === 13 || number.number.length === 12);
          if (isToRemoveFirstToDigits) {
            return {
              telephone: number.number.slice(2),
              type_telephone: 1,
              id_canal: parseInt(number.midiaid) || 1,
            };
          }
          return {
            telephone: number.number,
            type_telephone: 1,
            id_canal: parseInt(number.midiaid) || 1,
          };
        })
        .filter((phone) => {
          const typesToAllow = [1, "1", 5, "5", 3, "3"];
          return typesToAllow.includes(phone.type_telephone);
        });
    }

    return canais;
  }

  obterLoginDoResponsavel(contatode, allUsers) {
    try {
      if (
        !Array.isArray(allUsers) ||
        !(Array.isArray(contatode) && contatode.length > 0)
      )
        return undefined;
      const userFinded = allUsers.find((userInfo) => {
        return `${userInfo.iduser}` === `${contatode[0].value}`;
      });
      if (!Boolean(userFinded)) return undefined;
      return userFinded.username;
    } catch (error) {
      return undefined;
    }
  }

  async formatContactToSendToIngDesk(data) {
    const {
      name,
      displayname,
      cpf,
      rg,
      cep,
      endereco,
      numero,
      district,
      codigoexterno,
      numberscontact,
      contatode,
      allUsers,
    } = data;

    const nomeCompletoIngDesk = name;
    const nomeDeApresentacaoIngDesk = displayname;
    let canais = this.formatChannelToSendToIngDesk(numberscontact);
    const hasName = Boolean(nomeCompletoIngDesk);
    if (!hasName) return null;
    const hasCanais = Array.isArray(canais) && canais.length > 0;
    if (!hasCanais) return null;

    const dataToSendToIngDesk = {
      contact: {
        name: nomeCompletoIngDesk,
        displayname: nomeDeApresentacaoIngDesk,
      },
    };

    //verifica se tem cargo
    const hasCargo = Boolean(this.state.cargoSelecionado);
    if (hasCargo) {
      const cargo = this.state.cargoSelecionado.label;
      dataToSendToIngDesk.contact.cargo = cargo;
    }
    //verifica se tem responsável
    const loginuser = this.obterLoginDoResponsavel(contatode, allUsers);
    const hasLoginuser = Boolean(loginuser);
    if (hasLoginuser) {
      dataToSendToIngDesk.contact.loginuser = loginuser;
    }
    //verifica se tem relação
    const hasRelacao = Boolean(this.state.relacaoSelecionada);
    if (hasRelacao) {
      const relacao = this.state.relacaoSelecionada.label;
      dataToSendToIngDesk.contact.relacao = relacao;
    }
    //verifica se tem cpf cadastrado
    const hasCpf =
      Boolean(cpf) &&
      typeof cpf === "string" &&
      Boolean(cpf.replaceAll(".", "").replaceAll("-", "").trim());
    if (hasCpf) {
      dataToSendToIngDesk.contact.cpf = cpf
        .replaceAll(".", "")
        .replaceAll("-", "")
        .trim();
    }
    //verifica se tem rg
    const hasRg =
      Boolean(rg) &&
      typeof rg === "string" &&
      Boolean(rg.replaceAll(".", "").replaceAll("-", "").trim());
    if (hasRg) {
      dataToSendToIngDesk.contact.rg = rg
        .replaceAll(".", "")
        .replaceAll("-", "")
        .trim();
    }
    //verifica se tem cep
    const hasCep =
      Boolean(cep) &&
      typeof cep === "string" &&
      Boolean(cep.replaceAll("-", "").trim());
    if (hasCep) {
      dataToSendToIngDesk.contact.cep = cep.replaceAll("-", "").trim();
    }
    //verifica se tem endereço
    const hasEndereco =
      Boolean(endereco) &&
      typeof endereco === "string" &&
      Boolean(endereco.trim());
    if (hasEndereco) {
      dataToSendToIngDesk.contact.address = endereco.trim();
    }
    //verifica se tem o número do endereço
    const hasNumero =
      Boolean(numero) && typeof numero === "string" && Boolean(numero.trim());
    if (hasNumero) {
      dataToSendToIngDesk.contact.number = numero.trim();
    }
    //verifica se tem e-mail
    const hasEmail =
      Array.isArray(canais) &&
      canais.some(
        (canal) => canal.type_telephone === 3 || canal.type_telephone === "3",
      );
    if (hasEmail) {
      const email = canais.filter(
        (canal) => canal.type_telephone === 3 || canal.type_telephone === "3",
      )[0].telephone;
      dataToSendToIngDesk.contact.email = email;
    }
    //verifica se tem distrito
    const hasDistrict =
      Boolean(district) &&
      typeof district === "string" &&
      Boolean(district.trim());
    if (hasDistrict) {
      dataToSendToIngDesk.contact.district = district.trim();
    }
    //verifica se tem o código externo do contato
    const hasCodigoExterno =
      Boolean(codigoexterno) &&
      typeof codigoexterno === "string" &&
      Boolean(codigoexterno.trim());
    if (hasCodigoExterno) {
      dataToSendToIngDesk.contact.externcode = codigoexterno.trim();
    }
    //verifica se tem telefones
    const telefones = canais
      .filter((canal) => {
        const allowedMidias = [1, "1", 5, "5"];
        return allowedMidias.includes(canal.type_telephone);
      })
      .map((canal) => {
        canal.type_telephone = 1;
        return canal;
      });
    const hasTelefones = telefones.length > 0;
    if (hasTelefones) {
      dataToSendToIngDesk.contact.phones = telefones;
    }
    //verifica se tem empresaC
    const hasEmpresaC =
      Array.isArray(this.state.empresaC) && this.state.empresaC.length > 0;
    if (!hasEmpresaC) return dataToSendToIngDesk;
    //verifica se tem nome da empresa
    const enterpriseName =
      typeof this.state.empresaC[0] === "object" &&
      this.state.empresaC[0].label;
    const hasEnterpriseName = Boolean(enterpriseName);
    if (!hasEnterpriseName) return dataToSendToIngDesk;
    //verifica se tem id da empresa
    const enterpriseId =
      typeof this.state.empresaC[0] === "object" &&
      this.state.empresaC[0].value;
    const hasEnterpriseId = Boolean(enterpriseId) || enterpriseId === 0;
    if (!hasEnterpriseId) return dataToSendToIngDesk;
    dataToSendToIngDesk.contact.id_empresa = enterpriseId;
    //verifica se tem as informações da empresa
    const enterpriseInfos =
      await this.getInformationsOfEnterprise(enterpriseId);
    const hasEnterpriseInfos = Boolean(enterpriseInfos);
    if (!hasEnterpriseInfos) return dataToSendToIngDesk;
    //verifica se tem cnpj ou código externo
    const hasCnpjOrExternalCode =
      enterpriseInfos.cnpj || Boolean(enterpriseInfos.externcode);
    if (!hasCnpjOrExternalCode) return dataToSendToIngDesk;
    dataToSendToIngDesk.enterprise = {
      nome: enterpriseName,
    };
    //verifica se tem cnpj
    const hasCnpj = Boolean(enterpriseInfos.cnpj);
    if (hasCnpj) {
      dataToSendToIngDesk.enterprise.cnpj = enterpriseInfos.cnpj;
    }
    //verifica se tem email da empresa
    const hasEnterpriseEmail = Boolean(enterpriseInfos.email);
    if (hasEnterpriseEmail) {
      dataToSendToIngDesk.enterprise.email = enterpriseInfos.email;
    }
    //verifica se tem o site da empresa
    const hasEnterpriseSite = Boolean(enterpriseInfos.site);
    if (hasEnterpriseSite) {
      dataToSendToIngDesk.enterprise.site = enterpriseInfos.site;
    }
    //verifica se tem inscrição estadual
    const hasInscricaoEstadual = Boolean(enterpriseInfos.inscricaoestadual);
    if (hasInscricaoEstadual) {
      dataToSendToIngDesk.enterprise.inscricaoestadual =
        enterpriseInfos.inscricaoestadual;
    }
    //verifica se tem inscrição municipal
    const hasInscricaoMunicipal = Boolean(enterpriseInfos.inscricaomunicipal);
    if (hasInscricaoMunicipal) {
      dataToSendToIngDesk.enterprise.inscricaomunicipal =
        enterpriseInfos.inscricaomunicipal;
    }
    //verifica o código da empresa
    const hasEnterpriseExternalCode = Boolean(enterpriseInfos.externcode);
    if (hasEnterpriseExternalCode) {
      dataToSendToIngDesk.enterprise.codigo_empresa =
        enterpriseInfos.externcode;
    }

    return dataToSendToIngDesk;
  }

  showToastError(errorText) {
    try {
      toast.dismiss();
      toast.error(errorText, {
        autoClose: 2000,
        pauseOnHover: true,
        closeOnClick: true,
      });
    } catch (error) {
      toast.error(errorText, {
        autoClose: 2000,
        pauseOnHover: true,
        closeOnClick: true,
      });
    }
  }

  verifyIfHasValidContacts(numberscontact) {
    const hasNumbersContact =
      Array.isArray(numberscontact) && numberscontact.length > 0;
    if (!hasNumbersContact) {
      this.showToastError("Adicione pelo menos um Canal!");
      return false;
    }
    const hasEmptyNumbers =
      Boolean(numberscontact) &&
      Array.isArray(numberscontact) &&
      numberscontact.some((numberContact) => !Boolean(numberContact.number));
    if (hasEmptyNumbers) {
      this.showToastError("Todos os canais adicionados devem ser preenchidos");
      return false;
    }

    return true;
  }

  getCompanyData(empresa) {
    let empresaNaAgenda = "";
    let idEmpresa = null;
    let cnpjEmpresa = null;
    let codigoEmpresa = null;
    if (Array.isArray(empresa) && empresa.length > 0) {
      empresaNaAgenda = empresa[0].label;
      idEmpresa = empresa[0].value;
      cnpjEmpresa = empresa[0].cnpj;
      codigoEmpresa = empresa[0].externcode;
    }
    return { empresaNaAgenda, idEmpresa, cnpjEmpresa, codigoEmpresa };
  }

  updateDataOfHistoric(empresa, name) {
    const dataToUpdate = this.props.HistoryCalls.map((item) => {
      const rowData = this.state.historicData;
      const tellOfThisCall =
        rowData.iddirection === 2 ? rowData.called : rowData.caller;
      const telOfItem = item.iddirection === 2 ? item.called : item.caller;
      if (telOfItem === tellOfThisCall) {
        const { empresaNaAgenda, idEmpresa, cnpjEmpresa, codigoEmpresa } =
          this.getCompanyData(empresa);

        return {
          ...item,
          companyname: empresaNaAgenda,
          companycnpj: cnpjEmpresa,
          companyexterncode: codigoEmpresa,
          contactname: name,
        };
      }
      return item;
    });

    this.props.DispatchGetHistoryCalls(dataToUpdate);
    this.setState({ historicData: null });
    this.ExitModal({}, "modal__agenda-pf-usuario-detalhes");
  }

  // async InsertContactsResponsibleCompany(contactId, userId) {
  //   const companysToAdd = this.state.responsavelPor.filter(
  //     (company) =>
  //       !this.state.responsavelPorInDb.some(
  //         (companyInDb) => companyInDb.id === company.id,
  //       ),
  //   );
  //   if (companysToAdd.length === 0) return;
  //   const limit = promiseLimit(50);
  //   await Promise.all(
  //     companysToAdd.map((company) =>
  //       limit(insertContactResponsibleCompany, contactId, company.id, userId),
  //     ),
  //   );
  // }

  addItemsToResponsavelPorInDb(data) {
    this.setState((prevState) => ({
      responsavelPorInDb: [...prevState.responsavelPorInDb, data],
    }));
  }

  removeItemsToResponsavelPorInDb(data) {
    this.setState((prevState) => ({
      responsavelPorInDb: prevState.responsavelPorInDb.filter(
        (datum) => datum.id !== data.id,
      ),
    }));
  }

  async updateContactV2(
    contactid,
    numberscontact,
    iduser,
    detailscontact,
    allUsers,
    event,
  ) {
    this.VerifyLoadingOfResponsavelPor();
    //VIM AQ
    const hasNumbersContact = this.verifyIfHasValidContacts(numberscontact);
    if (!hasNumbersContact) return;
    this.setState({ isLoadingSavingAlterations: true });
    event.preventDefault();
    var oDivAlerta1 = document.getElementById("msg_erro1");
    var oDivAlerta2 = document.getElementById("msg_erro2");
    var oDivAlerta3 = document.getElementById("msg_erro3");
    let novosErros = {
      nome: false,
      contato: false,
      displayName: false,
      empresa: false,
    };
    var erro = 0;
    var displayname = this.displayname.value;
    var name = this.name.value;
    // var email = this.email.value;
    var contatode = this.state.contatode;
    var codigoexterno = this.codigoexterno.value;
    var particular = this.state.private;
    var nascimento = this.nascimento.value;
    var rg = this.rg.value;
    var cpf = this.cpf.value;
    var numero = this.numberaddress.value;
    var endereco = this.endereco.value;
    var cepassociationid = this.cepassociationid.value;
    var district = "";
    var numberdel = this.state.numberDel;
    const cep = Boolean(this.cep) ? this.cep.value : null;
    var empresa = this.state.empresaC;

    if (endereco != "") {
      var address = endereco.split(",");
      endereco = address[0];
      district = address[1];
    }

    if (name === "") {
      erro = 1;
      // oDivAlerta1.style.display = "block";
      // oDivAlerta1.innerHTML = "Preenchimento obrigatório";
      novosErros.nome = "Preenchimento obrigatório";
    }
    if (!contatode) {
      erro = 1;
      // oDivAlerta3.style.display = "block";
      // oDivAlerta3.innerHTML = "Preenchimento obrigatório";
      novosErros.contato = "Preenchimento obrigatório";
    }
    if (displayname === "") {
      erro = 1;
      // oDivAlerta2.style.display = "block";
      // oDivAlerta2.innerHTML = "Preenchimento obrigatório";
      novosErros.displayName = "Preenchimento obrigatório";
    }
    if (
      (!empresa || empresa.length === 0) &&
      connection_platform.insertWithCompany
    ) {
      erro = 1;
      // oDivAlerta5.style.display = "block";
      // oDivAlerta5.innerHTML = "Preenchimento obrigatório";
      novosErros.empresa = "Preenchimento obrigatório";
    }

    this.setState({ errosDiv: novosErros });

    console.log("COMO CHEGOU AQUI", erro, empresa);

    if (erro === 0) {
      const idrelacao = this.state.relacaoSelecionada
        ? this.state.relacaoSelecionada.value
        : "";
      const idcargo = this.state.cargoSelecionado
        ? this.state.cargoSelecionado.value
        : "";
      await updateContactOnEditV2(
        contactid,
        displayname,
        name,
        "",
        cpf,
        rg,
        codigoexterno,
        nascimento,
        endereco,
        numero,
        district,
        cepassociationid,
        numberdel,
        particular,
        contatode[0].value,
        "",
        detailscontact,
        idrelacao,
        idcargo,
      );

      await deleteNumberContactOnEdit(numberdel, this.props.InfoUsers);

      this.VerifyCompany();
      this.ButtonEdit(true);
      //this.VerifiedNumbers(numberscontact, iduser, contactid);
      const errorsOfVerified = await updateContactNumberOnEdit(
        numberscontact,
        iduser,
        contactid,
      );
      const hasErrorsOfVerified =
        !!errorsOfVerified &&
        Array.isArray(errorsOfVerified) &&
        errorsOfVerified.length > 0;
      if (hasErrorsOfVerified) {
        for (let number of errorsOfVerified) {
          this.props.ErrorNumberExist(number.number);
        }
      }
      if (detailscontact.detailsget) {
        this.props.editClient(numberscontact, displayname);
        let empresaNaAgenda = "";
        let idEmpresa = null;
        let cnpjEmpresa = null;
        let codigoEmpresa = null;
        const codigoContato = codigoexterno;
        if (Array.isArray(empresa) && empresa.length > 0) {
          empresaNaAgenda = empresa[0].label;
          idEmpresa = empresa[0].value;
          cnpjEmpresa = empresa[0].cnpj;
          codigoEmpresa = empresa[0].externcode;
        }
        this.props.EditMenuBotAndAditionalInformationOfContactAndEnterprise(
          numberscontact,
          {
            nomeNaAgenda: displayname,
            empresaNaAgenda,
            idEmpresa,
            cnpjEmpresa,
            codigoEmpresa,
            codigoContato,
          },
        );
        UpdateContactInteraction(
          this.props.InfoUsers.id,
          this.state.detailsScript.serverid,
          this.state.detailsScript.cdr,
          contactid,
          displayname,
        );
        // dispatch(editClientName(numberscontact, displayname));
      }

      //deletando empresas do responsáveis por
      let empresasDeResponsavelPor = this.state.responsavelPor;
      const companysToDelete = getResponsavelPorToDelete(
        this.state.responsavelPor,
        this.state.responsavelPorInDb,
      );
      const failedToDelete = await DeleteContactResponsibleCompany(
        companysToDelete,
        contactid,
        iduser,
        this.removeItemsToResponsavelPorInDb,
      );

      if (Array.isArray(failedToDelete) && failedToDelete.length > 0) {
        toast.error(
          "Algumas empresas do campo responsável por não foram removidas corretamente, tente novamente!",
        );
        empresasDeResponsavelPor.push(...failedToDelete);
      }

      //inserção das empresas responsáveis por
      const companysToAdd = getResponsavelPorToAdd(
        this.state.responsavelPor,
        this.state.responsavelPorInDb,
      );
      const failedToAdd = await InsertContactsResponsibleCompany(
        companysToAdd,
        contactid,
        iduser,
        this.addItemsToResponsavelPorInDb,
      );

      if (Array.isArray(failedToAdd) && failedToAdd.length > 0) {
        toast.error(
          "Algumas empresas do campo responsável por não foram adicionadas corretamente, tente novamente!",
        );
        empresasDeResponsavelPor = empresasDeResponsavelPor.filter(
          (empresa) => {
            return !failedToAdd.some(
              (failed) => parseInt(failed.id) === parseInt(empresa.id),
            );
          },
        );
      }

      this.setState({ responsavelPor: empresasDeResponsavelPor });

      this.props.ChangeResponsavelPor(
        null,
        empresasDeResponsavelPor,
        contactid,
      );

      //inserir lógica do ingDesk aqui
      const dataToSendToIngDesk = await this.formatContactToSendToIngDesk({
        name,
        displayname,
        cpf,
        rg,
        cep,
        endereco,
        numero,
        district,
        codigoexterno,
        numberscontact,
        contatode: this.state.contatode,
        allUsers,
      });

      await this.props.AddContactInIngDesk(dataToSendToIngDesk);
    }

    const isToUpdateHistoric = Boolean(this.state.historicData);
    if (isToUpdateHistoric) {
      this.updateDataOfHistoric(empresa, name);
    }

    this.handleSubmit({
      codext: this.state.codigoExternoContato,
      email: this.state.emailContato,
      nome: this.state.nomeContato,
      telefone: this.state.telefoneContato,
    });
    this.setState({ isLoadingSavingAlterations: false });
  }

  updateContact(contactid, numberscontact, iduser, event) {
    event.preventDefault();
    var oDivAlerta1 = document.getElementById("msg_erro1");
    var oDivAlerta2 = document.getElementById("msg_erro2");
    var oDivAlerta3 = document.getElementById("msg_erro3");
    var erro = 0;
    var displayname = this.displayname.value;
    var name = this.name.value;
    // var email = this.email.value;
    var contatode = this.state.contatode;
    var codigoexterno = this.codigoexterno.value;
    var particular = this.state.private;
    var nascimento = this.nascimento.value;
    var rg = this.rg.value;
    var cpf = this.cpf.value;
    var numero = this.numberaddress.value;
    var endereco = this.endereco.value;
    var cepassociationid = this.cepassociationid.value;
    var district = "";
    var numberdel = this.state.numberDel;

    if (endereco != "") {
      var address = endereco.split(",");
      endereco = address[0];
      district = address[1];
    }

    if (name === "") {
      erro = 1;
      oDivAlerta1.style.display = "block";
      oDivAlerta1.innerHTML = "Preenchimento obrigatório";
    }
    if (!contatode) {
      erro = 1;
      oDivAlerta3.style.display = "block";
      oDivAlerta3.innerHTML = "Preenchimento obrigatório";
    }
    if (displayname === "") {
      erro = 1;
      oDivAlerta2.style.display = "block";
      oDivAlerta2.innerHTML = "Preenchimento obrigatório";
    }
    if (erro === 0) {
      this.props.UpdateContact(
        contactid,
        displayname,
        name,
        "",
        cpf,
        rg,
        codigoexterno,
        nascimento,
        endereco,
        numero,
        district,
        cepassociationid,
        numberdel,
        particular,
        contatode[0].value,
      );

      this.VerifyCompany();
      this.ButtonEdit(true);
      this.VerifiedNumbers(numberscontact, iduser, contactid);
    }
    // document.getElementById("button_filtrar_contact").click();
    // this.handleSubmit(event);
  }

  updateCompany(e, companyid) {
    var oDivAlerta4 = document.getElementById("msg_erro4");
    var erro = 0;
    var inscricaoestadual = this.inscricaoestadual.value;
    inscricaoestadual = inscricaoestadual.replace(/\D+/g, "");
    var estadualmunicipal = this.estadualmunicipal.value;
    estadualmunicipal = estadualmunicipal.replace(/\D+/g, "");
    var business = this.business.value;
    var emailcompany = this.emailcompany.value;
    var site = this.site.value;
    var cnpj = this.cnpjinsert.value;
    let codext = "";

    if (
      this.state.externalCodeCompanyInCompanyPage ||
      this.state.externalCodeCompanyInCompanyPage === 0
    ) {
      codext = this.state.externalCodeCompanyInCompanyPage;
    }

    cnpj = cnpj.replace(/\D+/g, "");

    if (business === "") {
      erro = 1;
      oDivAlerta4.style.display = "block";
      oDivAlerta4.innerHTML = "Preenchimento obrigatório";
    }

    if (erro === 0) {
      /*
      this.props.UpdateCompany(
        inscricaoestadual,
        estadualmunicipal,
        site,
        emailcompany,
        cnpj,
        business,
        companyid
      );
      */

      this.props.UpdateCompanyV2(
        inscricaoestadual,
        estadualmunicipal,
        site,
        emailcompany,
        cnpj,
        business,
        companyid,
        codext,
      );
      this.ButtonEditCompany();
      this.setState({ disabledcompany: true });
    }
    this.setState({ modulecompany: undefined });
    document.getElementById("button_filtrar_company").click();
  }

  /*
  InsertCompany(e, userid) {
    var oDivAlerta4 = document.getElementById("msg_erro4");
    var erro = 0;
    var inscricaoestadual = this.inscricaoestadual.value;
    var estadualmunicipal = this.estadualmunicipal.value;
    var business = this.business.value;
    var emailcompany = this.emailcompany.value;
    var site = this.site.value;
    var cnpj = this.cnpjinsert.value;

    if (business === "") {
      erro = 1;
      oDivAlerta4.style.display = "block";
      oDivAlerta4.innerHTML = "Preenchimento obrigatório";
    }

    if (erro === 0) {
      this.props.InsertCompany(
        inscricaoestadual,
        estadualmunicipal,
        site,
        emailcompany,
        cnpj,
        business,
        userid
      );
    }
    document.getElementById("button_filtrar_company").click();
  }
  */

  InsertCompany(e, userid) {
    var oDivAlerta4 = document.getElementById("msg_erro4");
    var erro = 0;
    var inscricaoestadual = this.inscricaoestadual.value;
    var estadualmunicipal = this.estadualmunicipal.value;
    var business = this.business.value;
    var emailcompany = this.emailcompany.value;
    var site = this.site.value;
    var cnpj = this.cnpjinsert.value;
    let codext = "";

    if (this.state.externalCodeCompanyInCompanyPage) {
      codext = this.state.externalCodeCompanyInCompanyPage;
    }

    if (business === "") {
      erro = 1;
      oDivAlerta4.style.display = "block";
      oDivAlerta4.innerHTML = "Preenchimento obrigatório";
    }

    if (erro === 0) {
      this.props.InsertCompanyV2(
        inscricaoestadual,
        estadualmunicipal,
        site,
        emailcompany,
        cnpj,
        business,
        userid,
        codext,
      );
    }
    document.getElementById("button_filtrar_company").click();
  }

  handleSubmitCompany(e) {
    e.preventDefault();
    let empresa = this.nameempresa.value;
    let cnpj = this.cnpj.value;
    let codextemp = "";

    if (this.state.externalCodeInsideLegalPerson) {
      codextemp = this.state.externalCodeInsideLegalPerson;
    }

    /*
    this.props.SearchCompany(cnpj, empresa);
    */

    this.setState({ pageOfTable: 0 });

    if (
      (!empresa || empresa === 0) &&
      (!cnpj || cnpj === 0) &&
      (!codextemp || codextemp === 0)
    ) {
      return;
    }

    this.props.SearchCompanyV2(
      cnpj,
      empresa,
      (total) => {
        this.setState({ totalOfRows: total });
      },
      codextemp,
    );
  }

  VerifyLoadingOfResponsavelPor() {
    if (this.state.isLoadingResponsavelPor) {
      toast.warn("Aguarde o carregamento das empresas");
    }
  }

  async InsertContact(e, numberscontact, usercreate, detailscontact, allUsers) {
    this.VerifyLoadingOfResponsavelPor();
    const hasNumbersContact = this.verifyIfHasValidContacts(numberscontact);
    if (!hasNumbersContact) return;
    //VIM AQ
    const cep = Boolean(this.cep) ? this.cep.value : null;

    let oDivAlerta1 = document.getElementById("msg_erro1");
    let oDivAlerta2 = document.getElementById("msg_erro2");
    let oDivAlerta3 = document.getElementById("msg_erro3");
    let oDivAlerta5 = document.getElementById("msg_erro5");
    let novosErros = {
      nome: false,
      contato: false,
      displayName: false,
      empresa: false,
    };
    var erro = 0;
    var displayname = this.displayname.value;
    var name = this.name.value;
    // var email = this.email.value;
    var contatode = this.state.contatode;
    contatode = contatode[0].value;
    var codigoexterno = this.codigoexterno.value;
    var particular = this.state.private;
    var nascimento = this.nascimento.value;
    var rg = this.rg.value;
    var cpf = this.cpf.value;
    var numero = this.numberaddress.value;
    var endereco = this.endereco.value;
    var cepassociationid = this.cepassociationid.value;
    var district = "";
    var empresa = this.state.empresaC;
    //var numberdel        = this.state.numberDel
    if (endereco != "") {
      var address = endereco.split(",");
      endereco = address[0];
      district = address[1];
    }

    if (name === "") {
      erro = 1;
      // oDivAlerta1.style.display = "block";
      // oDivAlerta1.innerHTML = "Preenchimento obrigatório";
      novosErros.nome = "Preenchimento obrigatório";
    }
    if (contatode === "") {
      erro = 1;
      // oDivAlerta3.style.display = "block";
      // oDivAlerta3.innerHTML = "Preenchimento obrigatório";
      novosErros.contato = "Preenchimento obrigatório";
    }
    if (displayname === "") {
      erro = 1;
      // oDivAlerta2.style.display = "block";
      // oDivAlerta2.innerHTML = "Preenchimento obrigatório";
      novosErros.displayName = "Preenchimento obrigatório";
    }
    if (
      (!empresa || empresa.length === 0) &&
      connection_platform.insertWithCompany
    ) {
      erro = 1;
      // oDivAlerta5.style.display = "block";
      // oDivAlerta5.innerHTML = "Preenchimento obrigatório";
      novosErros.empresa = "Preenchimento obrigatório";
    }

    this.setState({ errosDiv: novosErros });

    for (let i = 0; i < numberscontact.length; i++) {
      await axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/phonexist?contactid=0&number=` +
            numberscontact[i].number,
        )
        .then((response) => {
          if (response.data.length !== 0) {
            erro = 1;
            this.props.ErrorNumberExist(numberscontact[i].number);
          }
        });
    }

    if (erro === 0) {
      const idrelacao = this.state.relacaoSelecionada
        ? this.state.relacaoSelecionada.value
        : "";
      const idcargo = this.state.cargoSelecionado
        ? this.state.cargoSelecionado.value
        : "";

      //inserção das empresas responsáveis por
      const companysToAdd = getResponsavelPorToAdd(
        this.state.responsavelPor,
        this.state.responsavelPorInDb,
      );

      this.props.InsertContactNew(
        displayname,
        name,
        "",
        cpf,
        rg,
        codigoexterno,
        nascimento,
        endereco,
        numero,
        district,
        cepassociationid,
        particular,
        usercreate,
        numberscontact,
        contatode,
        empresa,
        detailscontact,
        this.state.detailsScript,
        idrelacao,
        idcargo,
        companysToAdd,
      );
      // document.getElementById("nome").value = name;
      const dataToSendToIngDesk = await this.formatContactToSendToIngDesk({
        name,
        displayname,
        cpf,
        rg,
        cep,
        endereco,
        numero,
        district,
        codigoexterno,
        numberscontact,
        contatode: this.state.contatode,
        allUsers,
      });

      await this.props.AddContactInIngDesk(dataToSendToIngDesk);

      this.setState({
        buttonnewcontact: !this.state.buttonnewcontact,
        disabled: false,
        module: "edit",
      });

      this.clearHistoricData();
      this.ClearEmpresaC();
      this.ClearCargoSelecionado();
      this.ClearRelacaoSelecionada();
      this.cleanResponsavelPor();
    }
  }

  VerifiedNumbers(numberscontact, iduser, contactid) {
    this.props.UpdateContactNumber(numberscontact, iduser, contactid);
  }

  CloseHistory(e) {
    this.props.ClearHistory();
  }

  VerifyCompany() {
    console.log("COMO CHEGOU AQUI, ", {
      contactid: this.state.contactid,
      auxEmpresa: this.state.auxEmpresa,
      empresaC: this.state.empresaC,
    });
    if (this.state.empresaC) {
      if (this.state.empresaC.length !== 0) {
        var companyid = this.state.empresaC;
        companyid = companyid[0].value;

        if (companyid === this.state.auxEmpresa) {
        } else if (
          companyid !== this.state.auxEmpresa &&
          this.state.auxEmpresa !== "" &&
          this.state.companyid !== ""
        ) {
          this.props.UpdateCompanyContact(
            this.state.contactid,
            this.state.auxEmpresa,
          );
          this.props.InsertCompanyContact(this.state.contactid, companyid);
          this.setState({ auxEmpresa: companyid });
        } else if (
          companyid !== this.state.auxEmpresa &&
          companyid !== "" &&
          this.state.auxEmpresa === ""
        ) {
          this.props.InsertCompanyContact(this.state.contactid, companyid);
          this.setState({ auxEmpresa: companyid });
        }
      } else {
        var companyid = this.state.empresaC;
        if (
          companyid !== this.state.auxEmpresa &&
          this.state.auxEmpresa !== "" &&
          companyid === ""
        ) {
          this.props.UpdateCompanyContact(
            this.state.contactid,
            this.state.auxEmpresa,
          );
          this.setState({ auxEmpresa: companyid });
        }
      }
    } else {
      let companyid = this.state.empresaC;
      if (
        companyid !== this.state.auxEmpresa &&
        this.state.auxEmpresa !== "" &&
        companyid === ""
      ) {
        this.props.UpdateCompanyContact(
          this.state.contactid,
          this.state.auxEmpresa,
        );
        this.setState({ auxEmpresa: companyid });
      }
    }
  }

  ShowContactNew() {
    this.props.ShowModalsMenu("modal__agenda-pf-usuario-detalhess");
    this.setState({ buttonnewcontact: !this.state.buttonnewcontact });
  }

  ShowCompanyNew() {
    this.props.ShowModalsMenu("modal__agenda-pf-usuario-detalhess");
    this.setState({ buttonnewcompany: !this.state.buttonnewcompany });
  }

  ShowHistory(e, idcdr, data) {
    let idgroup = this.props.InfoUsers.idgroup;
    this.props.CarregamentoCDR(idcdr, idgroup);
    MicroModal.close("modal__agenda-pf__cliente__interacoes");
    MicroModal.show("modal__historico-atendimento-contact");
    this.datahistoryinitcontact.value = data + "T00:00";
    this.datahistoryfimcontact.value = data + "T23:59";
    if (this.state.cliente === "") {
      this.setState({ cliente: "999999999" });
    }
    if (this.state.mensagem != "")
      this.setState({ searchText: this.state.mensagem, showHistory: true });
    // document.getElementById('campopesquisartexto').value = this.state.mensagem;
  }

  CloseHistory(e) {
    MicroModal.close("modal__historico-atendimento-contact");
    MicroModal.show("modal__agenda-pf__cliente__interacoes");
  }

  clearValuesCompany() {
    this.business.value = "";
    this.inscricaoestadual.value = "";
    this.estadualmunicipal.value = "";
    this.site.value = "";
    this.emailcompany.value = "";
    this.cnpjinsert.value = "";

    this.setState({ externalCodeCompanyInCompanyPage: "" });
  }

  clearValues(iduser, displayname) {
    this.name.value = "";
    var value = [{ value: iduser, label: displayname }];
    this.setState({ contatode: value });
    this.setState({ empresaC: "" });
    this.setState({ auxEmpresa: "" });
    this.setState({ contactid: "" });
    this.setState({ private: iduser });
    this.setState({ disabled: false });
    this.setState({ person: "" });
    this.setState({ numberC: "" });
    this.setState({ module: "new" });
    // this.email.value = "";
    this.displayname.value = "";
    this.cepassociationid.value = "";
    this.codigoexterno.value = "";
    this.cep.value = "";
    this.estado.value = "";
    this.cidade.value = "";
    this.endereco.value = "";
    this.nascimento.value = "";
    this.numberaddress.value = "";
    this.rg.value = "";
    this.cpf.value = "";
  }

  checkValues(contact) {
    // if (contact.email === null || contact.email === "undefined") {
    //   this.email.value = "";
    // } else {
    //   this.email.value = contact.email;
    // }
    if (contact.displayname === null) {
      this.displayname.value = "";
    } else {
      // var mensagem_tratada = contact.displayname.replace(/¿/gi, "\n");
      // mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
      // var valor = 1
      // try{
      // mensagem_tratada = '{"'+valor+'": [{"mensagem_tratada":"'+mensagem_tratada+'"}]}';
      // var obj = JSON.parse(mensagem_tratada);
      // mensagem_tratada = obj[1][0].mensagem_tratada
      // } catch(e){
      //     mensagem_tratada = contact.displayname;
      // }
      var mensagem_tratada = createJSON(contact.displayname);
      this.displayname.value = mensagem_tratada;
    }
    if (contact.cepassociationid === null) {
      this.cepassociationid.value = "";
    } else {
      this.cepassociationid.value = contact.cepassociationid;
    }
    if (contact.codigoexterno === null) {
      this.codigoexterno.value = "";
    } else {
      this.codigoexterno.value = contact.externcode;
    }
    if (contact.cep === null) {
      this.cep.value = "";
    } else {
      this.cep.value = contact.cep;
    }
    if (contact.estado === null) {
      this.estado.value = "";
    } else {
      this.estado.value = contact.estado;
    }
    if (contact.cidade === null) {
      this.cidade.value = "";
    } else {
      this.cidade.value = contact.cidade;
    }
    if (contact.endereco === null) {
      this.endereco.value = "";
    } else {
      this.endereco.value = contact.address;
    }
    if (contact.nascimento === null) {
      this.nascimento.value = "";
    } else {
      var nascimento = Moment(contact.birthday).format("YYYY-MM-DD");
      this.nascimento.value = nascimento;
    }
    if (contact.numberaddress === null) {
      this.numberaddress.value = "";
    } else {
      this.numberaddress.value = contact.numberaddress;
    }
    if (contact.rg === null) {
      this.rg.value = "";
    } else {
      this.rg.value = contact.rg;
    }
    if (contact.cpf === null) {
      this.cpf.value = "";
    } else {
      this.cpf.value = contact.cpf;
    }
  }

  GetInteractions(e, number) {
    e.preventDefault();
    let datainit = this.dataInit.value;
    let datafim = this.dataFim.value;
    let idgroup = this.props.InfoUsers.idgroup;

    this.props.InteracoesContactNumber(
      number,
      datainit,
      datafim,
      this.state.mensagem,
      idgroup,
    );
  }

  AddContactNew(e) {
    this.props.ShowModalsMenu("modal_pj-empresa");
    MicroModal.close("modal__agenda-pj-empresa-detalhes-editar-salvo");
    MicroModal.show("modal__agenda");
  }

  AddCompanyNew(e) {
    this.props.ShowModalsMenu("modal_pj-empresa");
    MicroModal.close("modal__agenda-pj-empresa-detalhes-editar-salvo");
    MicroModal.show("modal__agenda-pj-empresa-detalhes-editar");
    this.clearValuesCompany();
  }

  ShowModalMaisCampos(e, modal) {
    MicroModal.close("modal__agenda-pf-usuario-detalhes-mais-campos");
    MicroModal.show("modal__agenda-pf-usuario-detalhes");
  }

  CancelMaisCampos(e, modal) {
    if (this.props.DetailsContacts.detailsget) {
      this.props.GetDetailsContacts(false, "");
      MicroModal.close("modal__agenda-pf-usuario-detalhes-mais-campos");
    } else {
      MicroModal.close("modal__agenda-pf-usuario-detalhes-mais-campos");
      MicroModal.show("modal__agenda");
    }
  }

  CancelMenosCampos(e, modal) {
    this.clearHistoricData();
    this.ClearEmpresaC();
    this.ClearAddressInfos();
    this.ClearCargoSelecionado();
    this.ClearRelacaoSelecionada();
    this.cleanResponsavelPor();
    if (this.props.DetailsContacts.detailsget) {
      this.props.GetDetailsContacts(false, "");
      MicroModal.close("modal__agenda-pf-usuario-detalhes");
    } else {
      MicroModal.close("modal__agenda-pf-usuario-detalhes");
      MicroModal.show("modal__agenda");
    }

    this.props.ClearNumbersContact();
    this.setState({
      moreinfo: false,
      errosDiv: {
        nome: false,
        contato: false,
        displayName: false,
        empresa: false,
      },
    });
  }

  CancelCompany(e) {
    MicroModal.close("modal__agenda-pj-empresa-detalhes-editar");
    MicroModal.show("modal__agenda");

    this.setState({ modulecompany: undefined });
  }

  ClearEmpresaC() {
    this.setState({ empresaC: "" });
  }

  ClearCargoSelecionado() {
    this.setState({ cargoSelecionado: undefined });
  }

  ClearRelacaoSelecionada() {
    this.setState({ relacaoSelecionada: undefined });
  }

  ClearAddressInfos() {
    this.props.ClearGetCEP();
    // this.setState({ endereco: "", cidade: "", estado: "" });
    // if (Boolean(this.endereco)) this.endereco.value = "";
    // if (Boolean(this.cidade)) this.cidade.value = "";
    // if (Boolean(this.estado)) this.estado.value = "";
  }

  clearHistoricData() {
    this.setState({ historico: null });
  }

  ExitModal(e, modal) {
    switch (modal) {
      case "modal__agenda-pf-usuario-detalhes":
        this.clearHistoricData();
        this.ClearEmpresaC();
        this.ClearCargoSelecionado();
        this.ClearRelacaoSelecionada();
        this.ClearAddressInfos();
        this.cleanResponsavelPor();
        if (this.props.DetailsContacts.detailsget) {
          this.props.GetDetailsContacts(false, "", "");
          MicroModal.close("modal__agenda-pf-usuario-detalhes");
        } else {
          MicroModal.close("modal__agenda-pf-usuario-detalhes");
          MicroModal.show("modal__agenda");
        }
        break;
      case "modal__agenda-pf-usuario-detalhes-mais-campos":
        MicroModal.close("modal__agenda-pf-usuario-detalhes-mais-campos");
        MicroModal.show("modal__agenda");
        break;
      case "modal__agenda-pf__cliente__interacoes":
        MicroModal.close("modal__historico-atendimento-details");
        MicroModal.show("modal__agenda");
      default:
        break;
    }
    this.props.ClearNumbersContact();
    this.setState({ moreinfo: false, detailsScript: "" });
  }

  concatNumberDel(e, idnumber) {
    this.setState({ numberDel: this.state.numberDel.concat([idnumber]) });
    this.props.deleteNumber(idnumber);
  }

  /*
  handleSubmit(data) {
    var contatoof = "";
    var empresa = "";
    if (this.state.value === null) {
      contatoof = "";
    } else {
      contatoof = this.state.value;
      contatoof = contatoof.value;
    }
    if (this.state.empresa === null) {
      empresa = "";
    } else {
      empresa = this.state.empresa;
      empresa = empresa.value;
    }
    this.props.SearchingContacts(data, contatoof, empresa);
  }
  */

  handleSubmit(data) {
    var contatoof = "";
    var empresa = "";
    let externalCodeCompany = "";
    if (this.state.value === null) {
      contatoof = "";
    } else {
      contatoof = this.state.value;
      contatoof = contatoof.value;
    }
    if (this.state.empresa === null) {
      empresa = "";
    } else {
      empresa = this.state.empresa;
      empresa = empresa.value;
    }
    if (
      this.state.externalCodeCompany ||
      this.state.externalCodeCompany === 0
    ) {
      externalCodeCompany = this.state.externalCodeCompany;
    }
    this.props.SearchingContactsV2(
      data,
      contatoof,
      empresa,
      externalCodeCompany,
    );
  }

  handleChangeC = (value) => {
    this.setState({ value: value });
  };

  ChangeDisplayname = (e) => {
    this.displayname.value = e.target.value;
  };

  handleChangeE = (empresa) => {
    this.setState({ empresa: empresa });
  };

  ButtonEdit(action, value) {
    this.setState({ disabled: action });
    if (value === "edit") {
      this.setState({ module: "edit" });
    }
  }

  ButtonEditCompany(action, value) {
    this.setState({ disabledcompany: false });
    this.setState({ modulecompany: "edit" });
  }

  renderPopoverDial = (
    e,
    PermissionRouter,
    OutBandService,
    InfoUsers,
    StatusAgent,
    listCallQueue,
    number,
    AtdSimult,
    IPCurrent,
    voz,
    zap,
    face,
    sms,
    teams,
    zapvoz,
  ) => (
    <div className="context-menu" id="modal-contato-ligar">
      <ul className="context-menu__list">
        {voz && (
          <li
            onClick={(event) =>
              this.SolicitarChamadaAtiva(
                event,
                PermissionRouter,
                1,
                OutBandService,
                InfoUsers,
                StatusAgent.status,
                listCallQueue,
                number,
                AtdSimult,
                IPCurrent,
                StatusAgent,
              )
            }
            className="context-menu__item"
          >
            <a className="context-menu__link">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
              >
                <path d="M0,0H20V20H0Z" fill="none" />
                <path
                  className="grey-mode"
                  d="M18.82,14.632A10.572,10.572,0,0,1,15.5,14.1a.95.95,0,0,0-.95.223L12.5,16.372a14,14,0,0,1-6.133-6.133L8.416,8.178a.893.893,0,0,0,.232-.931,10.572,10.572,0,0,1-.531-3.322A.933.933,0,0,0,7.188,3H3.924A.933.933,0,0,0,3,3.931a15.819,15.819,0,0,0,15.822,15.82.933.933,0,0,0,.929-.931V15.556A.933.933,0,0,0,18.82,14.632Zm-.931-3.264h1.86A8.376,8.376,0,0,0,11.375,3V4.86a6.509,6.509,0,0,1,6.514,6.514Zm-3.723,0h1.86a4.655,4.655,0,0,0-4.652-4.645v1.86a2.788,2.788,0,0,1,2.792,2.792Z"
                  transform="translate(-1.375 -1.375)"
                  fill="#005daa"
                />
              </svg>{" "}
              Ligação (Voz)
            </a>
          </li>
        )}

        {zapvoz && (
          <li
            onClick={(event) =>
              this.SolicitarChamadaAtiva(
                event,
                PermissionRouter,
                16,
                OutBandService,
                InfoUsers,
                StatusAgent.status,
                listCallQueue,
                number,
                AtdSimult,
                IPCurrent,
                StatusAgent,
              )
            }
            className="context-menu__item"
          >
            <a className="context-menu__link">
              <WHATSAPPVOZICONDISABLED width={20} height={20} /> Ligação
              (Whatsapp)
            </a>
          </li>
        )}

        {zap && (
          <li
            onClick={(event) =>
              this.SolicitarChamadaAtiva(
                event,
                PermissionRouter,
                5,
                OutBandService,
                InfoUsers,
                StatusAgent.status,
                listCallQueue,
                number,
                AtdSimult,
                IPCurrent,
                StatusAgent,
              )
            }
            className="context-menu__item"
          >
            <a className="context-menu__link">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
              >
                <path
                  className="grey-mode"
                  d="M-67.705-1207.71a9.912,9.912,0,0,1-5.5-1.656l-3.843,1.231,1.246-3.715a9.885,9.885,0,0,1-1.9-5.859,10.012,10.012,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.009,10.009,0,0,1-67.705-1207.71Zm-3.769-15.43a1.458,1.458,0,0,0-1.024.36l-.029.03a3.2,3.2,0,0,0-1,2.4,5.363,5.363,0,0,0,1.17,2.991l.018.024c.011.014.03.041.057.081l.006.008a11.887,11.887,0,0,0,4.918,4.31,8.551,8.551,0,0,0,2.934.819,2.694,2.694,0,0,0,.571-.065,2.819,2.819,0,0,0,1.96-1.411,2.507,2.507,0,0,0,.173-1.4c-.055-.094-.185-.157-.381-.251l-.014-.007-.164-.08c-.216-.108-1.713-.848-1.991-.947a.735.735,0,0,0-.252-.049.564.564,0,0,0-.468.268l-.092.13a10.08,10.08,0,0,1-.689.905.556.556,0,0,1-.414.169.752.752,0,0,1-.288-.059l-.074-.03a7.346,7.346,0,0,1-2.271-1.416,8.959,8.959,0,0,1-1.62-2.016.455.455,0,0,1,.108-.61l.009-.011c.093-.119.183-.215.279-.316.053-.056.1-.11.155-.168l.016-.018a1.62,1.62,0,0,0,.308-.439.613.613,0,0,0-.043-.544c-.049-.1-.343-.817-.6-1.448l0-.011-.044-.107-.246-.6c-.194-.456-.336-.48-.637-.491l-.1,0C-71.314-1223.136-71.391-1223.14-71.474-1223.14Z"
                  transform="translate(77.71 1227.71)"
                  fill="#25d366"
                />
              </svg>{" "}
              Whatsapp
            </a>
          </li>
        )}

        {face && (
          <li className="context-menu__item">
            <a className="context-menu__link">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20.009"
                viewBox="0 0 20 20.009"
              >
                <path
                  d="M0,.961V19.047a.961.961,0,0,0,.961.961h9.693V12.283h-2.6V9.126h2.6V6.475a3.49,3.49,0,0,1,3.49-3.49h2.722V5.821H14.917a1.112,1.112,0,0,0-1.111,1.111V9.126h3.007L16.4,12.283H13.8v7.726h5.237A.961.961,0,0,0,20,19.047V.961A.961.961,0,0,0,19.039,0H.953A.959.959,0,0,0,0,.961Z"
                  fill="#3b5998"
                  className="grey-mode"
                />
              </svg>{" "}
              Facebook
            </a>
          </li>
        )}

        {sms && (
          <li
            className="context-menu__item"
            onClick={(event) =>
              this.SolicitarChamadaAtiva(
                event,
                PermissionRouter,
                12,
                OutBandService,
                InfoUsers,
                StatusAgent.status,
                listCallQueue,
                number,
                AtdSimult,
                IPCurrent,
                StatusAgent,
              )
            }
          >
            <a className="context-menu__link">
              <svg
                width="24"
                height="24"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="17"
                  height="17"
                  rx="8.5"
                  fill="#61C4BE"
                />
                <path
                  d="M11.8479 4.5H6.1521C4.96557 4.5 4 5.51786 4 6.76865V9.0159C4 10.2667 4.96557 11.2845 6.1521 11.2845H9.75226L12.3694 13.5V11.2162C13.3161 10.9675 14 10.0684 14 9.0159V6.76865C14 5.51786 13.0344 4.5 11.8479 4.5ZM6.30286 8.86132C6.04804 8.86132 5.82098 8.80401 5.6739 8.72186L5.78133 8.27418C5.89271 8.34407 6.12373 8.42625 6.30288 8.42625C6.48598 8.42625 6.56167 8.36045 6.56167 8.25782C6.56167 8.15487 6.50186 8.10575 6.27512 8.02768C5.8729 7.88791 5.71757 7.66217 5.72153 7.42384C5.72153 7.05014 6.0322 6.7668 6.51378 6.7668C6.74082 6.7668 6.94408 6.82 7.06339 6.88171L6.95596 7.31302C6.86837 7.26358 6.70114 7.19779 6.5339 7.19779C6.38649 7.19779 6.30288 7.2595 6.30288 7.36213C6.30288 7.45658 6.37855 7.50601 6.61751 7.59227C6.98769 7.72356 7.14302 7.91685 7.147 8.21249C7.14698 8.58617 6.86041 8.86132 6.30286 8.86132ZM10.4554 8.82039H9.8661V7.72794C9.8661 7.4361 9.77424 7.26767 9.57924 7.26767C9.44008 7.26767 9.34029 7.3662 9.30061 7.48553C9.28473 7.53054 9.27682 7.59636 9.27682 7.64577V8.82039H8.68753V7.69489C8.68753 7.44018 8.59994 7.26767 8.40859 7.26767C8.25357 7.26767 8.16169 7.39108 8.126 7.49372C8.10616 7.54284 8.1022 7.60044 8.1022 7.64987V8.82041H7.51292V7.4525C7.51292 7.20221 7.50498 6.98843 7.49704 6.81181H8.00669L8.03447 7.08288H8.04637C8.12998 6.95569 8.30118 6.7668 8.63565 6.7668C8.88651 6.7668 9.08549 6.89809 9.1691 7.10745H9.17704C9.24875 7.00481 9.33635 6.92264 9.4279 6.86535C9.53563 6.79956 9.65494 6.76682 9.79839 6.76682C10.1725 6.76682 10.4554 7.03789 10.4554 7.63733V8.82039H10.4554ZM11.4539 8.86132C11.1991 8.86132 10.972 8.80401 10.825 8.72186L10.9324 8.27418C11.0438 8.34407 11.2748 8.42625 11.4539 8.42625C11.637 8.42625 11.7127 8.36045 11.7127 8.25782C11.7127 8.15487 11.6529 8.10575 11.4262 8.02768C11.0239 7.88791 10.8686 7.66217 10.8726 7.42384C10.8726 7.05014 11.1832 6.7668 11.6648 6.7668C11.8919 6.7668 12.0948 6.82 12.2144 6.88171L12.107 7.31302C12.0194 7.26358 11.8522 7.19779 11.6849 7.19779C11.5375 7.19779 11.4539 7.2595 11.4539 7.36213C11.4539 7.45658 11.5296 7.50601 11.7686 7.59227C12.1387 7.72356 12.2941 7.91685 12.298 8.21249C12.298 8.58617 12.0115 8.86132 11.4539 8.86132Z"
                  fill="white"
                />
                <rect
                  x="0.5"
                  y="0.5"
                  width="17"
                  height="17"
                  rx="8.5"
                  stroke="white"
                />
              </svg>{" "}
              Sms
            </a>
          </li>
        )}

        {teams && (
          <li
            onClick={(event) =>
              this.SolicitarChamadaAtiva(
                event,
                PermissionRouter,
                15,
                OutBandService,
                InfoUsers,
                StatusAgent.status,
                listCallQueue,
                number,
                AtdSimult,
                IPCurrent,
                StatusAgent,
              )
            }
            className="context-menu__item"
          >
            <a className="context-menu__link">
              <svg
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.2749 13.8515V22.2858C12.2749 23.3155 12.5275 24.2847 12.9663 25.143H18.6795C19.4886 25.143 20.2749 24.3281 20.2749 23.5955V12.5955L19.9538 12.5715H13.5549C12.8475 12.5715 12.2749 13.1441 12.2749 13.8515"
                  fill="black"
                />
                <path
                  d="M18.9417 9.14282H15.5405C16.0274 10.672 17.4422 11.7863 19.1325 11.7863C19.5337 11.7863 19.912 11.7074 20.2754 11.592V10.4765C20.2754 9.74282 19.6754 9.14282 18.9417 9.14282"
                  fill="black"
                />
                <path
                  d="M29.2726 12.5714H23.5663L21.9731 13.8594V20.2468C21.9731 22.6183 23.8954 24.5406 26.2669 24.5406C28.6383 24.5406 30.5606 22.6183 30.5606 20.2468V13.8594C30.5606 13.1486 29.9834 12.5714 29.2726 12.5714"
                  fill="#5059C9"
                />
                <path
                  d="M29.4179 8.57138C29.4179 10.1497 28.139 11.4285 26.5608 11.4285C24.9825 11.4285 23.7036 10.1497 23.7036 8.57138C23.7036 6.99309 24.9825 5.71423 26.5608 5.71423C28.139 5.71423 29.4179 6.99309 29.4179 8.57138"
                  fill="#5059C9"
                />
                <path
                  d="M13.5549 12.5714H23.5663C24.2738 12.5714 24.8463 13.144 24.8463 13.8514V22.2857C24.8463 25.7577 22.0326 28.5714 18.5606 28.5714C15.0886 28.5714 12.2749 25.7577 12.2749 22.2857V13.8514C12.2749 13.144 12.8475 12.5714 13.5549 12.5714"
                  fill="#7B83EB"
                />
                <path
                  d="M22.9189 8.00003C22.9189 10.0915 21.2241 11.7863 19.1326 11.7863C17.0412 11.7863 15.3452 10.0915 15.3452 8.00003C15.3452 5.9086 17.0412 4.21375 19.1326 4.21375C21.2241 4.21375 22.9189 5.9086 22.9189 8.00003"
                  fill="#7B83EB"
                />
                <path
                  opacity="0.5"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.5404 9.14282H18.9415C19.6752 9.14282 20.2752 9.74282 20.2752 10.4765V11.592C19.9118 11.7074 19.5335 11.7863 19.1324 11.7863C17.4421 11.7863 16.0272 10.672 15.5404 9.14282ZM12.2749 22.2858V13.8515C12.2749 13.1441 12.8475 12.5715 13.5549 12.5715H19.9538L20.2749 12.5955V23.5955C20.2749 24.3281 19.4886 25.1429 18.6795 25.1429H12.9663C12.5275 24.2846 12.2749 23.3155 12.2749 22.2858Z"
                  fill="black"
                />
                <path
                  d="M17.7989 24H4.46514C3.73257 24 3.13257 23.4 3.13257 22.6663V9.33371C3.13257 8.6 3.73257 8 4.46514 8H17.7989C18.5326 8 19.1326 8.6 19.1326 9.33371V22.6663C19.1326 23.4 18.5326 24 17.7989 24"
                  fill="#4B53BC"
                />
                <path
                  d="M14.767 13.2315H12.0367V20.571H10.2425V13.2315H7.49731V11.4281H14.767V13.2315Z"
                  fill="white"
                />
              </svg>{" "}
              Teams
            </a>
          </li>
        )}
        <li className="context-menu__item">
          <a
            href={
              "mailto:suporte@ingenium-systems.com.br?subject=Numero para contato:" +
              number
            }
            className="context-menu__link"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M20,4H4A2,2,0,0,0,2.01,6L2,18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,20,4Zm0,4-8,5L4,8V6l8,5,8-5Z"
                fill="#005daa"
                className="grey-mode"
              />
            </svg>{" "}
            E-mail
          </a>
        </li>
        <li className="context-menu__item">
          <a className="context-menu__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20.049"
              height="20.049"
              viewBox="0 0 20.049 20.049"
            >
              <circle
                className="grey-mode"
                cx="10.024"
                cy="10.024"
                r="10.024"
                fill="#08c"
              />
              <path
                d="M100.412,107.636a.334.334,0,0,0-.329-.027l-10.772,5.014a.527.527,0,0,0,.012.96l9.931,4.325a.532.532,0,0,0,.743-.448l.561-9.529A.334.334,0,0,0,100.412,107.636Z"
                transform="translate(-85.522 -103.365)"
                fill="#e5e5e5"
              />
              <path
                d="M171.631,115.676l.671,4.487,7.455-11.73Z"
                transform="translate(-164.91 -104.186)"
                fill="#b7bec5"
              />
              <path
                d="M100.083,107.613l-10.772,5.014a.527.527,0,0,0,.012.96l2.919,1.271,8.127-7.244A.334.334,0,0,0,100.083,107.613Z"
                transform="translate(-85.522 -103.369)"
                fill="#fff"
              />
              <path
                d="M189.659,116.354l-.887,3.808,7.456-11.73Z"
                transform="translate(-181.38 -104.186)"
                fill="#fff"
              />
              <path
                d="M218.03,108.456a.328.328,0,0,0-.043-.024l-6.569,7.922,5.454,2.375a.532.532,0,0,0,.743-.448l.561-9.529A.334.334,0,0,0,218.03,108.456Z"
                transform="translate(-203.139 -104.186)"
                fill="#fff"
              />
            </svg>{" "}
            Telegram
          </a>
        </li>
        <li className="context-menu__item">
          <a className="context-menu__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20.013"
              height="20.013"
              viewBox="0 0 20.013 20.013"
            >
              <path
                className="grey-mode"
                d="M14.051,0H5.962A5.969,5.969,0,0,0,0,5.962v8.089a5.969,5.969,0,0,0,5.962,5.962h8.089a5.969,5.969,0,0,0,5.962-5.962V5.962A5.969,5.969,0,0,0,14.051,0ZM18,14.051A3.949,3.949,0,0,1,14.051,18H5.962a3.949,3.949,0,0,1-3.949-3.949V5.962A3.949,3.949,0,0,1,5.962,2.013h8.089A3.949,3.949,0,0,1,18,5.962v8.089Z"
                fill="#e4405f"
              />
              <path
                className="grey-mode"
                d="M138.176,133a5.176,5.176,0,1,0,5.176,5.176A5.182,5.182,0,0,0,138.176,133Zm0,8.339a3.163,3.163,0,1,1,3.163-3.163A3.163,3.163,0,0,1,138.176,141.339Z"
                transform="translate(-128.17 -128.17)"
                fill="#e4405f"
              />
              <circle
                className="grey-mode"
                cx="1.24"
                cy="1.24"
                r="1.24"
                transform="translate(13.952 3.629)"
                fill="#e4405f"
              />
            </svg>{" "}
            Instagram
          </a>
        </li>
        <li className="context-menu__item">
          <a className="context-menu__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24.615"
              height="20"
              viewBox="0 0 24.615 20"
            >
              <path
                className="grey-mode"
                d="M24.615,50.368a10.521,10.521,0,0,1-2.908.8,5.018,5.018,0,0,0,2.22-2.789,10.085,10.085,0,0,1-3.2,1.222A5.046,5.046,0,0,0,12,53.048a5.2,5.2,0,0,0,.117,1.151,14.284,14.284,0,0,1-10.4-5.278,5.048,5.048,0,0,0,1.551,6.745,4.984,4.984,0,0,1-2.28-.622V55.1a5.07,5.07,0,0,0,4.043,4.958,5.037,5.037,0,0,1-1.323.166,4.462,4.462,0,0,1-.955-.086,5.094,5.094,0,0,0,4.715,3.515A10.14,10.14,0,0,1,1.208,65.8,9.453,9.453,0,0,1,0,65.735,14.207,14.207,0,0,0,7.742,68,14.264,14.264,0,0,0,22.1,53.64c0-.223-.008-.438-.018-.652A10.067,10.067,0,0,0,24.615,50.368Z"
                transform="translate(0 -48)"
                fill="#1da1f2"
              />
            </svg>{" "}
            Twitter
          </a>
        </li>
      </ul>
    </div>
  );

  renderPopoverInfo = (e, contact, iduser, router) => (
    <div className="context-menu" id="modal-contato-mais-info">
      <ul className="context-menu__list">
        <li className="context-menu__item">
          <a
            onClick={(event) =>
              this.ShowModal(
                event,
                "modal__agenda-pf__cliente__interacoes",
                contact,
                false,
                contact.number,
                router,
              )
            }
            className="context-menu__link"
          >
            <i className="material-icons">compare_arrows</i> Ver interações
          </a>
        </li>
        <li
          onClick={(event) =>
            this.ShowModal(
              event,
              "modal__agenda-pf-usuario-detalhes",
              contact,
              false,
            )
          }
          className="context-menu__item"
        >
          <a className="context-menu__link">
            <i className="material-icons">edit</i> Editar
          </a>
        </li>
        <li
          onClick={this.deleteContact.bind(this, contact, iduser)}
          className="context-menu__item"
        >
          <a className="context-menu__link">
            <i className="material-icons">delete</i> Excluir
          </a>
        </li>
      </ul>
    </div>
  );

  renderPopoverInfoCompany = (e, company, iduser) => (
    <div className="context-menu" id="modal-contato-mais-info">
      <ul className="context-menu__list">
        <li
          onClick={(event) =>
            this.ShowModal(
              event,
              "modal__agenda-pj-empresa-detalhes",
              company,
              true,
            )
          }
          className="context-menu__item"
        >
          <a className="context-menu__link">
            <i className="material-icons">edit</i> Editar
          </a>
        </li>
        <li
          onClick={this.deleteCompany.bind(this, company, iduser)}
          className="context-menu__item"
        >
          <a className="context-menu__link">
            <i className="material-icons">delete</i> Excluir
          </a>
        </li>
      </ul>
    </div>
  );

  getCep(e) {
    var cep = this.cep.value;
    // antiga
    // this.props.getCep(cep);

    this.props.getCepApi(cep);
  }

  fillCep(location) {
    //antigo
    // if (location.length != 0) {
    //   this.endereco.value = location[0].adress + ", " + location[0].district;
    //   this.cidade.value = location[0].city;
    //   this.estado.value = location[0].uf;
    //   this.cepassociationid.value = location[0].addressid;
    // } else {
    //   this.endereco.value = "";
    //   this.cidade.value = "";
    //   this.estado.value = "";
    //   this.numberaddress.value = "";
    // }

    if (location.length !== 0) {
      this.endereco.value = location[0].logradouro + ", " + location[0].bairro;
      this.cidade.value = location[0].localidade;
      this.estado.value = location[0].uf;
      // this.cepassociationid.value = location[0].addressid;
    } else {
      this.endereco.value = "";
      this.cidade.value = "";
      this.estado.value = "";
      this.numberaddress.value = "";
    }
  }

  ContactPrivate(valor) {
    this.setState({ private: valor });
  }

  AddNumber(e) {
    this.props.AddNumberContact();
  }

  EditNumber = (event, id, type) => {
    let number = event.target.value;
    if (type) {
      number = number.replace(/\D+/g, "");
      // this.maskNumber(number);
    }

    this.props.editNumber(id, number);
  };

  // EditTypeNumber(e, id) {
  //   if (e != null) {
  //     this.props.editTypeNumber(id, e.target.value);
  //   }
  // }

  EditTypeNumber(bind, number, midiaid) {
    if (number != null) {
      bind.props.editTypeNumber(
        number.idphone,
        number.phonetypeid,
        number.description,
        midiaid,
      );
    }
  }

  maskNumber(number) {
    // switch (number.length) {
    //   case 9:
    //     return "99999-9999";

    //   case 10:
    //     return "(99) 9999-9999";

    //   case 11:
    //     return "(99) 99999-9999";

    //   case 12:
    //     return "+99 (99) 9999-9999";

    //   case 13:
    //     return "+99 (99) 99999-9999";

    //   default:
    //     return "9999-9999";
    // }
    if (number.length <= 8) {
      return "9999-9999";
    } else if (number.length === 9) {
      return "99999-9999";
    } else if (number.length === 10) {
      return "(99) 9999-9999";
    } else if (number.length === 11) {
      return "(99) 99999-9999";
    } else if (number.length === 12) {
      return "+99 (99) 9999-9999";
    } else if (number.length === 13) {
      return "+99 (99) 99999-9999";
    }
  }

  ShowPJPF(e) {
    if (e === "pj") {
      this.setState({ buttonshowpfpj: true });
      this.props.ClearCompany();
    } else {
      this.setState({ buttonshowpfpj: false });
      //this.props.ShowCompanys();
    }
  }

  VerifierImage(e, urlimage, modal) {
    this.setState({ isOpen: true, urlimage: urlimage });
    if (modal === "history") {
      MicroModal.close("modal__historico-atendimento-contact");
    }
    if (modal === "dmark") {
      MicroModal.close("modal__mensagens-favoritas");
    }
  }

  CloseImage(e, modal) {
    this.setState({ isOpen: false, urlimage: "" });
    if (modal === "history") {
      MicroModal.show("modal__historico-atendimento-contact");
    }
    if (modal === "dmark") {
      MicroModal.show("modal__mensagens-favoritas");
    }
  }

  validateDetails(contact, edit) {
    this.GetCargoAndRelacaoType2(contact);
    this.getResponsavelPor(contact);

    var mensagem_tratada_display = createJSON(contact.displayname);
    var mensagem_tratada = createJSON(contact.name);
    var value = [{ value: contact.user_create, label: contact.username }];
    this.checkValues(contact);
    this.state.contatode = value;
    this.state.private = contact.userid;
    this.state.person = mensagem_tratada_display;
    this.state.numberC = contact.number;
    this.state.pathfile = contact.pathfile;
    this.state.contactid = contact.id;

    // this.props.ShowModalsMenu("modal__agenda-pf-usuario-detalhes");
    this.name.value = mensagem_tratada;
    // this.setState({ person: mensagem_tratada_display });
    // this.setState({
    //   person: mensagem_tratada_display,
    //   numberC: contact.number,
    //   pathfile: contact.pathfile,
    //   contatode: value,
    //   contactid: contact.id,
    //   private: contact.userid,
    // });
    // this.setState({ contatode: value });
    // this.setState({ contactid: contact.id });
    // this.setState({ private: contact.userid });
    if (contact.idempresa) {
      var value1 = [
        {
          value: contact.idempresa,
          label: contact.empresa,
          cnpj: contact.cnpj_empresa,
          externcode: contact.codigo_ext_empresa,
        },
      ];
      this.setState({ empresaC: value1, auxEmpresa: contact.idempresa });
      this.state.empresaC = value1;
      this.state.auxEmpresa = contact.idempresa;
    }
    // else {
    //   this.setState({ empresaC: null });
    //   this.setState({ auxEmpresa: "" });
    // }

    if (contact.userid !== null && contact.userid !== "") {
      document.getElementById(
        "modal__content__form__group__radios__option--sim",
      ).checked = true;
    } else {
      document.getElementById(
        "modal__content__form__group__radios__option--nao",
      ).checked = true;
    }

    if (edit) {
      // this.setState({ disabled: true });
      this.state.disabled = true;
    } else {
      // this.setState({ disabled: false, module: "edit" });
      this.state.disabled = false;
      this.state.module = "edit";
    }

    this.props.GetNumbersContact(contact.id);
    this.ObterListaResponsaveisPor(contact.id);
    this.props.GetDetailsContacts(true, "", "");
    this.props.GetTypeNumbers();

    setTimeout(() => {
      MicroModal.show("modal__agenda-pf-usuario-detalhes");
    }, 300);
  }

  handleTagContact(info, modeDisabled) {
    const {
      IPCurrent,
      PermissionRouter,
      OutBandService,
      InfoUsers,
      StatusAgent,
      listCallQueue,
      AtdSimult,
    } = this.props;
    let srcMidia = "";
    let labelMidia = "Telefone";

    switch (info.midiaid) {
      case 1:
        srcMidia = CALLCHAT;
        break;
      case 2:
        srcMidia = MIDIAWEB;
        labelMidia = "Webchat";
        break;
      case 3:
        srcMidia = MIDIAEMAIL;
        labelMidia = "Email";
        break;
      case 4:
        srcMidia = MIDIAFACE;
        labelMidia = "Facebook";
        break;
      case 5:
        srcMidia = MIDIAZAP;
        labelMidia = "Whatsapp";
        break;
      case 6:
        srcMidia = INSTAGRAM;
        labelMidia = "Instagram";
        break;
      case 8:
        srcMidia = MIDIATELEGRAM;
        labelMidia = "Telegram";
        break;
      case 9:
        srcMidia = TWITTER;
        labelMidia = "Twitter";
        break;
      case 10:
        srcMidia = LINKEDIN;
        labelMidia = "LinkedIn";
        break;
      case 11:
        srcMidia = GOOGLEGBM;
        labelMidia = "Google GBM";
        break;
      case 12:
        srcMidia = SMSICON;
        labelMidia = "Sms";
        break;
      case 15:
        srcMidia = TEAMS;
        labelMidia = "Teams";
        break;
      case 16:
        srcMidia = MIDIAZAPVOZ;
        labelMidia = "Whatsapp Voz";
        break;
      default:
        srcMidia = CALLCHAT;
        break;
    }

    if (modeDisabled) {
      return (
        <div
          className="icon-contactAction"
          onClick={(event) => {
            if (info.midiaid !== 3) {
              this.SolicitarChamadaAtiva(
                event,
                PermissionRouter,
                info.midiaid,
                OutBandService,
                InfoUsers,
                StatusAgent,
                listCallQueue,
                info.number,
                AtdSimult,
                IPCurrent,
                StatusAgent,
              );
            }
          }}
        >
          {info.midiaid === 3 ? (
            <a href={"mailto:" + info.number}>
              <img
                alt="Ícone da mídia de contato"
                width="24"
                height="24"
                src={srcMidia}
              />
            </a>
          ) : (
            <img
              alt="Ícone da mídia de contato"
              width="24"
              height="24"
              src={srcMidia}
            />
          )}
        </div>
      );
    } else {
      return (
        <div style={{ paddingRight: "10px" }} className="tag-contact">
          <img
            alt="Ícone da mídia de contato"
            width="16"
            height="16"
            src={srcMidia}
          />
          <Typography.H5 color={"gray-180"}>{labelMidia}</Typography.H5>
        </div>
      );
    }
  }

  listUsers() {
    if (this.props.UsersAgents.length != 0) {
      let Users = this.props.InfoUsers;

      optionsUsers = [
        ...this.props.UsersAgents,
        {
          iduser: Users.id,
          username: Users.displayname,
          desc_grupo: Users.grupo,
          id_grupo: 2,
          label: Users.displayname,
          ramal: Users.ramal,
          value: Users.id,
        },
      ];
    }
  }

  async listarCargos() {
    const response = await getContactPositions();
    const hasResponse = Boolean(response) && response.status === 200;
    if (!hasResponse) return this.setState({ todosCargos: [] });
    const hasData = Array.isArray(response.data);
    if (!hasData) return this.setState({ todosCargos: [] });
    const formatedData = response.data.map((cargoInfo) => {
      return {
        ...cargoInfo,
        label: cargoInfo.description,
        value: cargoInfo.id,
      };
    });
    this.setState({ todosCargos: formatedData });
  }

  async listarRelacoes() {
    const response = await getContactRelations();
    const hasResponse = Boolean(response) && response.status === 200;
    if (!hasResponse) return this.setState({ todasRelacoes: [] });
    const hasData = Array.isArray(response.data);
    if (!hasData) return this.setState({ todasRelacoes: [] });
    const formatedData = response.data.map((relacaoInfo) => {
      return {
        ...relacaoInfo,
        label: relacaoInfo.description,
        value: relacaoInfo.id,
      };
    });
    this.setState({ todasRelacoes: formatedData });
  }

  render() {
    const {
      Modals,
      Contacts,
      History,
      Companys,
      NumbersContact,
      IPCurrent,
      TypeNumbers,
      PermissionRouter,
      OutBandService,
      InfoUsers,
      StatusAgent,
      listCallQueue,
      returnCep,
      InteractionsNumber,
      PhoneMidia,
      AtdSimult,
      DetailsContacts,
    } = this.props;
    var options = optionsUsers;
    var companys = [];
    var typenumbers = [];

    let modeStorage = localStorage.getItem("manager__mode-screen");
    let modeTabShit = localStorage.getItem("manager__tabshit-mode");
    let modeScreen = localStorage.getItem("tela_atual_ingweb");

    const { searchText } = this.state;
    const searchWords = searchText.split(/\s/).filter((word) => word);
    var dia = "";
    var mes = "";
    var ano = "";
    var auxdia = "";

    const agora = Moment().subtract(7, "days");
    this.datainitinteract = agora.format("YYYY-MM-DDT00:00");
    this.datafiminteract = Moment().format("YYYY-MM-DDT23:59");

    if (Modals.length != 0) {
      var modal = Modals.modal;
      switch (modal) {
        case "modal__agenda":
          //MicroModal.show('modal__agenda');
          break;
        case "cadastro_contato":
          MicroModal.close("modal__agenda-pf-empresa-detalhes");
          MicroModal.show("modal__agenda-pj-empresa-detalhes-editar-salvo");
          setTimeout(() => {
            MicroModal.close("modal__agenda-pj-empresa-detalhes-editar-salvo");
            this.props.ShowModalsMenu("modal_pj-empresa");
          }, 3000);
          break;
        case "cadastro_company":
          MicroModal.close("modal__agenda-pj-empresa-detalhes");
          MicroModal.show(
            "modal__agenda-pj-empresa-detalhes-editar-salvo-company",
          );
          break;
      }
    }

    if (DetailsContacts.detailsget) {
      if (DetailsContacts.detailscontacts) {
        this.validateDetails(DetailsContacts.detailscontacts, true);
        this.state.detailsScript = {
          serverid: DetailsContacts.detailscontacts.serverid,
          cdr: DetailsContacts.detailscontacts.cdr,
        };
      }

      if (DetailsContacts.contactAdd) {
        this.ShowModalAddContact(
          InfoUsers.id,
          InfoUsers.displayname,
          DetailsContacts.contactAdd,
        );
        this.state.detailsScript = {
          serverid: DetailsContacts.contactAdd.serverid,
          cdr: DetailsContacts.contactAdd.idatendimento,
        };
      }
    }

    if (returnCep.length != 0) {
      this.fillCep(returnCep.cep);
    }

    if (NumbersContact.length != 0) {
      this.state.numberscontact = NumbersContact;
      NumbersContact.map((nb) => {
        if (nb.exist === true) {
          this.state.disabled = false;
        }
      });
    } else {
      this.state.numberscontact = [];
    }

    if (PhoneMidia.length != 0) {
      this.state.pathfile = PhoneMidia;
    } else {
      this.state.pathfile = null;
    }

    if (TypeNumbers.length != 0) {
      typenumbers = TypeNumbers.typenumbers;
    }

    if (InteractionsNumber.length != 0) {
      this.state.interactions = InteractionsNumber.interactions;
    }

    if (Contacts.length != 0) {
      this.state.Contacts = Contacts;
    } else {
      this.state.Contacts = [];
    }

    // if (UsersAgents.length != 0) {
    //   //options = UsersAgents;
    //   options = [
    //     ...UsersAgents,
    //     {
    //       iduser: InfoUsers.id,
    //       username: InfoUsers.displayname,
    //       desc_grupo: InfoUsers.grupo,
    //       id_grupo: 2,
    //       label: InfoUsers.displayname,
    //       ramal: InfoUsers.ramal,
    //       value: InfoUsers.id,
    //     },
    //   ];
    // }

    if (Companys.length != 0) {
      companys = Companys;
      this.state.companys = Companys;
    } else {
      companys = [];
      this.state.companys = [];
    }

    if (History.length) {
      this.state.history = History;
      let testarultimo = 0;
      var total = this.state.history[0];
      this.state.totalhistory = total.interacoes;
    } else {
      this.state.history = [];
    }

    if (this.state.buttonshowpfpj === true) {
      var TELAPJPF = "Empresas";
    } else {
      var TELAPJPF = "Contatos";
    }

    var voz = false;
    var zap = false;
    var face = false;
    var telegram = false;
    var instagram = false;
    var email = false;
    var twiter = false;
    var linkedin = false;
    var sms = false;
    var teams = false;
    var zapvoz = false;

    if (InfoUsers.user_midias) {
      for (var i = 0; i < InfoUsers.user_midias.length; i++) {
        if (InfoUsers.user_midias[i] === 1) voz = true;

        if (InfoUsers.user_midias[i] === 3) email = true;

        if (InfoUsers.user_midias[i] === 4) face = true;

        if (InfoUsers.user_midias[i] === 5) zap = true;

        if (InfoUsers.user_midias[i] === 6) instagram = true;

        if (InfoUsers.user_midias[i] === 8) telegram = true;

        if (InfoUsers.user_midias[i] === 9) twiter = true;

        if (InfoUsers.user_midias[i] === 10) linkedin = true;

        if (InfoUsers.user_midias[i] === 12) sms = true;

        if (InfoUsers.user_midias[i] === 15) teams = true;

        if (InfoUsers.user_midias[i] === 16) zapvoz = true;
      }
    }

    return (
      <div>
        <div
          className="modal micromodal-slide"
          id="modal__agenda"
          aria-hidden="true"
          role="dialog"
        >
          <input type="hidden" id="simulation_click" name="simulation_click" />
          <div className="modal__overlay agenda-index" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__agenda__title"
              style={{ maxHeight: "88%" }}
            >
              <header className="modal__header">
                <h2 className="modal__title" id="modal__agenda__title">
                  {TELAPJPF}
                </h2>
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  data-micromodal-close
                  onClick={(event) => this.CloseModals(event, "encerrarmodal")}
                ></button>
              </header>
              <main className="modal__content" id="modal__agenda__content">
                <div className="modal__content__tabs">
                  <div className="modal__content__tabs__header">
                    <a
                      className={
                        this.state.buttonshowpfpj
                          ? "modal__content__tabs__header__tab"
                          : "modal__content__tabs__header__tab is-active"
                      }
                      onClick={this.ShowPJPF.bind(this, "pf")}
                      data-tab="pf"
                    >
                      Pessoa Física
                    </a>
                    <a
                      className={
                        this.state.buttonshowpfpj
                          ? "modal__content__tabs__header__tab is-active"
                          : "modal__content__tabs__header__tab"
                      }
                      onClick={this.ShowPJPF.bind(this, "pj")}
                      data-tab="pj"
                    >
                      Pessoa Jurídica
                    </a>
                  </div>
                  <div className="modal__content__tabs__body">
                    <div
                      className={
                        this.state.buttonshowpfpj
                          ? "modal__content__tabs__body__tab"
                          : "modal__content__tabs__body__tab is-active"
                      }
                      data-tab="pf"
                    >
                      <p>Preencha os campos para buscar um contato.</p>
                      <Form
                        onSubmit={(event) => this.handleSubmit(event)}
                        schema={schema}
                        className="modal__content__form"
                      >
                        <div className="modal__content__form">
                          <div className="modal__content__form__group modal__content__form__group--col-2">
                            <label
                              className="modal__content__form__group__label"
                              htmlFor="modal__content__form__group__label--nome"
                            >
                              Nome:
                            </label>
                            <Input
                              value={this.state.nomeContato}
                              onChange={(event) => {
                                const newNomeContato = event.target.value;
                                this.setState({
                                  nomeContato: newNomeContato,
                                });
                              }}
                              type="text"
                              // id="nome"
                              name="nome"
                              className="modal__content__form__group__input"
                              id="modal__content__form__group__label--nome"
                            />
                          </div>

                          <div className="modal__content__form__group modal__content__form__group--col-2">
                            <label
                              className="modal__content__form__group__label"
                              htmlFor="modal__content__form__group__label--email"
                            >
                              E-mail:
                            </label>
                            <Input
                              value={this.state.emailContato}
                              onChange={(event) => {
                                const newEmailContato = event.target.value;
                                this.setState({
                                  emailContato: newEmailContato,
                                });
                              }}
                              type="text"
                              name="email"
                              className="modal__content__form__group__input modal__content__form__group__input--new-size"
                              id="modal__content__form__group__label--email"
                            />
                          </div>

                          <div className="modal__content__form__group modal__content__form__group--col-2">
                            <label
                              className="modal__content__form__group__label"
                              htmlFor="modal__content__form__group__label--telefone"
                            >
                              Telefone:
                            </label>
                            <Input
                              value={this.state.telefoneContato}
                              onChange={(event) => {
                                const newTelefoneContato = event.target.value;
                                this.setState({
                                  telefoneContato: newTelefoneContato,
                                });
                              }}
                              type="text"
                              name="telefone"
                              className="modal__content__form__group__input"
                              id="modal__content__form__group__label--telefone"
                            />
                          </div>

                          <div className="modal__content__form__group modal__content__form__group--col-2">
                            <label
                              className="modal__content__form__group__label"
                              htmlFor="modal__content__form__group__label--contato"
                            >
                              Contato de:
                            </label>
                            <Select
                              isDisabled={false}
                              onChange={this.handleChangeC}
                              // id="contato"
                              isLoading={false}
                              isClearable={true}
                              isRtl={false}
                              className="modal__content__form__group__input"
                              id="modal__content__form__group__label--contato"
                              options={options}
                              classNamePrefix=""
                              defaultValue={""}
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 2, // ou qualquer valor que você precise
                                }),
                              }}
                            />
                          </div>

                          {/*<div className="modal__content__form__group modal__content__form__group--col-2">
                            <label
                              className="modal__content__form__group__label"
                              htmlFor="modal__content__form__group__label--empresa"
                            >
                              Empresa 2:
                            </label>
                            <Select
                              isDisabled={false}
                              // id="empresa"
                              name="empresa"
                              onChange={this.handleChangeE}
                              isLoading={false}
                              isClearable={true}
                              isRtl={false}
                              className="modal__content__form__group__input"
                              id="modal__content__form__group__label--empresa"
                              options={companys}
                            />
                    </div>*/}

                          {/*
                            <div className="modal__content__form__group modal__content__form__group--col-2">
                              <label
                                className="modal__content__form__group__label"
                                htmlFor="modal__content__form__group__label--empresa"
                              >
                                Empresa 2:
                              </label>
                              <Select
                                isDisabled={false}
                                // id="empresa"
                                name="empresa"
                                onChange={this.handleChangeE}
                                isLoading={false}
                                isClearable={true}
                                isRtl={false}
                                className="modal__content__form__group__input"
                                id="modal__content__form__group__label--empresa"
                                options={companys}
                              />
                            </div>
                          */}

                          <div
                            style={{ width: "288.75px" }}
                            className="modal__content__form__group modal__content__form__group--col-2"
                          >
                            <label
                              className="modal__content__form__group__label"
                              htmlFor="modal__content__form__group__label--codigo"
                            >
                              Código Externo Contato:
                            </label>
                            <Input
                              value={this.state.codigoExternoContato}
                              onChange={(event) => {
                                const newCodigoExternoContato =
                                  event.target.value;
                                this.setState({
                                  codigoExternoContato: newCodigoExternoContato,
                                });
                              }}
                              type="text"
                              name="codext"
                              className="modal__content__form__group__input"
                              id="modal__content__form__group__label--codigo"
                            />
                          </div>

                          {
                            <div
                              style={{ width: "192.5px" }}
                              className="modal__content__form__group modal__content__form__group--col-2"
                            >
                              <label
                                className="modal__content__form__group__label"
                                htmlFor="modal__content__form__group__label--empresa"
                              >
                                Empresa:
                              </label>
                              <SelectSearchWithPagination
                                paginated
                                tooltip
                                style={{
                                  height: "38px",
                                  border: "1px solid #CCCCCC",
                                }}
                                value={
                                  this.state.empresa
                                    ? this.state.empresa
                                    : undefined
                                }
                                onSelect={(newCompany) => {
                                  if (newCompany) {
                                    this.setState({
                                      empresa: newCompany,
                                    });
                                  } else {
                                    this.setState({
                                      empresa: null,
                                    });
                                  }
                                }}
                                getOptions={getListCompanys}
                              />
                            </div>
                          }

                          <div className="modal__content__form__group modal__content__form__group--col-2">
                            <label
                              className="modal__content__form__group__label"
                              htmlFor="modal__content__form__group__label--codigo-empresa"
                            >
                              Código Externo Empresa:
                            </label>
                            <Input
                              value={this.state.externalCodeCompany}
                              onChange={(event) => {
                                const newExternalCodeCompany =
                                  event.target.value;
                                this.setState({
                                  externalCodeCompany: newExternalCodeCompany,
                                });
                              }}
                              type="text"
                              name="codextemp"
                              className="modal__content__form__group__input"
                              id="modal__content__form__group__label--codigo-empresa"
                            />
                          </div>

                          <div className="modal__content__form__group modal__content__form__group--col-1">
                            <button
                              type="submit"
                              id="button_filtrar_contact"
                              className="modal__content__form__group__button"
                            >
                              Filtrar
                            </button>
                          </div>
                        </div>
                      </Form>

                      <div
                        className={
                          "modal__content__tabs__body__tab__result" +
                          (this.state.Contacts && this.state.Contacts.length
                            ? " modal__content__tabs__body__tab__result--scroll-x"
                            : "")
                        }
                      >
                        <div
                          className="modal__content__tabs__body__tab__result__header"
                          style={{ zIndex: 2 }}
                        >
                          <div className="modal__content__tabs__body__tab__result__header__col modal__content__tabs__body__tab__result__header__col--0">
                            #
                          </div>
                          <div
                            className="modal__content__tabs__body__tab__result__header__col modal__content__tabs__body__tab__result__header__col--4"
                            style={{ width: "17%" }}
                          >
                            Nome
                          </div>
                          <div className="modal__content__tabs__body__tab__result__header__col modal__content__tabs__body__tab__result__header__col--25">
                            Empresa
                          </div>
                          <div className="modal__content__tabs__body__tab__result__header__col modal__content__tabs__body__tab__result__header__col--25">
                            CNPJ
                          </div>
                          <div
                            className="modal__content__tabs__body__tab__result__header__col modal__content__tabs__body__tab__result__header__col--3"
                            style={{ width: "10%" }}
                          >
                            Cod. Externo (Empresa)
                          </div>
                          <div className="modal__content__tabs__body__tab__result__header__col modal__content__tabs__body__tab__result__header__col--99">
                            Responsável Por
                          </div>
                          <div
                            className="modal__content__tabs__body__tab__result__header__col "
                            style={{ width: "500px" }}
                          >
                            Canais
                          </div>
                        </div>
                        <div className="modal__content__tabs__body__tab__result__body">
                          <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--letter">
                            A
                          </div>
                          {/* <!-- RESULT ROW --> */}

                          {(() => {
                            if (this.state.Contacts.length != 0) {
                              let checkdadoszap = false;
                              let checkdadosvoz = false;
                              let checkdadosface = false;
                              let checkdadosemail = false;
                              let checkdadostelegram = false;
                              let checkdadosinstagram = false;
                              let checkdadostwiter = false;
                              let checkdadoslinkedin = false;
                              let checkadossms = false;
                              let checkdadosgbm = false;
                              let checkdadosteams = false;
                              let checkdadoszapvoz = false;

                              let dadoszap = "";
                              let dadosvoz = "";
                              let dadosface = "";
                              let dadosemail = "";
                              let dostelegram = "";
                              let dadosinstagram = "";
                              let dadostwiter = "";
                              let dadoslinkedin = "";
                              let adossms = "";
                              let dadosgbm = "";
                              let dadostelegram = "";
                              let dadosteams = "";
                              let dadoszapvoz = "";

                              return (
                                <>
                                  {this.state.Contacts.map((contact, index) => (
                                    <div
                                      className="modal__content__tabs__body__tab__result__body__row"
                                      key={index}
                                      style={{ paddingRight: "40px" }}
                                    >
                                      <div
                                        className="modal__content__tabs__body__tab__result__body__col "
                                        style={{ width: "3%" }}
                                      >
                                        {(() => {
                                          var objPhone = JSON.parse(
                                            contact.phone_midia,
                                          );

                                          dadoszap = objPhone.filter(
                                            (recipient) =>
                                              recipient.midiaid === 5,
                                          );
                                          dadosvoz = objPhone.filter(
                                            (recipient) =>
                                              recipient.midiaid === 1,
                                          );
                                          dadosface = objPhone.filter(
                                            (recipient) =>
                                              recipient.midiaid === 4,
                                          );
                                          dadosemail = objPhone.filter(
                                            (recipient) =>
                                              recipient.midiaid === 3,
                                          );
                                          dadostelegram = objPhone.filter(
                                            (recipient) =>
                                              recipient.midiaid === 8,
                                          );
                                          dadosinstagram = objPhone.filter(
                                            (recipient) =>
                                              recipient.midiaid === 6,
                                          );
                                          dadostwiter = objPhone.filter(
                                            (recipient) =>
                                              recipient.midiaid === 9,
                                          );
                                          dadoslinkedin = objPhone.filter(
                                            (recipient) =>
                                              recipient.midiaid === 10,
                                          );
                                          dadosgbm = objPhone.filter(
                                            (recipient) =>
                                              recipient.midiaid === 11,
                                          );
                                          dadosteams = objPhone.filter(
                                            (recipient) =>
                                              recipient.midiaid === 15,
                                          );
                                          dadoszapvoz = objPhone.filter(
                                            (recipient) =>
                                              recipient.midiaid === 16,
                                          );

                                          checkdadoszap =
                                            dadoszap.length > 0 ? true : false;
                                          checkdadosvoz =
                                            dadosvoz.length > 0 ? true : false;
                                          checkdadosface =
                                            dadosface.length > 0 ? true : false;
                                          checkdadosemail =
                                            dadosemail.length > 0
                                              ? true
                                              : false;
                                          checkdadostelegram =
                                            dadostelegram.length > 0
                                              ? true
                                              : false;
                                          checkdadosinstagram =
                                            dadosinstagram.length > 0
                                              ? true
                                              : false;
                                          checkdadostwiter =
                                            dadostwiter.length > 0
                                              ? true
                                              : false;
                                          checkdadoslinkedin =
                                            dadoslinkedin.length > 0
                                              ? true
                                              : false;
                                          checkdadosgbm =
                                            dadosgbm.length > 0 ? true : false;
                                          checkdadosteams =
                                            dadosteams.length > 0
                                              ? true
                                              : false;
                                          checkdadoszapvoz =
                                            dadoszapvoz.length > 0
                                              ? true
                                              : false;

                                          if (checkdadoszap)
                                            contact.numberZap =
                                              dadoszap[0].number;

                                          if (checkdadosvoz)
                                            contact.numberVoz =
                                              dadosvoz[0].number;

                                          if (checkdadosface)
                                            contact.numberFace =
                                              dadosface[0].number;

                                          if (checkdadosemail)
                                            contact.numberMail =
                                              dadosemail[0].number;

                                          if (checkdadostelegram)
                                            contact.numberTelegram =
                                              dadostelegram[0].number;

                                          if (checkdadosinstagram)
                                            contact.numberInsta =
                                              dadosinstagram[0].number;

                                          if (checkdadostwiter)
                                            contact.numberTwiter =
                                              dadostwiter[0].number;

                                          if (checkdadoslinkedin)
                                            contact.numberLinkedin =
                                              dadoslinkedin[0].number;

                                          if (checkdadosgbm)
                                            contact.numberGbm =
                                              dadosgbm[0].number;

                                          if (checkdadosteams)
                                            contact.numberTeams =
                                              dadosteams[0].number;

                                          if (checkdadoszapvoz)
                                            contact.numberZapVoz =
                                              dadoszapvoz[0].number;

                                          // numeroCliente = contact.number;
                                          if (checkdadoszap) {
                                            if (dadoszap[0].pathfile != "") {
                                              return (
                                                // <div className="user-photo">
                                                <Topover
                                                  interactive={true}
                                                  content={this.renderPopoverPhotoContact(
                                                    this,
                                                    connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      dadoszap[0].pathfile,
                                                  )}
                                                >
                                                  {/* <img
                                                            src={
                                                              contact.pathfile
                                                                ? connection_platform.type_connect +
                                                                  "://" +
                                                                  ipcurrent +
                                                                  contact.pathfile
                                                                : null
                                                            }
                                                          /> */}
                                                  <UserPhoto
                                                    link={
                                                      dadoszap[0].pathfile
                                                        ? connection_platform.type_connect +
                                                          "://" +
                                                          ipcurrent +
                                                          dadoszap[0].pathfile
                                                        : null
                                                    }
                                                  />
                                                </Topover>

                                                // </div>
                                              );
                                            } else {
                                              return (
                                                // <div className="user-photo"></div>
                                                <UserPhoto />
                                              );
                                            }
                                          } else {
                                            return (
                                              // <div className="user-photo"></div>
                                              <UserPhoto />
                                            );
                                          }
                                        })()}
                                      </div>
                                      <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--5">
                                        <div className="user">
                                          {(() => {
                                            var mensagem_tratada = createJSON(
                                              contact.name,
                                            );
                                            return (
                                              <Tooltippy
                                                content={
                                                  mensagem_tratada
                                                    ? mensagem_tratada
                                                    : ""
                                                }
                                              >
                                                <div className="user-name">
                                                  {reduceString(
                                                    mensagem_tratada,
                                                    26,
                                                  )}
                                                  {/* {mensagem_tratada} */}
                                                </div>
                                              </Tooltippy>
                                            );
                                          })()}
                                          <div className="user-phone">
                                            {contact.number}
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--3"
                                        style={{ width: "10%" }}
                                      >
                                        <div className="user">
                                          <div className="user-name">
                                            {contact.empresa}
                                          </div>
                                          &nbsp;
                                        </div>
                                      </div>
                                      <div
                                        className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--3"
                                        style={{ width: "10%" }}
                                      >
                                        <div className="user">
                                          <div className="user-phone">
                                            {contact.cnpj_empresa}
                                          </div>
                                          &nbsp;
                                        </div>
                                      </div>
                                      <div
                                        className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--3"
                                        style={{ width: "10%" }}
                                      >
                                        <div className="user">
                                          <div className="user-phone">
                                            {contact.externcode_company}
                                          </div>
                                          &nbsp;
                                        </div>
                                      </div>
                                      <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--99">
                                        <div className="user">
                                          <div className="user-phone">
                                            <ListOfTags
                                              maxTagsToShow={1}
                                              tags={
                                                Array.isArray(
                                                  contact.empresas_responsavel,
                                                )
                                                  ? contact.empresas_responsavel.map(
                                                      (empresa) => ({
                                                        id: empresa.id,
                                                        label: empresa.nome,
                                                      }),
                                                    )
                                                  : []
                                              }
                                            />
                                          </div>
                                          {/* &nbsp; */}
                                        </div>
                                      </div>
                                      <div
                                        className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--6"
                                        style={{ width: "380px" }}
                                      >
                                        <div className="modal__content__tabs__body__tab__result__body__channels modal__content__tabs__body__tab__result__body__channels-new">
                                          {(() => {
                                            if (checkdadosvoz) {
                                              return (
                                                <SelectRouteActiveCall
                                                  size="small"
                                                  key={contact.numberVoz}
                                                  midiaId={1}
                                                  numeroDoCliente={
                                                    contact.numberVoz
                                                  }
                                                  onChooseRoute={(
                                                    event,
                                                    selectedRoute,
                                                  ) => {
                                                    this.SolicitarChamadaAtiva(
                                                      event,
                                                      selectedRoute,
                                                      1,
                                                      OutBandService,
                                                      InfoUsers,
                                                      StatusAgent,
                                                      listCallQueue,
                                                      contact.numberVoz,
                                                      AtdSimult,
                                                      IPCurrent,
                                                      StatusAgent,
                                                    );
                                                  }}
                                                />
                                              );
                                            } else {
                                              return (
                                                <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled fill">
                                                  <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled__midia-icon">
                                                    <VOZICONDISABLED />
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })()}

                                          {(() => {
                                            if (checkdadoszap) {
                                              return (
                                                <SelectRouteActiveCall
                                                  size="small"
                                                  midiaId={5}
                                                  onChooseRoute={(
                                                    event,
                                                    selectedRoute,
                                                  ) => {
                                                    this.SolicitarChamadaAtiva(
                                                      event,
                                                      selectedRoute,
                                                      5,
                                                      OutBandService,
                                                      InfoUsers,
                                                      StatusAgent,
                                                      listCallQueue,
                                                      contact.numberZap,
                                                      AtdSimult,
                                                      IPCurrent,
                                                      StatusAgent,
                                                    );
                                                  }}
                                                />
                                              );
                                            } else {
                                              return (
                                                <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled fill">
                                                  <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled__midia-icon">
                                                    <WHATSAPPICONDISABLED />
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })()}

                                          {(() => {
                                            if (checkdadosface) {
                                              return (
                                                <SelectRouteActiveCall
                                                  size="small"
                                                  midiaId={4}
                                                  onChooseRoute={(
                                                    event,
                                                    selectedRoute,
                                                  ) => {
                                                    this.SolicitarChamadaAtiva(
                                                      event,
                                                      selectedRoute,
                                                      4,
                                                      OutBandService,
                                                      InfoUsers,
                                                      StatusAgent,
                                                      listCallQueue,
                                                      contact.numberFace,
                                                      AtdSimult,
                                                      IPCurrent,
                                                      StatusAgent,
                                                    );
                                                  }}
                                                />
                                                // <div
                                                //   onClick={(event) =>
                                                //     this.SolicitarChamadaAtiva(
                                                //       event,
                                                //       PermissionRouter,
                                                //       4,
                                                //       OutBandService,
                                                //       InfoUsers,
                                                //       StatusAgent,
                                                //       listCallQueue,
                                                //       contact.numberFace,
                                                //       AtdSimult,
                                                //       IPCurrent,
                                                //       StatusAgent
                                                //     )
                                                //   }
                                                //   className={
                                                //     face
                                                //       ? "modal__content__tabs__body__tab__result__body__channels__channel"
                                                //       : "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <svg
                                                //     width="22"
                                                //     height="22"
                                                //     viewBox="0 0 32 32"
                                                //     fill="none"
                                                //     xmlns="http://www.w3.org/2000/svg"
                                                //   >
                                                //     <circle
                                                //       cx="16"
                                                //       cy="16"
                                                //       r="16"
                                                //       fill="#1877F2"
                                                //     />
                                                //     <path
                                                //       d="M19.4758 16.8854L19.8904 14.1553H17.2968V12.3845C17.2968 11.6374 17.6584 10.9087 18.8201 10.9087H20V8.58446C20 8.58446 18.9297 8.39999 17.9068 8.39999C15.7699 8.39999 14.3744 9.70786 14.3744 12.0746V14.1553H12V16.8854H14.3744V23.4856C14.8511 23.5613 15.3388 23.6 15.8356 23.6C16.3324 23.6 16.8201 23.5613 17.2968 23.4856V16.8854H19.4758Z"
                                                //       fill="white"
                                                //     />
                                                //   </svg>
                                                // </div>
                                              );
                                            } else {
                                              return (
                                                <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled fill">
                                                  <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled__midia-icon">
                                                    <FACEBOOKICONDISABLED />
                                                  </div>
                                                  {/* <div
                                                    style={{
                                                      width: "100%",
                                                      height: "16.8px",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <ArrowDown2
                                                      size="8"
                                                      color="#455cc7"
                                                    />
                                                  </div> */}
                                                </div>
                                                // <div
                                                //   className={
                                                //     "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <svg
                                                //     width="22"
                                                //     height="22"
                                                //     viewBox="0 0 32 32"
                                                //     fill="none"
                                                //     xmlns="http://www.w3.org/2000/svg"
                                                //   >
                                                //     <circle
                                                //       cx="16"
                                                //       cy="16"
                                                //       r="16"
                                                //       fill="#1877F2"
                                                //     />
                                                //     <path
                                                //       d="M19.4758 16.8854L19.8904 14.1553H17.2968V12.3845C17.2968 11.6374 17.6584 10.9087 18.8201 10.9087H20V8.58446C20 8.58446 18.9297 8.39999 17.9068 8.39999C15.7699 8.39999 14.3744 9.70786 14.3744 12.0746V14.1553H12V16.8854H14.3744V23.4856C14.8511 23.5613 15.3388 23.6 15.8356 23.6C16.3324 23.6 16.8201 23.5613 17.2968 23.4856V16.8854H19.4758Z"
                                                //       fill="white"
                                                //     />
                                                //   </svg>
                                                // </div>
                                              );
                                            }
                                          })()}

                                          {(() => {
                                            if (checkdadosemail) {
                                              return (
                                                <SelectRouteActiveCall
                                                  size="small"
                                                  midiaId={3}
                                                  onChooseRoute={(
                                                    event,
                                                    selectedRoute,
                                                  ) => {
                                                    this.SolicitarChamadaAtiva(
                                                      event,
                                                      selectedRoute,
                                                      3,
                                                      OutBandService,
                                                      InfoUsers,
                                                      StatusAgent,
                                                      listCallQueue,
                                                      contact.numberMail,
                                                      AtdSimult,
                                                      IPCurrent,
                                                      StatusAgent,
                                                    );
                                                  }}
                                                />
                                                // <a
                                                //   onClick={(event) =>
                                                //     this.SolicitarChamadaAtiva(
                                                //       event,
                                                //       PermissionRouter,
                                                //       3,
                                                //       OutBandService,
                                                //       InfoUsers,
                                                //       StatusAgent,
                                                //       listCallQueue,
                                                //       contact.numberMail,
                                                //       AtdSimult,
                                                //       IPCurrent,
                                                //       StatusAgent
                                                //     )
                                                //   }
                                                //   href={
                                                //     "mailto:suporte@ingenium-systems.com.br?subject=Numero para contato:" +
                                                //     contact.numberMail
                                                //   }
                                                //   className={
                                                //     email
                                                //       ? "modal__content__tabs__body__tab__result__body__channels__channel"
                                                //       : "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <svg
                                                //     width="22"
                                                //     height="22"
                                                //     viewBox="0 0 32 32"
                                                //     fill="none"
                                                //     xmlns="http://www.w3.org/2000/svg"
                                                //   >
                                                //     <circle
                                                //       cx="16"
                                                //       cy="16"
                                                //       r="16"
                                                //       fill="#FFBB00"
                                                //     />
                                                //     <path
                                                //       fillRule="evenodd"
                                                //       clipRule="evenodd"
                                                //       d="M9.12923 10.0308C8.59283 10.1361 8.13686 10.6014 8.0329 11.1496C7.98903 11.3809 7.98903 19.8616 8.0329 20.0928C8.13933 20.654 8.59252 21.1072 9.1537 21.2136C9.3863 21.2578 22.6137 21.2578 22.8463 21.2136C23.4075 21.1072 23.8607 20.654 23.9671 20.0928C24.011 19.8616 24.011 11.3809 23.9671 11.1496C23.8607 10.5885 23.4075 10.1353 22.8463 10.0288C22.6371 9.98917 9.33152 9.99101 9.12923 10.0308ZM19.6407 13.6721C17.7669 15.536 16.8367 16.44 16.7192 16.5112C16.2813 16.7767 15.7187 16.7767 15.2808 16.5112C15.1633 16.44 14.2331 15.536 12.3593 13.6721L9.61017 10.9376H16H22.3898L19.6407 13.6721ZM11.7348 14.3694L12.9845 15.6213L11.4223 17.1856C10.5631 18.0459 9.65273 18.9475 9.39926 19.1889L8.93838 19.6279V15.6211V11.6143L9.71172 12.3659C10.1371 12.7793 11.0474 13.6809 11.7348 14.3694ZM23.054 17.6288L23.046 19.6364L21.0306 17.6282L19.0152 15.6199L21.0306 13.6152L23.046 11.6106L23.054 13.6159C23.0585 14.7189 23.0585 16.5246 23.054 17.6288ZM13.9852 16.6229C14.5507 17.1928 14.8783 17.4196 15.3438 17.5637C15.54 17.6244 15.6469 17.6362 16 17.6362C16.4804 17.6362 16.7309 17.5777 17.0936 17.381C17.3622 17.2353 17.5041 17.1192 17.9594 16.6728L18.3409 16.2988L19.0843 17.0204C19.4931 17.4172 20.4041 18.3193 21.1086 19.025L22.3895 20.3082L15.9998 20.3068L9.61017 20.3055L11.6196 18.3071C12.7248 17.208 13.639 16.3087 13.6512 16.3087C13.6634 16.3087 13.8137 16.4501 13.9852 16.6229Z"
                                                //       fill="white"
                                                //     />
                                                //   </svg>
                                                // </a>
                                              );
                                            } else {
                                              return (
                                                <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled fill stroke">
                                                  <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled__midia-icon">
                                                    <EMAILICONDISABLED />
                                                  </div>
                                                  {/* <div
                                                    style={{
                                                      width: "100%",
                                                      height: "16.8px",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <ArrowDown2
                                                      size="8"
                                                      color="#455cc7"
                                                    />
                                                  </div> */}
                                                </div>
                                                // <a
                                                //   className={
                                                //     "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <svg
                                                //     width="22"
                                                //     height="22"
                                                //     viewBox="0 0 32 32"
                                                //     fill="none"
                                                //     xmlns="http://www.w3.org/2000/svg"
                                                //   >
                                                //     <circle
                                                //       cx="16"
                                                //       cy="16"
                                                //       r="16"
                                                //       fill="#FFBB00"
                                                //     />
                                                //     <path
                                                //       fillRule="evenodd"
                                                //       clipRule="evenodd"
                                                //       d="M9.12923 10.0308C8.59283 10.1361 8.13686 10.6014 8.0329 11.1496C7.98903 11.3809 7.98903 19.8616 8.0329 20.0928C8.13933 20.654 8.59252 21.1072 9.1537 21.2136C9.3863 21.2578 22.6137 21.2578 22.8463 21.2136C23.4075 21.1072 23.8607 20.654 23.9671 20.0928C24.011 19.8616 24.011 11.3809 23.9671 11.1496C23.8607 10.5885 23.4075 10.1353 22.8463 10.0288C22.6371 9.98917 9.33152 9.99101 9.12923 10.0308ZM19.6407 13.6721C17.7669 15.536 16.8367 16.44 16.7192 16.5112C16.2813 16.7767 15.7187 16.7767 15.2808 16.5112C15.1633 16.44 14.2331 15.536 12.3593 13.6721L9.61017 10.9376H16H22.3898L19.6407 13.6721ZM11.7348 14.3694L12.9845 15.6213L11.4223 17.1856C10.5631 18.0459 9.65273 18.9475 9.39926 19.1889L8.93838 19.6279V15.6211V11.6143L9.71172 12.3659C10.1371 12.7793 11.0474 13.6809 11.7348 14.3694ZM23.054 17.6288L23.046 19.6364L21.0306 17.6282L19.0152 15.6199L21.0306 13.6152L23.046 11.6106L23.054 13.6159C23.0585 14.7189 23.0585 16.5246 23.054 17.6288ZM13.9852 16.6229C14.5507 17.1928 14.8783 17.4196 15.3438 17.5637C15.54 17.6244 15.6469 17.6362 16 17.6362C16.4804 17.6362 16.7309 17.5777 17.0936 17.381C17.3622 17.2353 17.5041 17.1192 17.9594 16.6728L18.3409 16.2988L19.0843 17.0204C19.4931 17.4172 20.4041 18.3193 21.1086 19.025L22.3895 20.3082L15.9998 20.3068L9.61017 20.3055L11.6196 18.3071C12.7248 17.208 13.639 16.3087 13.6512 16.3087C13.6634 16.3087 13.8137 16.4501 13.9852 16.6229Z"
                                                //       fill="white"
                                                //     />
                                                //   </svg>
                                                // </a>
                                              );
                                            }
                                          })()}

                                          {(() => {
                                            if (checkdadostelegram) {
                                              return (
                                                <SelectRouteActiveCall
                                                  size="small"
                                                  midiaId={8}
                                                  onChooseRoute={(
                                                    event,
                                                    selectedRoute,
                                                  ) => {
                                                    this.SolicitarChamadaAtiva(
                                                      event,
                                                      selectedRoute,
                                                      8,
                                                      OutBandService,
                                                      InfoUsers,
                                                      StatusAgent,
                                                      listCallQueue,
                                                      contact.numberTelegram,
                                                      AtdSimult,
                                                      IPCurrent,
                                                      StatusAgent,
                                                    );
                                                  }}
                                                />
                                                // <div
                                                //   onClick={(event) =>
                                                //     this.SolicitarChamadaAtiva(
                                                //       event,
                                                //       PermissionRouter,
                                                //       8,
                                                //       OutBandService,
                                                //       InfoUsers,
                                                //       StatusAgent,
                                                //       listCallQueue,
                                                //       contact.numberTelegram,
                                                //       AtdSimult,
                                                //       IPCurrent,
                                                //       StatusAgent
                                                //     )
                                                //   }
                                                //   className={
                                                //     telegram
                                                //       ? "modal__content__tabs__body__tab__result__body__channels__channel"
                                                //       : "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <svg
                                                //     width="22"
                                                //     height="22"
                                                //     viewBox="0 0 32 32"
                                                //     fill="none"
                                                //     xmlns="http://www.w3.org/2000/svg"
                                                //   >
                                                //     <circle
                                                //       cx="16"
                                                //       cy="16"
                                                //       r="16"
                                                //       fill={
                                                //         telegram
                                                //           ? "#27A5E5"
                                                //           : "#b7bec5"
                                                //       }
                                                //     />
                                                //     <path
                                                //       fillRule="evenodd"
                                                //       clipRule="evenodd"
                                                //       d="M9.66208 15.1659C13.549 13.4724 16.1409 12.356 17.4378 11.8166C21.1406 10.2765 21.91 10.0089 22.4115 10.0001C22.5218 9.99815 22.7684 10.0255 22.9282 10.1551C23.0631 10.2646 23.1002 10.4124 23.1179 10.5162C23.1357 10.62 23.1578 10.8564 23.1402 11.0411C22.9396 13.1494 22.0713 18.2657 21.6296 20.6271C21.4427 21.6262 21.0747 21.9613 20.7184 21.994C19.9441 22.0653 19.3562 21.4823 18.6062 20.9907C17.4327 20.2215 16.7698 19.7426 15.6307 18.992C14.3142 18.1245 15.1676 17.6477 15.9178 16.8685C16.1142 16.6646 19.5257 13.5615 19.5918 13.28C19.6 13.2448 19.6077 13.1136 19.5297 13.0443C19.4518 12.975 19.3367 12.9987 19.2537 13.0175C19.136 13.0442 17.2613 14.2833 13.6296 16.7348C13.0975 17.1002 12.6155 17.2783 12.1836 17.2689C11.7076 17.2586 10.7918 16.9997 10.111 16.7785C9.27602 16.507 8.61238 16.3635 8.67016 15.9026C8.70026 15.6625 9.0309 15.4169 9.66208 15.1659Z"
                                                //       fill="white"
                                                //     />
                                                //   </svg>
                                                // </div>
                                              );
                                            } else {
                                              return (
                                                <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled fill">
                                                  <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled__midia-icon">
                                                    <TELEGRAMICONDISABLED />
                                                  </div>
                                                  {/* <div
                                                    style={{
                                                      width: "100%",
                                                      height: "16.8px",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <ArrowDown2
                                                      size="8"
                                                      color="#455cc7"
                                                    />
                                                  </div> */}
                                                </div>
                                                // <div
                                                //   className={
                                                //     "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <svg
                                                //     width="22"
                                                //     height="22"
                                                //     viewBox="0 0 32 32"
                                                //     fill="none"
                                                //     xmlns="http://www.w3.org/2000/svg"
                                                //   >
                                                //     <circle
                                                //       cx="16"
                                                //       cy="16"
                                                //       r="16"
                                                //       fill={
                                                //         telegram
                                                //           ? "#27A5E5"
                                                //           : "#b7bec5"
                                                //       }
                                                //     />
                                                //     <path
                                                //       fillRule="evenodd"
                                                //       clipRule="evenodd"
                                                //       d="M9.66208 15.1659C13.549 13.4724 16.1409 12.356 17.4378 11.8166C21.1406 10.2765 21.91 10.0089 22.4115 10.0001C22.5218 9.99815 22.7684 10.0255 22.9282 10.1551C23.0631 10.2646 23.1002 10.4124 23.1179 10.5162C23.1357 10.62 23.1578 10.8564 23.1402 11.0411C22.9396 13.1494 22.0713 18.2657 21.6296 20.6271C21.4427 21.6262 21.0747 21.9613 20.7184 21.994C19.9441 22.0653 19.3562 21.4823 18.6062 20.9907C17.4327 20.2215 16.7698 19.7426 15.6307 18.992C14.3142 18.1245 15.1676 17.6477 15.9178 16.8685C16.1142 16.6646 19.5257 13.5615 19.5918 13.28C19.6 13.2448 19.6077 13.1136 19.5297 13.0443C19.4518 12.975 19.3367 12.9987 19.2537 13.0175C19.136 13.0442 17.2613 14.2833 13.6296 16.7348C13.0975 17.1002 12.6155 17.2783 12.1836 17.2689C11.7076 17.2586 10.7918 16.9997 10.111 16.7785C9.27602 16.507 8.61238 16.3635 8.67016 15.9026C8.70026 15.6625 9.0309 15.4169 9.66208 15.1659Z"
                                                //       fill="white"
                                                //     />
                                                //   </svg>
                                                // </div>
                                              );
                                            }
                                          })()}

                                          {(() => {
                                            if (checkdadosinstagram) {
                                              return (
                                                <SelectRouteActiveCall
                                                  size="small"
                                                  midiaId={6}
                                                  onChooseRoute={(
                                                    event,
                                                    selectedRoute,
                                                  ) => {
                                                    this.SolicitarChamadaAtiva(
                                                      event,
                                                      selectedRoute,
                                                      6,
                                                      OutBandService,
                                                      InfoUsers,
                                                      StatusAgent,
                                                      listCallQueue,
                                                      contact.numberInsta,
                                                      AtdSimult,
                                                      IPCurrent,
                                                      StatusAgent,
                                                    );
                                                  }}
                                                />
                                                // <div
                                                //   onClick={(event) =>
                                                //     this.SolicitarChamadaAtiva(
                                                //       event,
                                                //       PermissionRouter,
                                                //       6,
                                                //       OutBandService,
                                                //       InfoUsers,
                                                //       StatusAgent,
                                                //       listCallQueue,
                                                //       contact.numberInsta,
                                                //       AtdSimult,
                                                //       IPCurrent,
                                                //       StatusAgent
                                                //     )
                                                //   }
                                                //   className={
                                                //     instagram
                                                //       ? "modal__content__tabs__body__tab__result__body__channels__channel"
                                                //       : "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <svg
                                                //     width="22"
                                                //     height="22"
                                                //     viewBox="0 0 32 32"
                                                //     fill="none"
                                                //     xmlns="http://www.w3.org/2000/svg"
                                                //   >
                                                //     <circle
                                                //       cx="16"
                                                //       cy="16"
                                                //       r="16"
                                                //       fill={
                                                //         instagram
                                                //           ? "#F00073"
                                                //           : "#b7bec5"
                                                //       }
                                                //     />
                                                //     <path
                                                //       d="M15.9984 9.44156C18.1354 9.44156 18.3862 9.45108 19.2308 9.48918C20.0119 9.52411 20.4342 9.6543 20.7168 9.76543C21.0915 9.91149 21.3582 10.083 21.6376 10.3624C21.9171 10.6418 22.0917 10.9085 22.2346 11.2832C22.3425 11.5658 22.4759 11.9881 22.5108 12.7692C22.5489 13.6138 22.5585 13.8647 22.5585 16.0016C22.5585 18.1385 22.5489 18.3894 22.5108 19.234C22.4759 20.0151 22.3457 20.4374 22.2346 20.72C22.0885 21.0947 21.9171 21.3614 21.6376 21.6408C21.3582 21.9202 21.0915 22.0949 20.7168 22.2377C20.4342 22.3457 20.0119 22.4791 19.2308 22.514C18.3862 22.5521 18.1354 22.5616 15.9984 22.5616C13.8615 22.5616 13.6106 22.5521 12.766 22.514C11.9849 22.4791 11.5626 22.3489 11.28 22.2377C10.9053 22.0917 10.6386 21.9202 10.3592 21.6408C10.0798 21.3614 9.90514 21.0947 9.76226 20.72C9.6543 20.4374 9.52094 20.0151 9.48601 19.234C9.44791 18.3894 9.43838 18.1385 9.43838 16.0016C9.43838 13.8647 9.44791 13.6138 9.48601 12.7692C9.52094 11.9881 9.65112 11.5658 9.76226 11.2832C9.90832 10.9085 10.0798 10.6418 10.3592 10.3624C10.6386 10.083 10.9053 9.90832 11.28 9.76543C11.5626 9.65747 11.9849 9.52411 12.766 9.48918C13.6106 9.44791 13.8647 9.44156 15.9984 9.44156ZM15.9984 8C13.8266 8 13.5535 8.00953 12.6993 8.04763C11.8484 8.08573 11.2673 8.22227 10.7593 8.41913C10.2322 8.62235 9.78766 8.89859 9.34312 9.34312C8.89859 9.78766 8.62552 10.2354 8.41913 10.7593C8.22227 11.2673 8.08573 11.8484 8.04763 12.7025C8.00953 13.5535 8 13.8266 8 15.9984C8 18.1703 8.00953 18.4433 8.04763 19.2975C8.08573 20.1484 8.22227 20.7295 8.41913 21.2407C8.62235 21.7678 8.89859 22.2123 9.34312 22.6569C9.78766 23.1014 10.2354 23.3745 10.7593 23.5809C11.2673 23.7777 11.8484 23.9143 12.7025 23.9524C13.5567 23.9905 13.8266 24 16.0016 24C18.1766 24 18.4465 23.9905 19.3007 23.9524C20.1516 23.9143 20.7327 23.7777 21.2439 23.5809C21.771 23.3777 22.2155 23.1014 22.6601 22.6569C23.1046 22.2123 23.3777 21.7646 23.5841 21.2407C23.7809 20.7327 23.9175 20.1516 23.9556 19.2975C23.9937 18.4433 24.0032 18.1734 24.0032 15.9984C24.0032 13.8234 23.9937 13.5535 23.9556 12.6993C23.9175 11.8484 23.7809 11.2673 23.5841 10.7561C23.3808 10.229 23.1046 9.78448 22.6601 9.33995C22.2155 8.89542 21.7678 8.62235 21.2439 8.41596C20.7359 8.21909 20.1548 8.08256 19.3007 8.04445C18.4433 8.00953 18.1703 8 15.9984 8Z"
                                                //       fill="white"
                                                //     />
                                                //     <path
                                                //       d="M15.9984 11.8928C13.7313 11.8928 11.8897 13.7313 11.8897 16.0016C11.8897 18.2719 13.7281 20.1103 15.9984 20.1103C18.2687 20.1103 20.1072 18.2719 20.1072 16.0016C20.1072 13.7313 18.2687 11.8928 15.9984 11.8928ZM15.9984 18.6656C14.5251 18.6656 13.3312 17.4717 13.3312 15.9984C13.3312 14.5251 14.5251 13.3312 15.9984 13.3312C17.4717 13.3312 18.6656 14.5251 18.6656 15.9984C18.6656 17.4717 17.4717 18.6656 15.9984 18.6656Z"
                                                //       fill="white"
                                                //     />
                                                //     <path
                                                //       d="M20.2691 12.6866C20.7987 12.6866 21.228 12.2573 21.228 11.7277C21.228 11.1981 20.7987 10.7688 20.2691 10.7688C19.7395 10.7688 19.3102 11.1981 19.3102 11.7277C19.3102 12.2573 19.7395 12.6866 20.2691 12.6866Z"
                                                //       fill="white"
                                                //     />
                                                //   </svg>
                                                // </div>
                                              );
                                            } else {
                                              return (
                                                <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled fill">
                                                  <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled__midia-icon">
                                                    <INSTAGRAMDISABLED />
                                                  </div>
                                                  {/* <div
                                                    style={{
                                                      width: "100%",
                                                      height: "16.8px",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <ArrowDown2
                                                      size="8"
                                                      color="#455cc7"
                                                    />
                                                  </div> */}
                                                </div>
                                                // <div
                                                //   className={
                                                //     "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <svg
                                                //     width="22"
                                                //     height="22"
                                                //     viewBox="0 0 32 32"
                                                //     fill="none"
                                                //     xmlns="http://www.w3.org/2000/svg"
                                                //   >
                                                //     <circle
                                                //       cx="16"
                                                //       cy="16"
                                                //       r="16"
                                                //       fill={
                                                //         instagram
                                                //           ? "#F00073"
                                                //           : "#b7bec5"
                                                //       }
                                                //     />
                                                //     <path
                                                //       d="M15.9984 9.44156C18.1354 9.44156 18.3862 9.45108 19.2308 9.48918C20.0119 9.52411 20.4342 9.6543 20.7168 9.76543C21.0915 9.91149 21.3582 10.083 21.6376 10.3624C21.9171 10.6418 22.0917 10.9085 22.2346 11.2832C22.3425 11.5658 22.4759 11.9881 22.5108 12.7692C22.5489 13.6138 22.5585 13.8647 22.5585 16.0016C22.5585 18.1385 22.5489 18.3894 22.5108 19.234C22.4759 20.0151 22.3457 20.4374 22.2346 20.72C22.0885 21.0947 21.9171 21.3614 21.6376 21.6408C21.3582 21.9202 21.0915 22.0949 20.7168 22.2377C20.4342 22.3457 20.0119 22.4791 19.2308 22.514C18.3862 22.5521 18.1354 22.5616 15.9984 22.5616C13.8615 22.5616 13.6106 22.5521 12.766 22.514C11.9849 22.4791 11.5626 22.3489 11.28 22.2377C10.9053 22.0917 10.6386 21.9202 10.3592 21.6408C10.0798 21.3614 9.90514 21.0947 9.76226 20.72C9.6543 20.4374 9.52094 20.0151 9.48601 19.234C9.44791 18.3894 9.43838 18.1385 9.43838 16.0016C9.43838 13.8647 9.44791 13.6138 9.48601 12.7692C9.52094 11.9881 9.65112 11.5658 9.76226 11.2832C9.90832 10.9085 10.0798 10.6418 10.3592 10.3624C10.6386 10.083 10.9053 9.90832 11.28 9.76543C11.5626 9.65747 11.9849 9.52411 12.766 9.48918C13.6106 9.44791 13.8647 9.44156 15.9984 9.44156ZM15.9984 8C13.8266 8 13.5535 8.00953 12.6993 8.04763C11.8484 8.08573 11.2673 8.22227 10.7593 8.41913C10.2322 8.62235 9.78766 8.89859 9.34312 9.34312C8.89859 9.78766 8.62552 10.2354 8.41913 10.7593C8.22227 11.2673 8.08573 11.8484 8.04763 12.7025C8.00953 13.5535 8 13.8266 8 15.9984C8 18.1703 8.00953 18.4433 8.04763 19.2975C8.08573 20.1484 8.22227 20.7295 8.41913 21.2407C8.62235 21.7678 8.89859 22.2123 9.34312 22.6569C9.78766 23.1014 10.2354 23.3745 10.7593 23.5809C11.2673 23.7777 11.8484 23.9143 12.7025 23.9524C13.5567 23.9905 13.8266 24 16.0016 24C18.1766 24 18.4465 23.9905 19.3007 23.9524C20.1516 23.9143 20.7327 23.7777 21.2439 23.5809C21.771 23.3777 22.2155 23.1014 22.6601 22.6569C23.1046 22.2123 23.3777 21.7646 23.5841 21.2407C23.7809 20.7327 23.9175 20.1516 23.9556 19.2975C23.9937 18.4433 24.0032 18.1734 24.0032 15.9984C24.0032 13.8234 23.9937 13.5535 23.9556 12.6993C23.9175 11.8484 23.7809 11.2673 23.5841 10.7561C23.3808 10.229 23.1046 9.78448 22.6601 9.33995C22.2155 8.89542 21.7678 8.62235 21.2439 8.41596C20.7359 8.21909 20.1548 8.08256 19.3007 8.04445C18.4433 8.00953 18.1703 8 15.9984 8Z"
                                                //       fill="white"
                                                //     />
                                                //     <path
                                                //       d="M15.9984 11.8928C13.7313 11.8928 11.8897 13.7313 11.8897 16.0016C11.8897 18.2719 13.7281 20.1103 15.9984 20.1103C18.2687 20.1103 20.1072 18.2719 20.1072 16.0016C20.1072 13.7313 18.2687 11.8928 15.9984 11.8928ZM15.9984 18.6656C14.5251 18.6656 13.3312 17.4717 13.3312 15.9984C13.3312 14.5251 14.5251 13.3312 15.9984 13.3312C17.4717 13.3312 18.6656 14.5251 18.6656 15.9984C18.6656 17.4717 17.4717 18.6656 15.9984 18.6656Z"
                                                //       fill="white"
                                                //     />
                                                //     <path
                                                //       d="M20.2691 12.6866C20.7987 12.6866 21.228 12.2573 21.228 11.7277C21.228 11.1981 20.7987 10.7688 20.2691 10.7688C19.7395 10.7688 19.3102 11.1981 19.3102 11.7277C19.3102 12.2573 19.7395 12.6866 20.2691 12.6866Z"
                                                //       fill="white"
                                                //     />
                                                //   </svg>
                                                // </div>
                                              );
                                            }
                                          })()}

                                          {(() => {
                                            if (checkdadostwiter) {
                                              return (
                                                <SelectRouteActiveCall
                                                  size="small"
                                                  midiaId={9}
                                                  onChooseRoute={(
                                                    event,
                                                    selectedRoute,
                                                  ) => {
                                                    this.SolicitarChamadaAtiva(
                                                      event,
                                                      selectedRoute,
                                                      9,
                                                      OutBandService,
                                                      InfoUsers,
                                                      StatusAgent,
                                                      listCallQueue,
                                                      contact.numberTwiter,
                                                      AtdSimult,
                                                      IPCurrent,
                                                      StatusAgent,
                                                    );
                                                  }}
                                                />
                                                // <div
                                                //   onClick={(event) =>
                                                //     this.SolicitarChamadaAtiva(
                                                //       event,
                                                //       PermissionRouter,
                                                //       9,
                                                //       OutBandService,
                                                //       InfoUsers,
                                                //       StatusAgent,
                                                //       listCallQueue,
                                                //       contact.numberTwiter,
                                                //       AtdSimult,
                                                //       IPCurrent,
                                                //       StatusAgent
                                                //     )
                                                //   }
                                                //   className={
                                                //     twiter
                                                //       ? "modal__content__tabs__body__tab__result__body__channels__channel"
                                                //       : "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <svg
                                                //     width="22"
                                                //     height="22"
                                                //     viewBox="0 0 32 32"
                                                //     fill="none"
                                                //     xmlns="http://www.w3.org/2000/svg"
                                                //   >
                                                //     <circle
                                                //       cx="16"
                                                //       cy="16"
                                                //       r="16"
                                                //       fill={
                                                //         twiter
                                                //           ? "#1D9BF0"
                                                //           : "#b7bec5"
                                                //       }
                                                //     />
                                                //     <path
                                                //       d="M22.2985 10.3826C22.1138 10.4397 21.9266 10.4882 21.7373 10.5281L21.45 10.5886L21.2572 10.3672C21.0153 10.0894 20.7238 9.87026 20.4023 9.72179C20.081 9.57338 19.7357 9.49826 19.388 9.50007L19.3817 9.5001V9.50006C19.0441 9.49759 18.7087 9.56937 18.3962 9.71204L18.3953 9.71245C17.7818 9.99102 17.2841 10.5167 17.0158 11.1887L17.0146 11.1917C16.8787 11.5257 16.8093 11.8874 16.8093 12.2806C16.8093 12.3911 16.8147 12.5015 16.8252 12.6113L16.8253 12.6124C16.8348 12.7138 16.8516 12.8141 16.8755 12.9125L17.0334 13.5628L16.3651 13.5299C15.713 13.4979 15.0662 13.3908 14.4362 13.2107L14.4358 13.2106C13.1897 12.8535 12.0288 12.2252 11.0259 11.3674C10.7368 11.1206 10.463 10.8552 10.2046 10.5717C10.1049 11.0207 10.1072 11.4892 10.2117 11.9375C10.2655 12.1581 10.3433 12.3707 10.4433 12.5709C10.6484 12.978 10.9408 13.3231 11.2932 13.5791L12.6091 14.5351L10.9834 14.4833C10.7119 14.4747 10.4488 14.4353 10.1947 14.3657C10.2914 14.7373 10.4603 15.0846 10.6918 15.3836C10.8794 15.6259 11.1022 15.8321 11.3503 15.9948L22.2985 10.3826ZM22.2985 10.3826C22.1951 10.4742 22.0847 10.5571 21.9683 10.6302L22.2958 11.5498C22.3776 11.5397 22.4591 11.5279 22.5404 11.5145M22.2985 10.3826L22.5404 11.5145M22.5404 11.5145C22.4163 11.6281 22.2879 11.7362 22.1556 11.8385L21.9446 12.0016L21.9626 12.2677C21.9715 12.4 21.9761 12.5326 21.9764 12.6652C21.9764 13.2875 21.9144 13.9016 21.7895 14.5091C21.6646 15.1167 21.4824 15.7089 21.2456 16.2766L21.2445 16.2794C20.9167 17.0791 20.4839 17.8238 19.9598 18.4911C19.4601 19.126 18.8756 19.677 18.226 20.1268C17.5737 20.5757 16.8638 20.9188 16.1196 21.1457L16.1194 21.1457C15.3384 21.3842 14.5301 21.5033 13.7185 21.4999L13.7157 21.4999C12.9352 21.501 12.1582 21.3836 11.4079 21.151C11.2301 21.0958 11.0543 21.0341 10.8808 20.9659C11.1052 20.9246 11.3278 20.8711 11.5478 20.8054C12.3963 20.5522 13.1875 20.1235 13.8769 19.5457L14.9066 18.6826L13.5632 18.6625C13.1698 18.6567 12.7816 18.5523 12.4297 18.3558C12.0777 18.1592 11.7708 17.8753 11.5358 17.5244L11.5358 17.5244L11.5339 17.5216C11.5149 17.4937 11.4965 17.4654 11.4785 17.4368C11.7258 17.4208 11.9714 17.3771 12.2108 17.3061L12.1715 16.3374C11.8823 16.2766 11.6042 16.161 11.3505 15.9949L22.5404 11.5145Z"
                                                //       fill="white"
                                                //       stroke="white"
                                                //     />
                                                //   </svg>
                                                // </div>
                                              );
                                            } else {
                                              return (
                                                <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled fill stroke">
                                                  <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled__midia-icon">
                                                    <TWITTERICONDISABLED />
                                                  </div>
                                                  {/* <div
                                                    style={{
                                                      width: "100%",
                                                      height: "16.8px",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <ArrowDown2
                                                      size="8"
                                                      color="#455cc7"
                                                    />
                                                  </div> */}
                                                </div>
                                                // <div
                                                //   className={
                                                //     "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <svg
                                                //     width="22"
                                                //     height="22"
                                                //     viewBox="0 0 32 32"
                                                //     fill="none"
                                                //     xmlns="http://www.w3.org/2000/svg"
                                                //   >
                                                //     <circle
                                                //       cx="16"
                                                //       cy="16"
                                                //       r="16"
                                                //       fill={
                                                //         twiter
                                                //           ? "#1D9BF0"
                                                //           : "#b7bec5"
                                                //       }
                                                //     />
                                                //     <path
                                                //       d="M22.2985 10.3826C22.1138 10.4397 21.9266 10.4882 21.7373 10.5281L21.45 10.5886L21.2572 10.3672C21.0153 10.0894 20.7238 9.87026 20.4023 9.72179C20.081 9.57338 19.7357 9.49826 19.388 9.50007L19.3817 9.5001V9.50006C19.0441 9.49759 18.7087 9.56937 18.3962 9.71204L18.3953 9.71245C17.7818 9.99102 17.2841 10.5167 17.0158 11.1887L17.0146 11.1917C16.8787 11.5257 16.8093 11.8874 16.8093 12.2806C16.8093 12.3911 16.8147 12.5015 16.8252 12.6113L16.8253 12.6124C16.8348 12.7138 16.8516 12.8141 16.8755 12.9125L17.0334 13.5628L16.3651 13.5299C15.713 13.4979 15.0662 13.3908 14.4362 13.2107L14.4358 13.2106C13.1897 12.8535 12.0288 12.2252 11.0259 11.3674C10.7368 11.1206 10.463 10.8552 10.2046 10.5717C10.1049 11.0207 10.1072 11.4892 10.2117 11.9375C10.2655 12.1581 10.3433 12.3707 10.4433 12.5709C10.6484 12.978 10.9408 13.3231 11.2932 13.5791L12.6091 14.5351L10.9834 14.4833C10.7119 14.4747 10.4488 14.4353 10.1947 14.3657C10.2914 14.7373 10.4603 15.0846 10.6918 15.3836C10.8794 15.6259 11.1022 15.8321 11.3503 15.9948L22.2985 10.3826ZM22.2985 10.3826C22.1951 10.4742 22.0847 10.5571 21.9683 10.6302L22.2958 11.5498C22.3776 11.5397 22.4591 11.5279 22.5404 11.5145M22.2985 10.3826L22.5404 11.5145M22.5404 11.5145C22.4163 11.6281 22.2879 11.7362 22.1556 11.8385L21.9446 12.0016L21.9626 12.2677C21.9715 12.4 21.9761 12.5326 21.9764 12.6652C21.9764 13.2875 21.9144 13.9016 21.7895 14.5091C21.6646 15.1167 21.4824 15.7089 21.2456 16.2766L21.2445 16.2794C20.9167 17.0791 20.4839 17.8238 19.9598 18.4911C19.4601 19.126 18.8756 19.677 18.226 20.1268C17.5737 20.5757 16.8638 20.9188 16.1196 21.1457L16.1194 21.1457C15.3384 21.3842 14.5301 21.5033 13.7185 21.4999L13.7157 21.4999C12.9352 21.501 12.1582 21.3836 11.4079 21.151C11.2301 21.0958 11.0543 21.0341 10.8808 20.9659C11.1052 20.9246 11.3278 20.8711 11.5478 20.8054C12.3963 20.5522 13.1875 20.1235 13.8769 19.5457L14.9066 18.6826L13.5632 18.6625C13.1698 18.6567 12.7816 18.5523 12.4297 18.3558C12.0777 18.1592 11.7708 17.8753 11.5358 17.5244L11.5358 17.5244L11.5339 17.5216C11.5149 17.4937 11.4965 17.4654 11.4785 17.4368C11.7258 17.4208 11.9714 17.3771 12.2108 17.3061L12.1715 16.3374C11.8823 16.2766 11.6042 16.161 11.3505 15.9949L22.5404 11.5145Z"
                                                //       fill="white"
                                                //       stroke="white"
                                                //     />
                                                //   </svg>
                                                // </div>
                                              );
                                            }
                                          })()}

                                          {(() => {
                                            if (checkdadoslinkedin) {
                                              return (
                                                <SelectRouteActiveCall
                                                  size="small"
                                                  midiaId={10}
                                                  onChooseRoute={(
                                                    event,
                                                    selectedRoute,
                                                  ) => {
                                                    this.SolicitarChamadaAtiva(
                                                      event,
                                                      selectedRoute,
                                                      10,
                                                      OutBandService,
                                                      InfoUsers,
                                                      StatusAgent,
                                                      listCallQueue,
                                                      contact.numberLinkedin,
                                                      AtdSimult,
                                                      IPCurrent,
                                                      StatusAgent,
                                                    );
                                                  }}
                                                />
                                                // <div
                                                //   onClick={(event) =>
                                                //     this.SolicitarChamadaAtiva(
                                                //       event,
                                                //       PermissionRouter,
                                                //       10,
                                                //       OutBandService,
                                                //       InfoUsers,
                                                //       StatusAgent,
                                                //       listCallQueue,
                                                //       contact.numberLinkedin,
                                                //       AtdSimult,
                                                //       IPCurrent,
                                                //       StatusAgent
                                                //     )
                                                //   }
                                                //   className={
                                                //     linkedin
                                                //       ? "modal__content__tabs__body__tab__result__body__channels__channel"
                                                //       : "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <svg
                                                //     width="22"
                                                //     height="22"
                                                //     viewBox="0 0 32 32"
                                                //     fill="none"
                                                //     xmlns="http://www.w3.org/2000/svg"
                                                //   >
                                                //     <path
                                                //       d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
                                                //       fill={
                                                //         linkedin
                                                //           ? "#0A66C2"
                                                //           : "#b7bec5"
                                                //       }
                                                //     />
                                                //     <path
                                                //       d="M22.8189 8H9.18111C8.86786 8 8.56744 8.12444 8.34594 8.34594C8.12444 8.56744 8 8.86786 8 9.18111V22.8189C8 23.1321 8.12444 23.4326 8.34594 23.6541C8.56744 23.8756 8.86786 24 9.18111 24H22.8189C23.1321 24 23.4326 23.8756 23.6541 23.6541C23.8756 23.4326 24 23.1321 24 22.8189V9.18111C24 8.86786 23.8756 8.56744 23.6541 8.34594C23.4326 8.12444 23.1321 8 22.8189 8ZM12.7689 21.63H10.3633V13.9889H12.7689V21.63ZM11.5644 12.93C11.2916 12.9285 11.0253 12.8461 10.7992 12.6934C10.573 12.5407 10.3972 12.3244 10.2939 12.0718C10.1906 11.8192 10.1644 11.5417 10.2187 11.2743C10.2729 11.0069 10.4052 10.7615 10.5988 10.5692C10.7923 10.3769 11.0385 10.2462 11.3063 10.1936C11.5741 10.1411 11.8514 10.1691 12.1033 10.274C12.3552 10.3789 12.5704 10.5561 12.7216 10.7832C12.8729 11.0103 12.9535 11.2771 12.9533 11.55C12.9559 11.7327 12.9217 11.914 12.8527 12.0832C12.7837 12.2524 12.6813 12.4059 12.5517 12.5347C12.4221 12.6635 12.2679 12.7649 12.0983 12.8328C11.9287 12.9007 11.7471 12.9337 11.5644 12.93ZM21.6356 21.6367H19.2311V17.4622C19.2311 16.2311 18.7078 15.8511 18.0322 15.8511C17.3189 15.8511 16.6189 16.3889 16.6189 17.4933V21.6367H14.2133V13.9944H16.5267V15.0533H16.5578C16.79 14.5833 17.6033 13.78 18.8444 13.78C20.1867 13.78 21.6367 14.5767 21.6367 16.91L21.6356 21.6367Z"
                                                //       fill="white"
                                                //     />
                                                //   </svg>
                                                // </div>
                                              );
                                            } else {
                                              return (
                                                <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled fill">
                                                  <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled__midia-icon">
                                                    <LINKEDINICONDISABLED />
                                                  </div>
                                                  {/* <div
                                                    style={{
                                                      width: "100%",
                                                      height: "16.8px",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <ArrowDown2
                                                      size="8"
                                                      color="#455cc7"
                                                    />
                                                  </div> */}
                                                </div>
                                                // <div
                                                //   className={
                                                //     "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <svg
                                                //     width="22"
                                                //     height="22"
                                                //     viewBox="0 0 32 32"
                                                //     fill="none"
                                                //     xmlns="http://www.w3.org/2000/svg"
                                                //   >
                                                //     <path
                                                //       d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
                                                //       fill={
                                                //         linkedin
                                                //           ? "#0A66C2"
                                                //           : "#b7bec5"
                                                //       }
                                                //     />
                                                //     <path
                                                //       d="M22.8189 8H9.18111C8.86786 8 8.56744 8.12444 8.34594 8.34594C8.12444 8.56744 8 8.86786 8 9.18111V22.8189C8 23.1321 8.12444 23.4326 8.34594 23.6541C8.56744 23.8756 8.86786 24 9.18111 24H22.8189C23.1321 24 23.4326 23.8756 23.6541 23.6541C23.8756 23.4326 24 23.1321 24 22.8189V9.18111C24 8.86786 23.8756 8.56744 23.6541 8.34594C23.4326 8.12444 23.1321 8 22.8189 8ZM12.7689 21.63H10.3633V13.9889H12.7689V21.63ZM11.5644 12.93C11.2916 12.9285 11.0253 12.8461 10.7992 12.6934C10.573 12.5407 10.3972 12.3244 10.2939 12.0718C10.1906 11.8192 10.1644 11.5417 10.2187 11.2743C10.2729 11.0069 10.4052 10.7615 10.5988 10.5692C10.7923 10.3769 11.0385 10.2462 11.3063 10.1936C11.5741 10.1411 11.8514 10.1691 12.1033 10.274C12.3552 10.3789 12.5704 10.5561 12.7216 10.7832C12.8729 11.0103 12.9535 11.2771 12.9533 11.55C12.9559 11.7327 12.9217 11.914 12.8527 12.0832C12.7837 12.2524 12.6813 12.4059 12.5517 12.5347C12.4221 12.6635 12.2679 12.7649 12.0983 12.8328C11.9287 12.9007 11.7471 12.9337 11.5644 12.93ZM21.6356 21.6367H19.2311V17.4622C19.2311 16.2311 18.7078 15.8511 18.0322 15.8511C17.3189 15.8511 16.6189 16.3889 16.6189 17.4933V21.6367H14.2133V13.9944H16.5267V15.0533H16.5578C16.79 14.5833 17.6033 13.78 18.8444 13.78C20.1867 13.78 21.6367 14.5767 21.6367 16.91L21.6356 21.6367Z"
                                                //       fill="white"
                                                //     />
                                                //   </svg>
                                                // </div>
                                              );
                                            }
                                          })()}

                                          {(() => {
                                            if (checkdadosvoz) {
                                              return (
                                                <SelectRouteActiveCall
                                                  size="small"
                                                  midiaId={12}
                                                  onChooseRoute={(
                                                    event,
                                                    selectedRoute,
                                                  ) => {
                                                    this.SolicitarChamadaAtiva(
                                                      event,
                                                      selectedRoute,
                                                      12,
                                                      OutBandService,
                                                      InfoUsers,
                                                      StatusAgent,
                                                      listCallQueue,
                                                      contact.numberVoz,
                                                      AtdSimult,
                                                      IPCurrent,
                                                      StatusAgent,
                                                    );
                                                  }}
                                                />
                                                // <div
                                                //   onClick={(event) =>
                                                //     this.SolicitarChamadaAtiva(
                                                //       event,
                                                //       PermissionRouter,
                                                //       12,
                                                //       OutBandService,
                                                //       InfoUsers,
                                                //       StatusAgent,
                                                //       listCallQueue,
                                                //       contact.numberVoz,
                                                //       AtdSimult,
                                                //       IPCurrent,
                                                //       StatusAgent
                                                //     )
                                                //   }
                                                //   className={
                                                //     sms
                                                //       ? "modal__content__tabs__body__tab__result__body__channels__channel"
                                                //       : "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <svg
                                                //     width="24"
                                                //     height="24"
                                                //     viewBox="0 0 18 18"
                                                //     fill="none"
                                                //     xmlns="http://www.w3.org/2000/svg"
                                                //   >
                                                //     <rect
                                                //       x="0.5"
                                                //       y="0.5"
                                                //       width="17"
                                                //       height="17"
                                                //       rx="8.5"
                                                //       fill="#61C4BE"
                                                //     />
                                                //     <path
                                                //       d="M11.8479 4.5H6.1521C4.96557 4.5 4 5.51786 4 6.76865V9.0159C4 10.2667 4.96557 11.2845 6.1521 11.2845H9.75226L12.3694 13.5V11.2162C13.3161 10.9675 14 10.0684 14 9.0159V6.76865C14 5.51786 13.0344 4.5 11.8479 4.5ZM6.30286 8.86132C6.04804 8.86132 5.82098 8.80401 5.6739 8.72186L5.78133 8.27418C5.89271 8.34407 6.12373 8.42625 6.30288 8.42625C6.48598 8.42625 6.56167 8.36045 6.56167 8.25782C6.56167 8.15487 6.50186 8.10575 6.27512 8.02768C5.8729 7.88791 5.71757 7.66217 5.72153 7.42384C5.72153 7.05014 6.0322 6.7668 6.51378 6.7668C6.74082 6.7668 6.94408 6.82 7.06339 6.88171L6.95596 7.31302C6.86837 7.26358 6.70114 7.19779 6.5339 7.19779C6.38649 7.19779 6.30288 7.2595 6.30288 7.36213C6.30288 7.45658 6.37855 7.50601 6.61751 7.59227C6.98769 7.72356 7.14302 7.91685 7.147 8.21249C7.14698 8.58617 6.86041 8.86132 6.30286 8.86132ZM10.4554 8.82039H9.8661V7.72794C9.8661 7.4361 9.77424 7.26767 9.57924 7.26767C9.44008 7.26767 9.34029 7.3662 9.30061 7.48553C9.28473 7.53054 9.27682 7.59636 9.27682 7.64577V8.82039H8.68753V7.69489C8.68753 7.44018 8.59994 7.26767 8.40859 7.26767C8.25357 7.26767 8.16169 7.39108 8.126 7.49372C8.10616 7.54284 8.1022 7.60044 8.1022 7.64987V8.82041H7.51292V7.4525C7.51292 7.20221 7.50498 6.98843 7.49704 6.81181H8.00669L8.03447 7.08288H8.04637C8.12998 6.95569 8.30118 6.7668 8.63565 6.7668C8.88651 6.7668 9.08549 6.89809 9.1691 7.10745H9.17704C9.24875 7.00481 9.33635 6.92264 9.4279 6.86535C9.53563 6.79956 9.65494 6.76682 9.79839 6.76682C10.1725 6.76682 10.4554 7.03789 10.4554 7.63733V8.82039H10.4554ZM11.4539 8.86132C11.1991 8.86132 10.972 8.80401 10.825 8.72186L10.9324 8.27418C11.0438 8.34407 11.2748 8.42625 11.4539 8.42625C11.637 8.42625 11.7127 8.36045 11.7127 8.25782C11.7127 8.15487 11.6529 8.10575 11.4262 8.02768C11.0239 7.88791 10.8686 7.66217 10.8726 7.42384C10.8726 7.05014 11.1832 6.7668 11.6648 6.7668C11.8919 6.7668 12.0948 6.82 12.2144 6.88171L12.107 7.31302C12.0194 7.26358 11.8522 7.19779 11.6849 7.19779C11.5375 7.19779 11.4539 7.2595 11.4539 7.36213C11.4539 7.45658 11.5296 7.50601 11.7686 7.59227C12.1387 7.72356 12.2941 7.91685 12.298 8.21249C12.298 8.58617 12.0115 8.86132 11.4539 8.86132Z"
                                                //       fill="white"
                                                //     />
                                                //     <rect
                                                //       x="0.5"
                                                //       y="0.5"
                                                //       width="17"
                                                //       height="17"
                                                //       rx="8.5"
                                                //       stroke="white"
                                                //     />
                                                //   </svg>
                                                // </div>
                                              );
                                            } else {
                                              return (
                                                <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled fill">
                                                  <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled__midia-icon">
                                                    <SMSICONDISABLED />
                                                  </div>
                                                  {/* <div
                                                    style={{
                                                      width: "100%",
                                                      height: "16.8px",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <ArrowDown2
                                                      size="8"
                                                      color="#455cc7"
                                                    />
                                                  </div> */}
                                                </div>
                                                // <div
                                                //   className={
                                                //     "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <svg
                                                //     width="24"
                                                //     height="24"
                                                //     viewBox="0 0 18 18"
                                                //     fill="none"
                                                //     xmlns="http://www.w3.org/2000/svg"
                                                //   >
                                                //     <rect
                                                //       x="0.5"
                                                //       y="0.5"
                                                //       width="17"
                                                //       height="17"
                                                //       rx="8.5"
                                                //       fill="#61C4BE"
                                                //     />
                                                //     <path
                                                //       d="M11.8479 4.5H6.1521C4.96557 4.5 4 5.51786 4 6.76865V9.0159C4 10.2667 4.96557 11.2845 6.1521 11.2845H9.75226L12.3694 13.5V11.2162C13.3161 10.9675 14 10.0684 14 9.0159V6.76865C14 5.51786 13.0344 4.5 11.8479 4.5ZM6.30286 8.86132C6.04804 8.86132 5.82098 8.80401 5.6739 8.72186L5.78133 8.27418C5.89271 8.34407 6.12373 8.42625 6.30288 8.42625C6.48598 8.42625 6.56167 8.36045 6.56167 8.25782C6.56167 8.15487 6.50186 8.10575 6.27512 8.02768C5.8729 7.88791 5.71757 7.66217 5.72153 7.42384C5.72153 7.05014 6.0322 6.7668 6.51378 6.7668C6.74082 6.7668 6.94408 6.82 7.06339 6.88171L6.95596 7.31302C6.86837 7.26358 6.70114 7.19779 6.5339 7.19779C6.38649 7.19779 6.30288 7.2595 6.30288 7.36213C6.30288 7.45658 6.37855 7.50601 6.61751 7.59227C6.98769 7.72356 7.14302 7.91685 7.147 8.21249C7.14698 8.58617 6.86041 8.86132 6.30286 8.86132ZM10.4554 8.82039H9.8661V7.72794C9.8661 7.4361 9.77424 7.26767 9.57924 7.26767C9.44008 7.26767 9.34029 7.3662 9.30061 7.48553C9.28473 7.53054 9.27682 7.59636 9.27682 7.64577V8.82039H8.68753V7.69489C8.68753 7.44018 8.59994 7.26767 8.40859 7.26767C8.25357 7.26767 8.16169 7.39108 8.126 7.49372C8.10616 7.54284 8.1022 7.60044 8.1022 7.64987V8.82041H7.51292V7.4525C7.51292 7.20221 7.50498 6.98843 7.49704 6.81181H8.00669L8.03447 7.08288H8.04637C8.12998 6.95569 8.30118 6.7668 8.63565 6.7668C8.88651 6.7668 9.08549 6.89809 9.1691 7.10745H9.17704C9.24875 7.00481 9.33635 6.92264 9.4279 6.86535C9.53563 6.79956 9.65494 6.76682 9.79839 6.76682C10.1725 6.76682 10.4554 7.03789 10.4554 7.63733V8.82039H10.4554ZM11.4539 8.86132C11.1991 8.86132 10.972 8.80401 10.825 8.72186L10.9324 8.27418C11.0438 8.34407 11.2748 8.42625 11.4539 8.42625C11.637 8.42625 11.7127 8.36045 11.7127 8.25782C11.7127 8.15487 11.6529 8.10575 11.4262 8.02768C11.0239 7.88791 10.8686 7.66217 10.8726 7.42384C10.8726 7.05014 11.1832 6.7668 11.6648 6.7668C11.8919 6.7668 12.0948 6.82 12.2144 6.88171L12.107 7.31302C12.0194 7.26358 11.8522 7.19779 11.6849 7.19779C11.5375 7.19779 11.4539 7.2595 11.4539 7.36213C11.4539 7.45658 11.5296 7.50601 11.7686 7.59227C12.1387 7.72356 12.2941 7.91685 12.298 8.21249C12.298 8.58617 12.0115 8.86132 11.4539 8.86132Z"
                                                //       fill="white"
                                                //     />
                                                //     <rect
                                                //       x="0.5"
                                                //       y="0.5"
                                                //       width="17"
                                                //       height="17"
                                                //       rx="8.5"
                                                //       stroke="white"
                                                //     />
                                                //   </svg>
                                                // </div>
                                              );
                                            }
                                          })()}

                                          {(() => {
                                            if (checkdadosteams) {
                                              return (
                                                <SelectRouteActiveCall
                                                  size="small"
                                                  midiaId={15}
                                                  onChooseRoute={(
                                                    event,
                                                    selectedRoute,
                                                  ) => {
                                                    this.SolicitarChamadaAtiva(
                                                      event,
                                                      selectedRoute,
                                                      15,
                                                      OutBandService,
                                                      InfoUsers,
                                                      StatusAgent,
                                                      listCallQueue,
                                                      contact.numberTeams,
                                                      AtdSimult,
                                                      IPCurrent,
                                                      StatusAgent,
                                                    );
                                                  }}
                                                />
                                                // <div
                                                //   onClick={(event) =>
                                                //     this.SolicitarChamadaAtiva(
                                                //       event,
                                                //       PermissionRouter,
                                                //       15,
                                                //       OutBandService,
                                                //       InfoUsers,
                                                //       StatusAgent,
                                                //       listCallQueue,
                                                //       contact.numberTeams,
                                                //       AtdSimult,
                                                //       IPCurrent,
                                                //       StatusAgent
                                                //     )
                                                //   }
                                                //   className={
                                                //     teams
                                                //       ? "modal__content__tabs__body__tab__result__body__channels__channel"
                                                //       : "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <img
                                                //     width="22"
                                                //     height="22"
                                                //     src={TEAMS}
                                                //     alt=""
                                                //     className="tippy-default"
                                                //     data-tippy-content="Teams"
                                                //   />
                                                // </div>
                                              );
                                            } else {
                                              return (
                                                <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled fill">
                                                  <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled__midia-icon">
                                                    <TEAMSICONDISABLED />
                                                  </div>
                                                  {/* <div
                                                    style={{
                                                      width: "100%",
                                                      height: "16.8px",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <ArrowDown2
                                                      size="8"
                                                      color="#455cc7"
                                                    />
                                                  </div> */}
                                                </div>
                                                // <div
                                                //   className={
                                                //     "modal__content__tabs__body__tab__result__body__channels__channel disable"
                                                //   }
                                                // >
                                                //   <img
                                                //     width="22"
                                                //     height="22"
                                                //     src={TEAMS}
                                                //     alt=""
                                                //     className="tippy-default"
                                                //     data-tippy-content="Teams"
                                                //   />
                                                // </div>
                                              );
                                            }
                                          })()}

                                          {(() => {
                                            if (checkdadoszapvoz) {
                                              return (
                                                <SelectRouteActiveCall
                                                  size="small"
                                                  key={contact.numberZapVoz}
                                                  midiaId={16}
                                                  numeroDoCliente={
                                                    contact.numberZapVoz
                                                  }
                                                  onChooseRoute={(
                                                    event,
                                                    selectedRoute,
                                                  ) => {
                                                    this.SolicitarChamadaAtiva(
                                                      event,
                                                      selectedRoute,
                                                      16,
                                                      OutBandService,
                                                      InfoUsers,
                                                      StatusAgent,
                                                      listCallQueue,
                                                      contact.numberZapVoz,
                                                      AtdSimult,
                                                      IPCurrent,
                                                      StatusAgent,
                                                    );
                                                  }}
                                                />
                                              );
                                            } else {
                                              return (
                                                <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled fill">
                                                  <div className="modal__content__tabs__body__tab__result__body__channels-new__icon-disabled__midia-icon other-disabled-version">
                                                    <WHATSAPPVOZICONDISABLED />
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })()}
                                        </div>
                                      </div>
                                      <div className="modal__content__tabs__body__tab__result__body__col  modal__content__tabs__body__tab__result__body__col--pull-right">
                                        <div className="modal__content__tabs__body__tab__result__body__actions">
                                          <Popover
                                            trigger="click"
                                            boundary="window"
                                            placement="left"
                                            multiple={true}
                                            interactive={true}
                                            content={this.renderPopoverDial(
                                              this,
                                              PermissionRouter,
                                              OutBandService,
                                              InfoUsers,
                                              StatusAgent,
                                              listCallQueue,
                                              contact.number,
                                              AtdSimult,
                                              IPCurrent,
                                              voz,
                                              zap,
                                              face,
                                              sms,
                                              teams,
                                              zapvoz,
                                            )}
                                          >
                                            <a
                                              className="modal__content__tabs__body__tab__result__body__actions__action tippy-context-menu"
                                              data-tippy-placement="left"
                                              data-template="modal-contato-ligar"
                                            >
                                              <i className="material-icons">
                                                call
                                              </i>
                                            </a>
                                          </Popover>
                                          <a
                                            onClick={(event) =>
                                              this.ShowModal(
                                                event,
                                                "modal__agenda-pf-usuario-detalhes",
                                                contact,
                                                true,
                                              )
                                            }
                                            className="modal__content__tabs__body__tab__result__body__actions__action"
                                          >
                                            <i className="material-icons">
                                              visibility
                                            </i>
                                          </a>
                                          <Popover
                                            trigger="click"
                                            boundary="window"
                                            placement="left"
                                            multiple={true}
                                            interactive={true}
                                            content={this.renderPopoverInfo(
                                              this,
                                              contact,
                                              InfoUsers.id,
                                              PermissionRouter,
                                            )}
                                          >
                                            <a
                                              className="modal__content__tabs__body__tab__result__body__actions__action tippy-context-menu"
                                              data-tippy-placement="left"
                                              data-template="modal-contato-mais-info"
                                            >
                                              <i className="material-icons">
                                                more_vert
                                              </i>
                                            </a>
                                          </Popover>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </>
                              );
                            } else {
                              return (
                                <div className="modal__content__tabs__body__tab__result__body__row">
                                  <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--1">
                                    {/* <div className="user-photo"></div> */}
                                    <UserPhoto />
                                  </div>
                                  <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--6">
                                    <div className="user">
                                      <div className="user-name">
                                        Sem resultado!
                                      </div>
                                      <div className="user-phone"></div>
                                    </div>
                                  </div>
                                  <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--6">
                                    <div className="modal__content__tabs__body__tab__result__body__channels"></div>
                                  </div>
                                  <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--7 modal__content__tabs__body__tab__result__body__col--pull-right">
                                    <div className="modal__content__tabs__body__tab__result__body__actions"></div>
                                  </div>
                                </div>
                              );
                            }
                          })()}
                          {/* <!-- END OF RESULT ROW --> */}

                          {/* <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--letter">B</div> */}
                        </div>
                      </div>
                      <div className="flab">
                        <a
                          className="flab__button"
                          onClick={this.ShowModalAddContact.bind(
                            this,
                            InfoUsers.id,
                            InfoUsers.displayname,
                          )}
                        >
                          <div className="material-icons">add</div>
                        </a>
                        <div className="flab__related">
                          <a
                            className="flab__related__button tippy-default"
                            onClick={this.ShowModalAddContact.bind(
                              this,
                              InfoUsers.id,
                              InfoUsers.displayname,
                            )}
                            data-tippy-content="Adicionar um contato"
                            data-tippy-theme="light"
                            data-tippy-placement="left"
                          >
                            <div className="material-icons">person_add</div>
                          </a>
                        </div>
                        <div className="flab__overlay"></div>
                      </div>
                    </div>

                    <div
                      className={
                        this.state.buttonshowpfpj
                          ? "modal__content__tabs__body__tab is-active"
                          : "modal__content__tabs__body__tab"
                      }
                      data-tab="pj"
                    >
                      <p>Preencha os campos para buscar uma empresa.</p>
                      <form
                        className="modal__content__form"
                        onSubmit={(event) => this.handleSubmitCompany(event)}
                      >
                        <div
                          style={{ width: "288.76px" }}
                          className="modal__content__form__group modal__content__form__group--col-5"
                        >
                          <label
                            className="modal__content__form__group__label"
                            htmlFor="modal__content__form__group__label--empresa"
                          >
                            Empresa:
                          </label>
                          <input
                            type="text"
                            name="empresa"
                            ref={(input) => (this.nameempresa = input)}
                            className="modal__content__form__group__input"
                            id="modal__content__form__group__label--empresa"
                          />
                        </div>

                        <div className="modal__content__form__group modal__content__form__group--col-2">
                          <label
                            className="modal__content__form__group__label"
                            htmlFor="modal__content__form__group__label--external-code-business-inside-legal-person"
                          >
                            Código Externo Empresa:
                          </label>
                          <input
                            type="text"
                            name="external-code-business-inside-legal-person"
                            value={this.state.externalCodeInsideLegalPerson}
                            onChange={(event) => {
                              const newExternalCode = event.target.value;
                              this.setState({
                                externalCodeInsideLegalPerson: newExternalCode,
                              });
                            }}
                            className="modal__content__form__group__input"
                            id="modal__content__form__group__label--external-code-business-inside-legal-person"
                          />
                        </div>

                        <div className="modal__content__form__group modal__content__form__group--col-2">
                          <label
                            className="modal__content__form__group__label"
                            htmlFor="modal__content__form__group__label--cnpj"
                          >
                            CNPJ:
                          </label>
                          <input
                            type="text"
                            name="cnpj"
                            ref={(input) => (this.cnpj = input)}
                            className="modal__content__form__group__input"
                            id="modal__content__form__group__label--cnpj"
                          />
                        </div>

                        <div className="modal__content__form__group modal__content__form__group--col-1">
                          <button
                            type="submit"
                            onClick={(event) => this.handleSubmitCompany(event)}
                            id="button_filtrar_company"
                            className="modal__content__form__group__button"
                          >
                            Filtrar
                          </button>
                        </div>
                      </form>
                      <div className="modal__content__tabs__body__tab__result">
                        <div className="modal__content__tabs__body__tab__result__header">
                          <div className="modal__content__tabs__body__tab__result__header__col modal__content__tabs__body__tab__result__header__col--1">
                            #
                          </div>
                          <div className="modal__content__tabs__body__tab__result__header__col modal__content__tabs__body__tab__result__header__col--20">
                            Nome
                          </div>
                        </div>
                        <div className="modal__content__tabs__body__tab__result__body">
                          {/* <!-- RESULT LETTER --> */}
                          <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--letter">
                            A
                          </div>
                          {/* <!-- END OF RESULT LETTER --> */}

                          {/* <!-- RESULT ROW --> */}
                          {this.state.companys.map((company, index) => (
                            <div
                              key={index}
                              className="modal__content__tabs__body__tab__result__body__row"
                            >
                              <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--1">
                                {/* <div className="user-photo"></div> */}
                                <UserPhoto />
                              </div>
                              <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--13">
                                <div className="user">
                                  <div className="user-name">
                                    {company.name}
                                  </div>
                                  <div className="user-phone">
                                    {company.cnpj}
                                  </div>
                                </div>
                              </div>

                              <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--7 modal__content__tabs__body__tab__result__body__col--pull-right">
                                <div className="modal__content__tabs__body__tab__result__body__actions">
                                  <a
                                    onClick={(event) =>
                                      this.ShowModal(
                                        event,
                                        "modal__agenda-pj-empresa-detalhes",
                                        company,
                                        true,
                                      )
                                    }
                                    className="modal__content__tabs__body__tab__result__body__actions__action"
                                  >
                                    <i className="material-icons">visibility</i>
                                  </a>
                                  <Popover
                                    trigger="click"
                                    boundary="window"
                                    placement="left"
                                    multiple={true}
                                    interactive={true}
                                    content={this.renderPopoverInfoCompany(
                                      this,
                                      company,
                                      InfoUsers.id,
                                    )}
                                  >
                                    <a
                                      className="modal__content__tabs__body__tab__result__body__actions__action tippy-context-menu"
                                      data-tippy-placement="left"
                                      data-template="modal-contato-mais-info"
                                    >
                                      <i className="material-icons">
                                        more_vert
                                      </i>
                                    </a>
                                  </Popover>
                                </div>
                              </div>
                            </div>
                          ))}

                          {this.state.companys && this.state.companys.length ? (
                            <NewPaginationV2
                              totalItems={
                                this.state.totalOfRows
                                  ? this.state.totalOfRows
                                  : 0
                              }
                              setPagination={(newPage) => {
                                this.setState({ pagination: newPage });
                              }}
                              setRowsPage={(newRowsPage) => {
                                this.setState({ rowsPage: newRowsPage });
                              }}
                              itemsPerPage={this.state.rowsPage}
                              setPageOfTable={(newPageOfTable) => {
                                this.setState({ pageOfTable: newPageOfTable });
                              }}
                              pageOfTable={this.state.pageOfTable}
                            />
                          ) : null}
                          {/* <!-- END OF RESULT ROW --> */}

                          <div
                            className={
                              this.state.buttonnewcompany
                                ? "flab is-active"
                                : "flab"
                            }
                          >
                            <a
                              className="flab__button"
                              onClick={this.ShowModalAddCompany.bind(
                                this,
                                InfoUsers.id,
                                InfoUsers.displayname,
                              )}
                            >
                              <div className="material-icons">add</div>
                            </a>
                            <div className="flab__related">
                              <a
                                onClick={this.ShowModalAddCompany.bind(
                                  this,
                                  InfoUsers.id,
                                  InfoUsers.displayname,
                                )}
                                className="flab__related__button tippy-default"
                                data-tippy-content="Adicionar um contato"
                                data-tippy-theme="light"
                                data-tippy-placement="left"
                              >
                                <div className="material-icons">person_add</div>
                              </a>
                            </div>
                            <div className="flab__overlay"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>

        <div
          className="modal micromodal-slide"
          id="modal__agenda-pj-empresa-detalhes-editar"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay new-company" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__agenda-pj-empresa-detalhes-editar__title"
            >
              <header className="modal__header">
                {/* <h2
                  className="modal__title"
                  id="modal__agenda-pj-empresa-detalhes-editar__title"
                >
                  Empresas
                </h2> */}
                <Typography.H2 color={"blue-selected-4"} weight={700}>
                  Empresas
                </Typography.H2>
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  onClick={(event) => this.CancelCompany(event)}
                ></button>
              </header>

              <main
                className="modal__content"
                id="modal__agenda-pj-empresa-detalhes-editar__content"
              >
                <div className="modal__content__user-details__header">
                  <div className="modal__content__user-details__header__info">
                    <UserPhoto size="large" />
                    <div className="modal__content__user-details__header__info__name">
                      {this.state.CompanyPerson}
                    </div>
                  </div>
                </div>

                <div className="modal__content__user-details__content">
                  <form action="" className="modal__content__form">
                    <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--nome"
                      >
                        Nome:
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line">
                        <input
                          type="text"
                          disabled={this.state.disabledcompany}
                          name="nome"
                          ref={(input) => (this.business = input)}
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--nome"
                        />
                        <div id="msg_erro5" className="invalid-feedback">
                          Mensagem
                        </div>
                      </div>
                    </div>

                    <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--cnpj"
                      >
                        CNPJ:
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line">
                        <InputMask
                          type="text"
                          mask="99.999.999/9999-99"
                          disabled={this.state.disabledcompany}
                          name="cnpj"
                          ref={(input) => (this.cnpjinsert = input)}
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--cnpj"
                        />
                      </div>
                    </div>
                    <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--email"
                      >
                        E-mail:
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line">
                        <input
                          type="email"
                          name="email"
                          disabled={this.state.disabledcompany}
                          ref={(input) => (this.emailcompany = input)}
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--email"
                        />
                      </div>
                    </div>

                    <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--site"
                      >
                        Site:
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line">
                        <input
                          type="text"
                          disabled={this.state.disabledcompany}
                          name="site"
                          ref={(input) => (this.site = input)}
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--site"
                        />
                      </div>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-half">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--cnpj"
                      >
                        Inscrição Estadual:
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line">
                        <InputMask
                          type="text"
                          disabled={this.state.disabledcompany}
                          mask="999.999-99"
                          ref={(input) => (this.inscricaoestadual = input)}
                          name="Inscrição Estadual"
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--cnpj"
                        />
                      </div>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-half">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--cnpj"
                      >
                        Inscrição Municipal:
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line">
                        <InputMask
                          type="text"
                          disabled={this.state.disabledcompany}
                          ref={(input) => (this.estadualmunicipal = input)}
                          name="cnpj"
                          mask="999999999999999999"
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--cnpj"
                        />
                      </div>
                    </div>

                    {/*<div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--codigo"
                      >
                        Código Externo:
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line">
                        <input
                          disabled={this.state.disabledcompany}
                          type="text"
                          ref={(input) => (this.codigoexternocompany = input)}
                          name="codigoexterno"
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--codigoext"
                        />
                      </div>
                    </div>*/}

                    <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--codigoext-company-2"
                      >
                        Código Externo:
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line">
                        <input
                          disabled={this.state.disabledcompany}
                          value={this.state.externalCodeCompanyInCompanyPage}
                          onChange={(event) => {
                            const newExternalCode = event.target.value;

                            this.setState({
                              externalCodeCompanyInCompanyPage: newExternalCode,
                            });
                          }}
                          type="text"
                          name="codigoexterno2"
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--codigoext-company-2"
                        />
                      </div>
                    </div>

                    <div className="modal__content__form__buttons">
                      <button
                        type="button"
                        onClick={(event) => this.CancelCompany(event)}
                        className="modal__content__form__group__button cancel-button"
                      >
                        <Typography.H4 color={"red-2"}>Cancelar</Typography.H4>
                      </button>
                      {(() => {
                        if (this.state.disabledcompany === true) {
                          return (
                            <button
                              type="button"
                              onClick={this.ButtonEditCompany.bind(
                                this,
                                false,
                                "edit",
                              )}
                              className="modal__content__form__group__button"
                            >
                              <Typography.H5 color={"white"} weight={700}>
                                Editar
                              </Typography.H5>
                            </button>
                          );
                        } else if (
                          this.state.disabledcompany === false &&
                          this.state.modulecompany === "edit"
                        ) {
                          return (
                            <button
                              type="button"
                              onClick={(event) =>
                                this.updateCompany(event, this.state.companyid)
                              }
                              className="modal__content__form__group__button"
                            >
                              <Typography.H5 color={"white"} weight={700}>
                                Salvar alterações
                              </Typography.H5>
                            </button>
                          );
                        } else {
                          return (
                            <button
                              type="button"
                              onClick={(event) =>
                                this.InsertCompany(event, InfoUsers.id)
                              }
                              className="modal__content__form__group__button"
                            >
                              <Typography.H5 color={"white"} weight={700}>
                                Adicionar
                              </Typography.H5>
                            </button>
                          );
                        }
                      })()}
                    </div>
                  </form>
                </div>
              </main>
            </div>
          </div>
        </div>

        {/* Modal de Historico */}

        <div
          className="modal micromodal-slide"
          id="modal__historico-atendimento-contact"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__historico-atendimento__title"
            >
              <header className="modal__header">
                <h2
                  className="modal__title"
                  id="modal__historico-atendimento__title"
                >
                  Interação
                </h2>
                <button
                  onClick={(event) => this.CloseHistory(event)}
                  className="modal__close"
                  aria-label="Close modal"
                  data-micromodal-close
                ></button>
              </header>
              <main
                className="modal__content"
                id="modal__historico-atendimento__content"
              >
                <div className="hist-atd__info">
                  <div className="hist-atd__info-items">
                    <p className="hist-atd__name  is-poppins">
                      {this.state.cliente}
                    </p>
                    <i className="material-icons hist-atd__icon">
                      question_answer
                    </i>{" "}
                    <span className="hist-atd__info-text">
                      Total de{" "}
                      <span className="hist-atd__counter">
                        {this.state.totalhistory}
                      </span>{" "}
                      interações&#x28;s&#x29;
                    </span>
                  </div>
                  {(() => {
                    if (InfoUsers.permdownload === true) {
                      return (
                        <div className="hist-atd__info-pdf">
                          <a onClick={this.exportPDFWithMethod}>
                            <img src={ICONPDFEXPORT} />
                            Exportar PDF
                          </a>
                        </div>
                      );
                    }
                  })()}
                </div>
                <div className="hist-atd__ctrls">
                  <p className="hist-atd__text">Período</p>
                  <span className="hist-atd__span">De:</span>
                  <input
                    type="datetime-local"
                    ref={(input) => (this.datahistoryinitcontact = input)}
                    className="hist-atd__end"
                    id="hist_start_queue"
                  />
                  <span className="hist-atd__span">Até:</span>
                  <input
                    type="datetime-local"
                    ref={(input) => (this.datahistoryfimcontact = input)}
                    className="hist-atd__end"
                    id="hist_end_queue"
                  />
                  <button
                    className="hist-atd__search-btn"
                    onClick={this.SearchHistoryContact.bind(
                      this,
                      this.state.cdrid,
                      this.state.cliente,
                    )}
                  >
                    Filtrar
                  </button>
                </div>
                <div className="hist-atd__content">
                  <div
                    className={
                      this.state.showHistory
                        ? "hist-atd__search active"
                        : "hist-atd__search"
                    }
                  >
                    <span
                      onClick={(event) => this.handleKeyUp("less")}
                      className="material-icons hist-atd__search-icon"
                    >
                      expand_less
                    </span>
                    <span
                      onClick={(event) => this.handleKeyUp("more")}
                      className="material-icons hist-atd__search-icon"
                    >
                      expand_more
                    </span>
                    <input
                      onChange={(event) => this.GetTermText(event)}
                      type="text"
                      className="hist-atd__search-input"
                      id="campopesquisartexto"
                      placeholder="Pesquisar..."
                    />
                    <button
                      onClick={this.SearchInHistoryContact.bind(this)}
                      className="hist-atd__search-btn hist-atd__search-btn--two"
                    >
                      Concluir
                    </button>
                  </div>
                  <div className="hist-atd__channel-info">
                    <img
                      className="hist-atd__channel-info-icon"
                      style={{ display: "none" }}
                      src={WHATSAPP}
                      alt=""
                      width="20"
                      height="20"
                    />
                    <div className="hist-atd__channel-info-time">
                      Interações
                    </div>
                  </div>
                  <div
                    className="hist-atd__wrapper"
                    onScroll={this.handleScroll}
                  >
                    <div className="hist-atd__channel">
                      <div className="hist-atd__channel-chat active">
                        {this.state.history.map((history, index) => (
                          <div
                            key={index}
                            className={
                              history.agente === true
                                ? "message right"
                                : "message left"
                            }
                          >
                            {(() => {
                              dia = history.diaenvio;
                              mes = history.mesenvio;
                              ano = history.anoenvio;
                              mes = meses.indexOf(mes);
                              dia = dia + " de " + meses[mes - 1];
                              if (
                                ano < history.anoenvio ||
                                ano > history.anoenvio
                              )
                                dia = dia + " de " + history.anoenvio;
                              if (dia != auxdia) {
                                dia = dia;
                                auxdia = dia;
                              } else {
                                auxdia = dia;
                                dia = "";
                              }
                            })()}
                            <div id={history.id} className="time">
                              {dia}
                            </div>
                            <div
                              className="bubble"
                              id={"contact_" + history.id}
                            >
                              {(() => {
                                if (history.replyid > 0) {
                                  var text = "";
                                  var array = [];
                                  var posit = "";
                                  checkreply = true;

                                  array = this.state.history.filter(
                                    (msg) =>
                                      parseInt(msg.id) ===
                                      parseInt(history.replyid),
                                  );
                                  if (array.length !== 0 && array) {
                                    posit = array[0].author;
                                    if (array[0].mimetypeid !== 1) {
                                      var url = array[0].messagem;
                                      url = url.substring(
                                        url.lastIndexOf(".") + 1,
                                      );
                                      switch (url.toLowerCase()) {
                                        case "jpeg":
                                        case "png":
                                        case "jpg": {
                                          return (
                                            <a
                                              href={
                                                "#contact_" + history.replyid
                                              }
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente,
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={FOTO}
                                                    alt=""
                                                    width="15"
                                                  />{" "}
                                                  Imagem
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                        case "pdf":
                                          return (
                                            <a
                                              href={
                                                "#contact_" + history.replyid
                                              }
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente,
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={DOC}
                                                    alt=""
                                                    width="15"
                                                  />{" "}
                                                  PDF
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        case "xls":
                                        case "xlsx":
                                        case "xlsm":
                                        case "doc":
                                        case "docx":
                                        case "ppt":
                                        case "pptx": {
                                          return (
                                            <a
                                              href={
                                                "#contact_" + history.replyid
                                              }
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente,
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={DOC}
                                                    alt=""
                                                    width="15"
                                                  />{" "}
                                                  DOC
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                        case "wav":
                                        case "mp3":
                                        case "ogg":
                                        case "mpeg": {
                                          return (
                                            <a
                                              href={
                                                "#contact_" + history.replyid
                                              }
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente,
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={AUDIO}
                                                    alt=""
                                                    width="12"
                                                  />{" "}
                                                  Áudio
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                        case "mp4": {
                                          return (
                                            <a
                                              href={
                                                "#contact_" + history.replyid
                                              }
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente,
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  <img
                                                    src={VIDEO}
                                                    alt=""
                                                    width="15"
                                                  />{" "}
                                                  Vídeo
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                      }
                                    } else {
                                      text = array[0].messagem;
                                      if (text.length > 200)
                                        text = text.substr(0, 200) + "...";
                                      text = text.replace(/¿/gi, "\n");
                                      text = text.replace(/§/gi, "\r\n");
                                      return (
                                        <a href={"#contact_" + history.replyid}>
                                          <div className="reply-message active">
                                            <div className="reply-message__name">
                                              {posit === "Me"
                                                ? "Você"
                                                : createJSON(
                                                    this.state.cliente,
                                                  )}
                                            </div>
                                            <div className="reply-message__text">
                                              {text}
                                            </div>
                                          </div>
                                        </a>
                                      );
                                    }
                                  }
                                }
                                //}
                              })()}

                              <div className="bubble-user-name">
                                {checkreply === false
                                  ? history.agente === false
                                    ? createJSON(this.state.cliente)
                                    : history.username
                                  : null}
                              </div>
                              <div className="text">
                                {(() => {
                                  let caption = history.caption;
                                  if (caption == "null" || caption == null) {
                                    caption = "";
                                  } else {
                                    caption = caption.replace(/\\n/g, "\r\n");
                                  }
                                  var positmessage1 = "";
                                  var positmessage2 = "";
                                  if (history.is_from_agent === true) {
                                    positmessage1 = " right";
                                  }
                                  checkreply = false;
                                  if (history.mimetypeid == "1") {
                                    var mensagem_tratada = tratarMSG(
                                      history.messagem,
                                    );
                                    mensagem_tratada = mensagem_tratada.replace(
                                      /\\n/gi,
                                      "\r\n",
                                    );
                                    return (
                                      <div>
                                        <Highlighter
                                          highlightClassName="YourHighlightClass"
                                          searchWords={searchWords}
                                          autoEscape={true}
                                          textToHighlight={mensagem_tratada}
                                          sanitize={latinize}
                                        />
                                        <span className="text__end-spacing"></span>
                                      </div>
                                    );
                                  } else {
                                    if (history.mimetypeid == "2") {
                                      if (isJson(history.messagem) === true) {
                                        let json = JSON.parse(history.messagem);
                                        let options = json.options;
                                        let i = 1;
                                        var opcoes = [];
                                        for (i in options) {
                                          opcoes.push(
                                            i + " - " + options[i][1],
                                          );
                                        }
                                        return (
                                          <div>
                                            <Highlighter
                                              highlightClassName="YourHighlightClass"
                                              searchWords={searchWords}
                                              autoEscape={true}
                                              textToHighlight={
                                                json.msg + " \r\n "
                                              }
                                              sanitize={latinize}
                                            />
                                            <Highlighter
                                              highlightClassName="YourHighlightClass"
                                              searchWords={searchWords}
                                              autoEscape={true}
                                              textToHighlight={opcoes.join(
                                                "  \r\n  ",
                                              )}
                                              sanitize={latinize}
                                            />
                                            <span className="text__end-spacing"></span>
                                          </div>
                                        );
                                      } else {
                                        return (
                                          <div>
                                            <Highlighter
                                              highlightClassName="YourHighlightClass"
                                              searchWords={searchWords}
                                              autoEscape={true}
                                              textToHighlight={history.messagem}
                                              sanitize={latinize}
                                            />
                                            <span className="text__end-spacing"></span>
                                          </div>
                                        );
                                      }
                                    } else if (history.mimetypeid == "30") {
                                      if (isJson(history.messagem) === true) {
                                        let json = JSON.parse(history.messagem);
                                        let options = json.options;
                                        let i = 1;
                                        var opcoes = [];
                                        for (i in options) {
                                          opcoes.push(
                                            i + " - " + options[i][1],
                                          );
                                        }
                                        if (json.MSG) {
                                          return (
                                            <div>
                                              <Highlighter
                                                highlightClassName="YourHighlightClass"
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={
                                                  json.MSG + " \r\n "
                                                }
                                                sanitize={latinize}
                                              />
                                              <Highlighter
                                                highlightClassName="YourHighlightClass"
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={opcoes.join(
                                                  "  \r\n  ",
                                                )}
                                                sanitize={latinize}
                                              />
                                              <span className="text__end-spacing"></span>
                                            </div>
                                          );
                                        } else if (json.URL) {
                                          return (
                                            <div>
                                              <Highlighter
                                                highlightClassName="YourHighlightClass"
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={
                                                  json.URL + " \r\n "
                                                }
                                                sanitize={latinize}
                                              />
                                              <Highlighter
                                                highlightClassName="YourHighlightClass"
                                                searchWords={searchWords}
                                                autoEscape={true}
                                                textToHighlight={opcoes.join(
                                                  "  \r\n  ",
                                                )}
                                                sanitize={latinize}
                                              />
                                              <span className="text__end-spacing"></span>
                                            </div>
                                          );
                                        }
                                      } else {
                                        return (
                                          <div>
                                            <Highlighter
                                              highlightClassName="YourHighlightClass"
                                              searchWords={searchWords}
                                              autoEscape={true}
                                              textToHighlight={history.messagem}
                                              sanitize={latinize}
                                            />
                                            <span className="text__end-spacing"></span>
                                          </div>
                                        );
                                      }
                                    } else if (
                                      history.mimetypeid == "3" ||
                                      history.mimetypeid == "4" ||
                                      history.mimetypeid == "5" ||
                                      history.mimetypeid >= "6"
                                    ) {
                                      let separador =
                                        history.messagem.split(".");
                                      switch (separador[1]) {
                                        case "jpeg":
                                        case "png":
                                        case "PNG":
                                        case "jpg":
                                          return (
                                            <div className="bubble-media">
                                              <div
                                                className="bubble-media__image"
                                                onClick={(e) =>
                                                  this.VerifierImage(
                                                    e,
                                                    connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      history.messagem,
                                                    "history",
                                                  )
                                                }
                                              >
                                                {this.state.isOpen && (
                                                  <Lightbox
                                                    mainSrc={
                                                      this.state.urlimage
                                                    }
                                                    onCloseRequest={(e) =>
                                                      this.CloseImage(
                                                        e,
                                                        "history",
                                                      )
                                                    }
                                                  />
                                                )}
                                                <img
                                                  src={
                                                    connection_platform.type_connect +
                                                    "://" +
                                                    ipcurrent +
                                                    history.messagem
                                                  }
                                                  alt=""
                                                />
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={JPG}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize,
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        case "pdf":
                                          return (
                                            <div className="bubble-media">
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={PDF}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize,
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        case "xls":
                                        case "xlsx":
                                        case "xlsm":
                                        case "doc":
                                        case "docx":
                                        case "ppt":
                                        case "pptx":
                                          return (
                                            <div className="bubble-media">
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={XLS}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize,
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        case "wav":
                                        case "mp3":
                                        case "ogg":
                                        case "mpeg":
                                          return (
                                            <div className="bubble-media">
                                              <div className="bubble-media__playerBar">
                                                <audio controls>
                                                  <source
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      history.messagem
                                                    }
                                                    type="audio/ogg"
                                                  />
                                                  <source
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      history.messagem
                                                    }
                                                    type="audio/mpeg"
                                                  />
                                                  Your browser.
                                                </audio>
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={MP3}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize,
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        case "mp4":
                                          return (
                                            <div className="bubble-media">
                                              <div className="bubble-media__video">
                                                <video
                                                  className="bubble-media__video-frame"
                                                  controls
                                                >
                                                  <source
                                                    className="bubble-media__video-file"
                                                    src={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      history.messagem
                                                    }
                                                    type="video/mp4"
                                                  />
                                                  Seu navegador nao suporta esse
                                                  tipo de arquivo.
                                                </video>
                                              </div>
                                              <div className="bubble-media__mediaInfo">
                                                <span className="bubble-media__fileType">
                                                  <img
                                                    className="bubble-media__fileIcon"
                                                    src={AVI}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="bubble-media__fileName">
                                                  <p className="bubble-media__text">
                                                    Nome do Arquivo
                                                  </p>
                                                  <br />
                                                  <div className="fileinfo__bar">
                                                    <span className="fileinfo__size">
                                                      {dbfileSize(
                                                        history.filesize,
                                                      )}
                                                    </span>{" "}
                                                    •{" "}
                                                    <span className="fileinfo__type">
                                                      {""}
                                                    </span>
                                                  </div>
                                                </span>
                                                {(() => {
                                                  if (
                                                    InfoUsers.permdownload ===
                                                    true
                                                  ) {
                                                    return (
                                                      <div className="bubble-media__download">
                                                        <a
                                                          href={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          target="_blank"
                                                          download
                                                          className="bubble-media__btnDownload"
                                                        >
                                                          <i className="material-icons">
                                                            get_app
                                                          </i>
                                                        </a>
                                                      </div>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            </div>
                                          );
                                          break;
                                        default:
                                          if (
                                            history.messagem.indexOf("https") >
                                              -1 &&
                                            history.messagem !== ""
                                          ) {
                                            if (
                                              parseInt(history.mimetypeid) ===
                                                16 ||
                                              parseInt(history.mimetypeid) ===
                                                41
                                            ) {
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__video">
                                                    <video
                                                      className="bubble-media__video-frame"
                                                      controls
                                                    >
                                                      <source
                                                        className="bubble-media__video-file"
                                                        src={history.messagem}
                                                        type="video/mp4"
                                                      />
                                                      Seu navegador nao suporta
                                                      esse tipo de arquivo.
                                                    </video>
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      {/* <img className="bubble-media__fileIcon" src={AVI} alt="" /> */}
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize,
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                            } else if (
                                              parseInt(history.mimetypeid) === 1
                                            ) {
                                              var mensagem_tratada = tratarMSG(
                                                history.messagem,
                                              );
                                              mensagem_tratada =
                                                mensagem_tratada.replace(
                                                  /\\n/gi,
                                                  "\r\n",
                                                );
                                              return (
                                                <div>
                                                  <Highlighter
                                                    highlightClassName="YourHighlightClass"
                                                    searchWords={searchWords}
                                                    autoEscape={true}
                                                    textToHighlight={
                                                      mensagem_tratada
                                                    }
                                                    sanitize={latinize}
                                                  />
                                                  <span className="text__end-spacing"></span>
                                                </div>
                                              );
                                            } else if (
                                              parseInt(history.mimetypeid) ===
                                                5 ||
                                              parseInt(history.mimetypeid) ===
                                                7 ||
                                              parseInt(history.mimetypeid) ===
                                                8 ||
                                              parseInt(history.mimetypeid) ===
                                                9 ||
                                              parseInt(history.mimetypeid) ===
                                                10 ||
                                              parseInt(history.mimetypeid) ===
                                                11 ||
                                              parseInt(history.mimetypeid) ===
                                                12 ||
                                              parseInt(history.mimetypeid) ===
                                                13 ||
                                              parseInt(history.mimetypeid) ===
                                                14
                                            ) {
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType"></span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize,
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                            } else if (
                                              parseInt(history.mimetypeid) ===
                                                4 ||
                                              parseInt(history.mimetypeid) ===
                                                6 ||
                                              parseInt(history.mimetypeid) ===
                                                15 ||
                                              parseInt(history.mimetypeid) ===
                                                17 ||
                                              parseInt(history.mimetypeid) ===
                                                21 ||
                                              parseInt(history.mimetypeid) ===
                                                25 ||
                                              parseInt(history.mimetypeid) ===
                                                26 ||
                                              parseInt(history.mimetypeid) ===
                                                27 ||
                                              parseInt(history.mimetypeid) ===
                                                28 ||
                                              parseInt(history.mimetypeid) ===
                                                40
                                            ) {
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__playerBar">
                                                    <audio controls>
                                                      <source
                                                        src={history.messagem}
                                                        type="audio/ogg"
                                                      />
                                                      <source
                                                        src={history.messagem}
                                                        type="audio/mpeg"
                                                      />
                                                      Your browser.
                                                    </audio>
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      {/* <img className="bubble-media__fileIcon" src={MP3} alt="" /> */}
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize,
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                            } else if (
                                              parseInt(history.mimetypeid) ===
                                                3 ||
                                              parseInt(history.mimetypeid) ===
                                                18 ||
                                              parseInt(history.mimetypeid) ===
                                                19 ||
                                              parseInt(history.mimetypeid) ===
                                                20 ||
                                              parseInt(history.mimetypeid) ===
                                                22 ||
                                              parseInt(history.mimetypeid) ===
                                                23 ||
                                              parseInt(history.mimetypeid) ===
                                                24
                                            ) {
                                              return (
                                                <div className="bubble-media">
                                                  <div
                                                    className="bubble-media__image"
                                                    onClick={(e) =>
                                                      this.VerifierImage(
                                                        e,
                                                        history.messagem,
                                                        "history",
                                                      )
                                                    }
                                                  >
                                                    {this.state.isOpen && (
                                                      <Lightbox
                                                        mainSrc={
                                                          this.state.urlimage
                                                        }
                                                        onCloseRequest={(e) =>
                                                          this.CloseImage(
                                                            e,
                                                            "history",
                                                          )
                                                        }
                                                      />
                                                    )}
                                                    <img
                                                      src={history.messagem}
                                                      alt=""
                                                    />
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType"></span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize,
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                            }
                                          }
                                      }
                                    }
                                  }
                                })()}
                              </div>
                              <div className="text">
                                {(() => {
                                  let caption = history.caption;
                                  if (caption == "null" || caption == null) {
                                    caption = "";
                                  } else {
                                    caption = caption.replace(/\\n/g, "\r\n");
                                  }
                                  return caption;
                                })()}
                              </div>
                              <div className="bubble__info-content">
                                <div className="fav fav--inside fav--right">
                                  {/* <i className="material-icons fav-icon">star_border</i> */}
                                </div>
                                <div className="bubble__info-content__time">
                                  {history.horaenvio}
                                </div>
                                {(() => {
                                  if (history.agente === true) {
                                    if (parseInt(history.mon_type_id) !== 2) {
                                      if (history.dateerror !== null)
                                        return (
                                          <div
                                            className={
                                              "message-info message-info--error"
                                            }
                                          >
                                            <i className="material-icons">
                                              error
                                            </i>
                                          </div>
                                        );
                                      else if (history.dateread !== null)
                                        return (
                                          <div
                                            className={
                                              "message-info message-info--visto"
                                            }
                                          >
                                            <i className="material-icons">
                                              done_all
                                            </i>
                                          </div>
                                        );
                                      else if (history.datedelivered !== null)
                                        return (
                                          <div className={"message-info"}>
                                            <i className="material-icons">
                                              done_all
                                            </i>
                                          </div>
                                        );
                                      else
                                        return (
                                          <div className={"message-info"}>
                                            <i className="material-icons">
                                              done
                                            </i>
                                          </div>
                                        );
                                    } else {
                                      return (
                                        <div
                                          className={
                                            "message-info message-info--visto"
                                          }
                                        >
                                          <i className="material-icons">
                                            done_all
                                          </i>
                                        </div>
                                      );
                                    }
                                  }
                                })()}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </main>

              <button
                className="hist-atd__fab"
                onClick={this.SearchInHistoryContact.bind(this)}
              >
                <i className="material-icons">search</i>
              </button>

              <div className="modal__content__form__group modal__content__form__group--col-1">
                <a
                  onClick={(event) => this.CloseHistory(event)}
                  className="modal__content__form__group__button modal__content__form__group__button--text"
                  data-micromodal-close
                >
                  <i className="material-icons" data-micromodal-close>
                    arrow_back
                  </i>
                  Voltar
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            right: "-9999999999999999999999999px",
            top: 0,
          }}
        >
          <PDFExport
            ref={(component) => (this.pdfExportComponent = component)}
            paperSize="A4"
          >
            <PdfDocument
              history={this.state.history}
              cliente={this.state.cliente}
              datapdfinit={this.state.datapdfinit}
              datapdfend={this.state.datapdfend}
              numero={this.state.clientpdf}
            />
          </PDFExport>
        </div>
        {/* Fim do Modal de Historico */}
        <div
          className="modal micromodal-slide"
          id="modal__agenda-pf-usuario-detalhes"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay new-contact" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__agenda-pf-usuario-detalhes__title"
            >
              <header className="modal__header">
                {/* <h2
                  className="modal__title"
                  id="modal__agenda-pf-usuario-detalhes__title"
                >
                  {TELAPJPF}
                </h2> */}
                <Typography.H2 color={"blue-selected-4"} weight={700}>
                  {TELAPJPF}
                </Typography.H2>
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  onClick={(event) =>
                    this.ExitModal(event, "modal__agenda-pf-usuario-detalhes")
                  }
                ></button>
              </header>
              <main
                className="modal__content"
                id="modal__agenda-pf-usuario-detalhes__content"
              >
                <div className="modal__content__user-details__header">
                  <div className="modal__content__user-details__header__info">
                    {(() => {
                      if (this.state.pathfile) {
                        if (this.state.pathfile.length === 1) {
                          return (
                            <div className="photo-container-one active">
                              <Topover
                                interactive={true}
                                content={this.renderPopoverPhotoContact(
                                  this,
                                  connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    this.state.pathfile[0].pathfile,
                                )}
                              >
                                <div className="photo-container-one__item">
                                  {/* <img
                                    src={
                                      this.state.pathfile[0].pathfile ===
                                        null || ""
                                        ? DEFAULT
                                        : connection_platform.type_connect +
                                          "://" +
                                          ipcurrent +
                                          this.state.pathfile[0].pathfile
                                    }
                                  /> */}
                                  <UserPhoto
                                    size="large"
                                    link={
                                      this.state.pathfile[0].pathfile ===
                                        null || ""
                                        ? false
                                        : this.state.pathfile[0].pathfile
                                    }
                                  />
                                  <div className="photo-container__list__item__social">
                                    {(() => {
                                      if (
                                        this.state.pathfile[0].midiaid === 1
                                      ) {
                                        return (
                                          <img
                                            alt="ícone da chamada de voz"
                                            width="22"
                                            height="22"
                                            src={CALLCHAT}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 2
                                      ) {
                                        return (
                                          <img
                                            alt="ícone do webchat"
                                            width="22"
                                            height="22"
                                            src={MIDIAWEB}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 3
                                      ) {
                                        return (
                                          <img
                                            alt="ícone do email"
                                            width="22"
                                            height="22"
                                            src={MIDIAEMAIL}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 4
                                      ) {
                                        return (
                                          <img
                                            alt="ícone do facebook"
                                            width="22"
                                            height="22"
                                            src={MIDIAFACE}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 5
                                      ) {
                                        return (
                                          <img
                                            alt="ícone do whatsapp"
                                            width="22"
                                            height="22"
                                            src={MIDIAZAP}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 6
                                      ) {
                                        return (
                                          <img
                                            alt="ícone do instagram"
                                            width="22"
                                            height="22"
                                            src={INSTAGRAM}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 8
                                      ) {
                                        return (
                                          <img
                                            alt="ícone do telegram"
                                            width="22"
                                            height="22"
                                            src={MIDIATELEGRAM}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 9
                                      ) {
                                        return (
                                          <img
                                            alt="ícone do twitter"
                                            width="22"
                                            height="22"
                                            src={TWITTER}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 10
                                      ) {
                                        return (
                                          <img
                                            alt="ícone do linkedin"
                                            width="22"
                                            height="22"
                                            src={LINKEDIN}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 11
                                      ) {
                                        return (
                                          <img
                                            alt="ícone do googleGBM"
                                            width="22"
                                            height="22"
                                            src={GOOGLEGBM}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 12
                                      ) {
                                        return <SMSICON />;
                                      } else if (
                                        this.state.pathfile[0].midiaid === 15
                                      ) {
                                        return (
                                          <img
                                            alt="ícone do Teams"
                                            width="22"
                                            height="22"
                                            src={TEAMS}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 16
                                      ) {
                                        return (
                                          <img
                                            alt="ícone do WhatsApp Voz"
                                            width="22"
                                            height="22"
                                            src={MIDIAZAPVOZ}
                                          />
                                        );
                                      }
                                    })()}
                                  </div>
                                </div>
                              </Topover>
                            </div>
                          );
                        } else {
                          return (
                            <div className="new-photo-container active ">
                              <div className="new-photo-container__list">
                                {this.state.pathfile
                                  .slice(0, this.state.pathfile.length)
                                  .map((path) => (
                                    <>
                                      <div className="photo-container__list__item photo-container__list__item--v2">
                                        {path.pathfile ? (
                                          <Topover
                                            interactive={true}
                                            content={this.renderPopoverPhotoContact(
                                              this,
                                              connection_platform.type_connect +
                                                "://" +
                                                ipcurrent +
                                                this.state.pathfile[0].pathfile,
                                            )}
                                          >
                                            <UserPhoto
                                              size="large"
                                              link={
                                                path.pathfile === null || ""
                                                  ? false
                                                  : path.pathfile
                                              }
                                            />
                                          </Topover>
                                        ) : (
                                          <UserPhoto
                                            size="large"
                                            link={
                                              path.pathfile === null || ""
                                                ? false
                                                : path.pathfile
                                            }
                                          />
                                        )}
                                        {/* <img
                                          src={
                                            path.pathfile === null || ""
                                              ? DEFAULT
                                              : connection_platform.type_connect +
                                                "://" +
                                                ipcurrent +
                                                path.pathfile
                                          }
                                        /> */}
                                        <div className="photo-container__list__item__social">
                                          {(() => {
                                            if (path.midiaid === 1) {
                                              return (
                                                <img
                                                  alt="ícone da chamada de voz"
                                                  width="22"
                                                  height="22"
                                                  src={CALLCHAT}
                                                />
                                              );
                                            } else if (path.midiaid === 2) {
                                              return (
                                                <img
                                                  alt="ícone do webchat"
                                                  width="22"
                                                  height="22"
                                                  src={MIDIAWEB}
                                                />
                                              );
                                            } else if (path.midiaid === 3) {
                                              return (
                                                <img
                                                  alt="ícone do email"
                                                  width="22"
                                                  height="22"
                                                  src={MIDIAEMAIL}
                                                />
                                              );
                                            } else if (path.midiaid === 4) {
                                              return (
                                                <img
                                                  alt="ícone do facebook"
                                                  width="22"
                                                  height="22"
                                                  src={MIDIAFACE}
                                                />
                                              );
                                            } else if (path.midiaid === 5) {
                                              return (
                                                <img
                                                  alt="ícone do whatsapp"
                                                  width="22"
                                                  height="22"
                                                  src={MIDIAZAP}
                                                />
                                              );
                                            } else if (path.midiaid === 6) {
                                              return (
                                                <img
                                                  alt="ícone do instagram"
                                                  width="22"
                                                  height="22"
                                                  src={INSTAGRAM}
                                                />
                                              );
                                            } else if (path.midiaid === 8) {
                                              return (
                                                <img
                                                  alt="ícone do telegram"
                                                  width="22"
                                                  height="22"
                                                  src={MIDIATELEGRAM}
                                                />
                                              );
                                            } else if (path.midiaid === 9) {
                                              return (
                                                <img
                                                  alt="ícone do twitter"
                                                  width="22"
                                                  height="22"
                                                  src={TWITTER}
                                                />
                                              );
                                            } else if (path.midiaid === 10) {
                                              return (
                                                <img
                                                  alt="ícone do linkedin"
                                                  width="22"
                                                  height="22"
                                                  src={LINKEDIN}
                                                />
                                              );
                                            } else if (path.midiaid === 11) {
                                              return (
                                                <img
                                                  alt="ícone do googleGBM"
                                                  width="22"
                                                  height="22"
                                                  src={GOOGLEGBM}
                                                />
                                              );
                                            } else if (path.midiaid === 12) {
                                              return <SMSICON />;
                                            } else if (path.midiaid === 15) {
                                              return (
                                                <img
                                                  alt="ícone do Teams"
                                                  width="22"
                                                  height="22"
                                                  src={TEAMS}
                                                />
                                              );
                                            } else if (path.midiaid === 16) {
                                              return (
                                                <img
                                                  alt="ícone do WhatsApp Voz"
                                                  width="22"
                                                  height="22"
                                                  src={MIDIAZAPVOZ}
                                                />
                                              );
                                            }
                                          })()}
                                        </div>
                                      </div>
                                    </>
                                  ))}
                              </div>
                            </div>
                          );
                        }
                      } else {
                        return (
                          <div className="modal__content__user-details__header__info__photo">
                            person
                          </div>
                        );
                      }
                    })()}
                  </div>
                </div>
                <div className="modal__content__user-details__content">
                  <form action="" className="modal__content__form">
                    <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--nomecompleto"
                      >
                        Nome Completo:
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line">
                        {/* <i className="material-icons">person</i> */}
                        <input
                          disabled={this.state.disabled}
                          type="text"
                          onChange={this.ChangeDisplayname.bind(this)}
                          name="nomecompleto"
                          ref={(input) => (this.name = input)}
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--nomecompleto"
                        />
                        {this.state.errosDiv.nome && (
                          <div id="msg_erro1" className="invalid-feedback">
                            {/* Mensagem */}
                            {this.state.errosDiv.nome}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--nomedeapresentacao"
                      >
                        Nome de apresentação (Apelido):
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line">
                        {/* <i className="material-icons">person</i> */}
                        <input
                          disabled={this.state.disabled}
                          type="text"
                          name="displayname"
                          ref={(input) => (this.displayname = input)}
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--nomedeapresentacao"
                        />
                        {this.state.errosDiv.displayName && (
                          <div id="msg_erro2" className="invalid-feedback">
                            {/* Mensagem */}
                            {this.state.errosDiv.displayName}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--codigo"
                      >
                        Código Externo:
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line">
                        <input
                          disabled={this.state.disabled}
                          type="text"
                          ref={(input) => (this.codigoexterno = input)}
                          name="codigoexterno"
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--codigo"
                        />
                      </div>
                    </div>
                    {/* //VIM AQ */}
                    <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--nomedeapresentacao"
                      >
                        Empresa:
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line">
                        {/* <i className="material-icons">person</i> */}
                        <SelectSearchWithPagination
                          disabled={this.state.disabled}
                          paginated
                          style={{
                            height: "40px",
                            border: "1px solid #0000001A",
                          }}
                          value={
                            this.state.empresaC &&
                            Array.isArray(this.state.empresaC) &&
                            this.state.empresaC.length
                              ? this.state.empresaC[0]
                              : undefined
                          }
                          onSelect={(newCompany) => {
                            if (newCompany) {
                              this.setState({
                                empresaC: [
                                  {
                                    value: newCompany.value,
                                    label: newCompany.label,
                                    cnpj: newCompany.cnpj,
                                    externcode: newCompany.externcode,
                                  },
                                ],
                                companySelected: newCompany,
                              });
                            } else {
                              this.setState({
                                empresaC: "",
                                companySelected: undefined,
                              });
                            }
                          }}
                          getOptions={getListCompanys}
                        />
                        {this.state.errosDiv.empresa && (
                          <div id="msg_erro5" className="invalid-feedback">
                            {/* Mensagem */}
                            {this.state.errosDiv.empresa}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--nomedeapresentacao"
                      >
                        Cargo:
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line">
                        {/* <SelectTagV2
                          valueTag={[]}
                          options={this.state.todosCargos}
                          onSelect={(option) => {
                            this.setState({ cargoSelecionado: [option] });
                          }}
                          multiple={false}
                          isCallCenter={true}
                          isChipActive={false}
                        /> */}
                        <SelectSearchWithPagination
                          disabled={this.state.disabled}
                          value={
                            this.state.cargoSelecionado
                              ? this.state.cargoSelecionado
                              : undefined
                          }
                          options={this.state.todosCargos}
                          onSelect={(option) => {
                            this.setState({ cargoSelecionado: option });
                          }}
                        />
                      </div>
                    </div>

                    <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--nomedeapresentacao"
                      >
                        Responsável por
                      </Typography.H6>
                      {/* <MuiMultiSelect
                        value={this.state.responsavelPor}
                        disabled={this.state.disabled}
                        paginated={true}
                        getOptions={getListCompanys}
                        placeholder={
                          this.state.isLoadingResponsavelPor
                            ? "Carregando..."
                            : "Selecione"
                        }
                        onChange={(value) => {
                          this.setState({ responsavelPor: value });
                        }}
                      /> */}
                      <SelectSearchWithPaginationV2
                        multiple={true}
                        paginated
                        tooltip
                        style={{
                          height: "40px",
                          border: "1px solid #0000001A",
                        }}
                        value={this.state.responsavelPor}
                        onSelect={(value) => {
                          this.setState({ responsavelPor: value });
                        }}
                        placeholder={
                          this.state.isLoadingResponsavelPor
                            ? "Carregando..."
                            : "Selecione"
                        }
                        getOptions={getListCompanys}
                        disabled={this.state.disabled}
                      />
                    </div>

                    <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--nomedeapresentacao"
                      >
                        Relação do contato:
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line new-select-tag-v2">
                        {/* <SelectTagV2
                          valueTag={this.state.relacaoSelecionada}
                          options={this.state.todasRelacoes}
                          onSelect={(option) => {
                            this.setState({ relacaoSelecionada: [option] });
                          }}
                          multiple={false}
                          isCallCenter={true}
                          isChipActive={false}
                        /> */}
                        <SelectSearchWithPagination
                          disabled={this.state.disabled}
                          value={
                            this.state.relacaoSelecionada
                              ? this.state.relacaoSelecionada
                              : undefined
                          }
                          options={this.state.todasRelacoes}
                          onSelect={(option) => {
                            this.setState({ relacaoSelecionada: option });
                          }}
                        />
                      </div>
                    </div>

                    <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--contatode"
                      >
                        Vincular ao contato de:
                      </Typography.H6>
                      <Select
                        isDisabled={this.state.disabled}
                        value={this.state.contatode}
                        onChange={this.SelectContato.bind(this)}
                        name="contatode"
                        className="modal__content__form__group__input modal__content__form__group__input--v2"
                        id="modal__content__form__group__label--empresa"
                        options={options}
                      />
                      {this.state.errosDiv.contato && (
                        <div id="msg_erro3" className="invalid-feedback">
                          {/* Mensagem */}
                          {this.state.errosDiv.contato}
                        </div>
                      )}
                    </div>

                    {/* <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--email"
                      >
                        E-mail:
                      </Typography.H6>
                      <div className="modal__content__form__group__input-line">
                        <i className="material-icons">email</i>
                        <input
                          disabled={this.state.disabled}
                          type="email"
                          ref={(input) => (this.email = input)}
                          name="email"
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--email"
                        />
                      </div>
                    </div> */}

                    <div className="modal__content__form__group">
                      <Typography.H6
                        color={"gray-600"}
                        className="modal__content__form__group__title"
                      >
                        Esse contato é particular?
                      </Typography.H6>
                      <div
                        className={`modal__content__form__group__radios ${
                          this.state.disabled ? "disabled" : ""
                        }`}
                      >
                        <div className="modal__content__form__group__radios__option">
                          <Checkbox
                            // typeCheck="checkbox"
                            radioBox={true}
                            disabled={this.state.disabled}
                            name="particular"
                            id="modal__content__form__group__radios__option--sim"
                            // defaultChecked={this.state.private}
                            checked={this.state.private === InfoUsers.id}
                            onClick={this.ContactPrivate.bind(
                              this,
                              InfoUsers.id,
                            )}
                            value="sim"
                          />
                          {/* <input
                            disabled={this.state.disabled}
                            type="radio"
                            onClick={this.ContactPrivate.bind(
                              this,
                              InfoUsers.id
                            )}
                            defaultChecked={
                              this.state.private !== "" &&
                              this.state.private !== null
                                ? "checked"
                                : ""
                            }
                            name="particular"
                            id="modal__content__form__group__radios__option--sim"
                            className="modal__content__form__group__radios__option__input"
                            value="sim"
                          /> */}
                          <label
                            htmlFor="modal__content__form__group__radios__option--sim"
                            className="modal__content__form__group__radios__option__label"
                          >
                            Sim
                          </label>
                        </div>
                        <div className="modal__content__form__group__radios__option">
                          <Checkbox
                            // typeCheck="checkbox"
                            radioBox={true}
                            disabled={this.state.disabled}
                            name="particular"
                            id="modal__content__form__group__radios__option--nao"
                            // defaultChecked={!this.state.private}
                            checked={this.state.private === null}
                            onClick={this.ContactPrivate.bind(this, null)}
                            value="nao"
                          />
                          {/* <input
                            disabled={this.state.disabled}
                            type="radio"
                            onClick={this.ContactPrivate.bind(this, null)}
                            defaultChecked={
                              this.state.private === "" ||
                              this.state.private === undefined ||
                              this.state.private === null
                                ? ""
                                : "checked"
                            }
                            name="particular"
                            id="modal__content__form__group__radios__option--nao"
                            className="modal__content__form__group__radios__option__input"
                            value="nao"
                          /> */}
                          <label
                            htmlFor="modal__content__form__group__radios__option--nao"
                            className="modal__content__form__group__radios__option__label"
                          >
                            Não
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* <!-- CONTATOS --> */}
                    <div className="modal__content__tabs__body__tab__result modal__content__tabs__body__tab__result--full-width">
                      <div className="modal__content__form__group--small modal__content__form__group--col-8">
                        <Typography.H2
                          color={"black"}
                          weight={700}
                          className="modal__content__form__group__label modal__content__form__group__label--small"
                        >
                          Canal
                        </Typography.H2>
                      </div>

                      {this.state.numberscontact.map((numbers) => (
                        <div className="modal__content__form__row">
                          <div className="modal__content__form__group-row">
                            <div className="modal__content__form__group__input-line tag-contact-v2">
                              {this.state.disabled ? (
                                this.handleTagContact(
                                  numbers,
                                  this.state.disabled,
                                )
                              ) : (
                                <NewSelect
                                  onRenderValue={(selected) =>
                                    this.handleTagContact(selected, false)
                                  }
                                  value={numbers}
                                  options={[
                                    { midiaid: 1, label: "Telefone" },
                                    { midiaid: 2, label: "Webchat" },
                                    { midiaid: 3, label: "Email" },
                                    { midiaid: 4, label: "Facebook" },
                                    { midiaid: 5, label: "Whatsapp" },
                                    { midiaid: 6, label: "Instagram" },
                                    { midiaid: 8, label: "Telegram" },
                                    { midiaid: 9, label: "Twitter" },
                                    { midiaid: 10, label: "LinkedIn" },
                                    { midiaid: 11, label: "GoogleGBM" },
                                    { midiaid: 12, label: "Sms" },
                                    { midiaid: 15, label: "Teams" },
                                    { midiaid: 16, label: "WhatsApp Voz" },
                                  ]}
                                  onSelect={this.EditTypeNumber}
                                  bind={this}
                                />
                              )}
                            </div>

                            <div
                              className="modal__content__form__row"
                              key={numbers.idphone}
                            >
                              <div className="modal__content__form__group__input-line total-width">
                                <InputMask
                                  disabled={this.state.disabled}
                                  style={{
                                    color:
                                      numbers.exist === true ? "#cc0033" : "",
                                  }}
                                  onChange={(event) =>
                                    this.EditNumber(
                                      event,
                                      numbers.idphone,
                                      numbers.midiaid === 1 ||
                                        numbers.midiaid === 5
                                        ? true
                                        : false,
                                    )
                                  }
                                  value={numbers.number}
                                  type="text"
                                  mask={
                                    (numbers.midiaid === 1 ||
                                      numbers.midiaid === 5) &&
                                    this.state.disabled
                                      ? this.maskNumber(numbers.number)
                                      : false
                                  }
                                  maskChar=""
                                  id={"telefone" + numbers.idphone}
                                  name={"telefone" + numbers.idphone}
                                  className="modal__content__form__group__input"
                                />
                              </div>

                              {(() => {
                                if (this.state.disabled === false) {
                                  return (
                                    <div className="modal__content__form__group__duplicate-btns">
                                      <a
                                        onClick={(event) =>
                                          this.concatNumberDel(
                                            event,
                                            numbers.idphone,
                                          )
                                        }
                                        className="modal__content__form__group__duplicate-btns__btn"
                                      >
                                        <IconMinus />
                                      </a>
                                    </div>
                                  );
                                }
                              })()}
                              {(() => {
                                if (numbers.exist === true) {
                                  return (
                                    <span style={{ color: "#cc0033" }}>
                                      Este número já existe
                                    </span>
                                  );
                                }
                              })()}
                            </div>
                          </div>
                        </div>
                      ))}
                      {(() => {
                        if (this.state.disabled === false) {
                          return (
                            <button
                              type="button"
                              className="more-info"
                              onClick={(event) => this.AddNumber(event)}
                            >
                              <Typography.H4 color={"blue-selected-4"}>
                                + Adicionar canal
                              </Typography.H4>
                            </button>
                          );
                        }
                      })()}
                    </div>

                    <div className="modal__content__form__group p-left">
                      {this.state.moreinfo ? (
                        <div className="more-info__container">
                          <Typography.H2 color={"black"} weight={700}>
                            Mais informações
                          </Typography.H2>
                          <IconMinus
                            onClick={(e) => this.setState({ moreinfo: false })}
                          />
                        </div>
                      ) : (
                        <button
                          className="more-info"
                          onClick={(e) => this.setState({ moreinfo: true })}
                        >
                          <Typography.H4 color={"blue-selected-4"}>
                            + Adicionar mais informações
                          </Typography.H4>
                        </button>
                      )}
                    </div>

                    <div
                      className={`modal__content__form__more-info ${
                        this.state.moreinfo ? "visible" : ""
                      }`}
                    >
                      <div className="modal__content__form__group">
                        <Typography.H6
                          color={"gray-600"}
                          className="modal__content__form__group__label"
                          htmlFor="modal__content__form__group__label--cpf"
                        >
                          CPF:
                        </Typography.H6>
                        <div className="modal__content__form__group__input-line">
                          <InputMask
                            disabled={this.state.disabled}
                            mask="999.999.999-99"
                            ref={(input) => (this.cpf = input)}
                            type="text"
                            name="cpf"
                            className="modal__content__form__group__input"
                            id="modal__content__form__group__label--cpf"
                          />
                        </div>
                      </div>

                      <div className="modal__content__form__group modal__content__form__group--col-half">
                        <Typography.H6
                          color={"gray-600"}
                          className="modal__content__form__group__label"
                          htmlFor="modal__content__form__group__label--rg"
                        >
                          RG:
                        </Typography.H6>
                        <div className="modal__content__form__group__input-line">
                          <InputMask
                            disabled={this.state.disabled}
                            mask="99.99.99.99-99"
                            type="text"
                            name="rg"
                            ref={(input) => (this.rg = input)}
                            className="modal__content__form__group__input"
                            id="modal__content__form__group__label--rg"
                          />
                        </div>
                      </div>

                      <div className="modal__content__form__group modal__content__form__group--col-half">
                        <Typography.H6
                          color={"gray-600"}
                          className="modal__content__form__group__label"
                          htmlFor="modal__content__form__group__label--nascimento"
                        >
                          Data de Nascimento:
                        </Typography.H6>
                        <div className="modal__content__form__group__input-line">
                          <input
                            disabled={this.state.disabled}
                            ref={(input) => (this.nascimento = input)}
                            type="date"
                            name="nascimento"
                            className="modal__content__form__group__input"
                            id="modal__content__form__group__label--nascimento"
                          />
                        </div>
                      </div>

                      {/* <div className="modal__content__form__group">
                        <Typography.H6
                          color={"gray-600"}
                          l
                          className="modal__content__form__group__label"
                          htmlFor="modal__content__form__group__label--empresa"
                        >
                          Empresa:
                        </Typography.H6>
                        <Select
                          isDisabled={this.state.disabled}
                          onChange={this.SelectEmpresa.bind(this)}
                          value={this.state.empresaC}
                          id="empresa"
                          name="empresa"
                          isLoading={false}
                          isClearable={true}
                          isRtl={false}
                          className="modal__content__form__group__input"
                          options={companys}
                        />
                    </div>*/}

                      <div className="modal__content__form__group">
                        <Typography.H6
                          color={"gray-600"}
                          className="modal__content__form__group__label"
                          htmlFor="modal__content__form__group__label--endereco"
                        >
                          Endereço:
                        </Typography.H6>
                        <div className="modal__content__form__group__input-line">
                          <input
                            disabled={
                              returnCep.cep && returnCep.cep.length !== 0
                                ? this.state.disabled
                                : true
                            }
                            ref={(input) => (this.endereco = input)}
                            type="text"
                            name="endereco"
                            className="modal__content__form__group__input"
                            id="modal__content__form__group__label--endereco"
                          />
                        </div>
                      </div>

                      <div className="modal__content__form__group modal__content__form__group--col-half">
                        <Typography.H6
                          color={"gray-600"}
                          className="modal__content__form__group__label"
                          htmlFor="modal__content__form__group__label--cep"
                        >
                          CEP:
                        </Typography.H6>
                        <div className="modal__content__form__group__input-line">
                          <InputMask
                            disabled={this.state.disabled}
                            onBlur={this.getCep.bind(this)}
                            mask="99999-999"
                            ref={(input) => (this.cep = input)}
                            type="text"
                            name="cep"
                            className="modal__content__form__group__input"
                            id="modal__content__form__group__label--cep"
                          />
                        </div>
                      </div>

                      <div className="modal__content__form__group modal__content__form__group--col-half">
                        <Typography.H6
                          color={"gray-600"}
                          className="modal__content__form__group__label"
                          htmlFor="modal__content__form__group__label--endnumero"
                        >
                          Número:
                        </Typography.H6>
                        <div className="modal__content__form__group__input-line">
                          <input
                            disabled={this.state.disabled}
                            ref={(input) => (this.numberaddress = input)}
                            type="text"
                            name="numberaddress"
                            className="modal__content__form__group__input"
                            id="modal__content__form__group__label--endnumero"
                          />
                          <input
                            disabled={this.state.disabled}
                            ref={(input) => (this.cepassociationid = input)}
                            type="hidden"
                            name="cepassociationid"
                            className="modal__content__form__group__input"
                            id="modal__content__form__group__label--endnumero"
                          />
                        </div>
                      </div>

                      <div className="modal__content__form__group modal__content__form__group--col-half">
                        <Typography.H6
                          color={"gray-600"}
                          className="modal__content__form__group__label"
                          htmlFor="modal__content__form__group__label--contatode"
                        >
                          Cidade:
                        </Typography.H6>
                        <div className="modal__content__form__group__input-line">
                          <input
                            disabled={
                              returnCep.cep && returnCep.cep.length !== 0
                                ? this.state.disabled
                                : true
                            }
                            ref={(input) => (this.cidade = input)}
                            type="text"
                            name="cidade"
                            className="modal__content__form__group__input"
                            id="modal__content__form__group__label--cidade"
                          />
                        </div>
                      </div>

                      <div className="modal__content__form__group modal__content__form__group--col-half">
                        <Typography.H6
                          color={"gray-600"}
                          className="modal__content__form__group__label"
                          htmlFor="modal__content__form__group__label--contatode"
                        >
                          Estado:
                        </Typography.H6>
                        <div className="modal__content__form__group__input-line">
                          <input
                            disabled={
                              returnCep.cep && returnCep.cep.length !== 0
                                ? this.state.disabled
                                : true
                            }
                            ref={(input) => (this.estado = input)}
                            type="text"
                            name="estado"
                            className="modal__content__form__group__input"
                            id="modal__content__form__group__label--estado"
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </main>
              <footer>
                <div className="modal__content__form__buttons">
                  <button
                    type="button"
                    onClick={(event) => this.CancelMenosCampos(event)}
                    className="modal__content__form__group__button cancel-button"
                  >
                    <Typography.H4 color={"red-2"}>Cancelar</Typography.H4>
                  </button>

                  {(() => {
                    if (this.state.disabled === true) {
                      return (
                        <button
                          type="button"
                          onClick={this.ButtonEdit.bind(this, false, "edit")}
                          className="modal__content__form__group__button"
                        >
                          <Typography.H5 color={"white"} weight={700}>
                            Editar
                          </Typography.H5>
                        </button>
                      );
                    } else if (
                      this.state.disabled === false &&
                      this.state.module === "edit"
                    ) {
                      if (this.state.isLoadingSavingAlterations) {
                        return (
                          <button
                            type="button"
                            className="modal__content__form__group__button"
                          >
                            <CircularProgress
                              size={24}
                              sx={{ color: "white" }}
                            />
                          </button>
                        );
                      }
                      return (
                        //VIM AQ
                        <button
                          type="button"
                          onClick={this.updateContactV2.bind(
                            this,
                            this.state.contactid,
                            this.state.numberscontact,
                            InfoUsers.id,

                            DetailsContacts,
                            options,
                          )}
                          className="modal__content__form__group__button"
                        >
                          <Typography.H5 color={"white"} weight={700}>
                            Salvar alterações
                          </Typography.H5>
                        </button>
                      );
                    } else {
                      return (
                        <button
                          type="button"
                          onClick={(event) =>
                            this.InsertContact(
                              event,
                              this.state.numberscontact,
                              InfoUsers.id,
                              DetailsContacts,
                              options,
                            )
                          }
                          className="modal__content__form__group__button"
                        >
                          <Typography.H5 color={"white"} weight={700}>
                            Adicionar
                          </Typography.H5>
                        </button>
                      );
                    }
                  })()}
                </div>
              </footer>
            </div>
          </div>
        </div>

        <div
          className="modal micromodal-slide"
          id="modal__agenda-pj-empresa-detalhes-editar-salvo"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__agenda-pj-empresa-detalhes-editar-salvo__title"
            >
              <header className="modal__header">
                <h2
                  className="modal__title"
                  id="modal__agenda-pj-empresa-detalhes-editar-salvo__title"
                >
                  Contatos
                </h2>
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  onClick={(event) =>
                    this.ShowModal(event, "modal_contato_salvo")
                  }
                ></button>
              </header>
              <main
                className="modal__content"
                id="modal__agenda-pj-empresa-detalhes-editar-salvo__content"
              >
                <form action="" className="modal__content__form">
                  <div className="modal__content__form__row">
                    <div className="modal__content__form__group modal__content__form__group--col-8">
                      <div className="modal__content-center">
                        <img src={CONTATOSALVO} alt="" />
                        <div className="modal-box__text-box">
                          <p className="modal-box__text-message">
                            Seu contato foi adicionado
                          </p>
                          <p className="modal-box__text-message modal-box__text-message--bold">
                            com sucesso!
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal__content__form__group modal__content__form__group--col-2"></div>
                  <div className="modal__content__form__group modal__content__form__group--col-2">
                    <a
                      onClick={(event) =>
                        this.ShowModal(event, "modal_contato_salvo")
                      }
                      className="modal__content__form__group__button"
                    >
                      Buscar um contato
                    </a>
                  </div>
                  <div className="modal__content__form__group modal__content__form__group--col-2">
                    <a
                      onClick={(event) => this.AddContactNew(event)}
                      className="modal__content__form__group__button modal__content__form__group__button--white"
                    >
                      Adicionar novo contato
                    </a>
                  </div>
                </form>
              </main>
            </div>
          </div>
        </div>
        <div
          className="modal micromodal-slide"
          id="modal__agenda-pj-empresa-detalhes-editar-salvo-company"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__agenda-pj-empresa-detalhes-editar-salvo__title"
            >
              <header className="modal__header">
                <h2
                  className="modal__title"
                  id="modal__agenda-pj-empresa-detalhes-editar-salvo__title"
                >
                  Empresas
                </h2>
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  onClick={(event) =>
                    this.ShowModal(event, "modal_contato_salvo-company")
                  }
                ></button>
              </header>
              <main
                className="modal__content"
                id="modal__agenda-pj-empresa-detalhes-editar-salvo__content"
              >
                <form action="" className="modal__content__form">
                  <div className="modal__content__form__row">
                    <div className="modal__content__form__group modal__content__form__group--col-8">
                      <div className="modal__content-center">
                        <img src={CONTATOSALVO} alt="" />
                        <div className="modal-box__text-box">
                          <p className="modal-box__text-message">
                            Empresa cadastrada
                          </p>
                          <p className="modal-box__text-message modal-box__text-message--bold">
                            com sucesso!
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal__content__form__group modal__content__form__group--col-2"></div>
                  <div className="modal__content__form__group modal__content__form__group--col-2">
                    <a
                      onClick={(event) =>
                        this.ShowModal(event, "modal_contato_salvo-company")
                      }
                      className="modal__content__form__group__button"
                    >
                      Buscar empresa
                    </a>
                  </div>
                  <div className="modal__content__form__group modal__content__form__group--col-2">
                    <a
                      onClick={(event) => this.AddCompanyNew(event)}
                      className="modal__content__form__group__button modal__content__form__group__button--white"
                    >
                      Nova empresa
                    </a>
                  </div>
                </form>
              </main>
            </div>
          </div>
        </div>

        {/* <div className="modal micromodal-slide" id="modal__agenda-pf__cliente__interacoes" aria-hidden="true" role="dialog">
                    <div className="modal__overlay" tabIndex="-1">
                        <div className="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal__agenda-pf__cliente__interacoes__title">
                            <header className="modal__header">
                            <h2 className="modal__title" id="modal__agenda-pf__cliente__interacoes__title">
                                Interações
                            </h2>
                            <button className="modal__close" aria-label="Close modal" onClick={event => this.ExitModal(event, 'modal__agenda-pf__cliente__interacoes')}></button>
                            </header>
                            <main className="modal__content" id="modal__agenda-pf__cliente__interacoes__content">
                            <div className="modal__content__user-details__header">
                                <div className="modal__content__user-details__header__info">
                                    {
                                    (() => {
                                            if(this.state.pathfile){
                                                if(this.state.pathfile.length === 1){
                                                    return <div className="photo-container-one active">
                                                                <Topover interactive={true} content={this.renderPopoverPhoto(this, IPCurrent.ip,this.state.pathfile[0].pathfile)}>
                                                                <div className="photo-container-one__item">
                                                                        <img src={this.state.pathfile[0].pathfile === null || "" ? DEFAULT:connection_platform.type_connect+'://'+ipcurrent+this.state.pathfile[0].pathfile} />
                                                                    <div className="photo-container__list__item__social">
                                                                        {
                                                                            (() => {
                                                                                if(this.state.pathfile[0].midiaid === 1){
                                                                                    return <img src={CALLCHAT} />
                                                                                }else if(this.state.pathfile[0].midiaid === 3){
                                                                                    return <img src={MIDIAWEB} />
                                                                                }else if(this.state.pathfile[0].midiaid === 4){
                                                                                    return <img src={MIDIAFACE} />
                                                                                }else if(this.state.pathfile[0].midiaid === 5){
                                                                                    return <img src={MIDIAZAP} />
                                                                                }
                                                                            })()
                                                                        }
                                                                    </div>
                                                                </div>
                                                                </Topover>
                                                            </div>
                                                }else{
                                                return <div className="photo-container active">
                                                        {this.state.pathfile.slice(0, 1).map(path => (
                                                            <div className="photo-container__img">
                                                                <div className="photo-container__img__s2"></div>
                                                                <div className="photo-container__img__s1"></div>
                                                                <div className="wrapper-photo">
                                                                    <img src={path.pathfile === null || "" ? DEFAULT:connection_platform.type_connect+'://'+ipcurrent+path.pathfile} />
                                                                    <div className="photo-container__list__item__social">
                                                                    {
                                                                            (() => {
                                                                                if(path.midiaid === 1){
                                                                                    return <img src={CALLCHAT} />
                                                                                }else if(path.midiaid === 3){
                                                                                    return <img src={MIDIAWEB} />
                                                                                }else if(path.midiaid === 4){
                                                                                    return <img src={MIDIAFACE} />
                                                                                }else if(path.midiaid === 5){
                                                                                    return <img src={MIDIAZAP} />
                                                                                }
                                                                            })()
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                            <div className="photo-container__list">
                                                                {this.state.pathfile.slice(1, this.state.pathfile.length).map(path => (
                                                                <>
                                                                <div className="photo-container__list__item"><img src={path.pathfile === null || "" ? DEFAULT:connection_platform.type_connect+'://'+ipcurrent+path.pathfile} />
                                                                    <div className="photo-container__list__item__social">
                                                                        {
                                                                            (() => {
                                                                                if(path.midiaid === 1){
                                                                                    return <img src={CALLCHAT} />
                                                                                }else if(path.midiaid === 3){
                                                                                    return <img src={MIDIAWEB} />
                                                                                }else if(path.midiaid === 4){
                                                                                    return <img src={MIDIAFACE} />
                                                                                }else if(path.midiaid === 5){
                                                                                    return <img src={MIDIAZAP} />
                                                                                }
                                                                            })()
                                                                        }
                                                                    </div>
                                                                </div>
                                                                </>
                                                                ))}
                                                            </div>
                                                        </div>  
                                                }
                                            }else{
                                                return  <div className="modal__content__user-details__header__info__photo">person</div>
                                            }
                                    })()   
                                }
                                <div className="modal__content__user-details__header__info__text">
                                    <div className="modal__content__user-details__header__info__name">{this.state.person}</div>
                                    <div className="modal__content__user-details__header__info__phone">{this.state.numberC}</div>
                                </div>
                                </div>













                                <div className="modal__content__user-details__header__search">
                                <div className="modal__content__user-details__header__search__title">Deseja buscar as interações de qual período?</div>
                                <div action="" className="modal__content__user-details__header__search__form">
                                    <div className="modal__content__user-details__header__search__form__col modal__content__user-details__header__search__form__col--half">
                                    <label htmlFor="modal__content__user-details__header__search__form__de" className="modal__content__user-details__header__search__form__col__label">De:</label>
                                    <input type="datetime-local" defaultValue={this.datainitinteract} ref={input => this.dataInit = input} className="modal__content__user-details__header__search__form__col__input" id="modal__content__user-details__header__search__form__de" />
                                    </div>
                                    <div className="modal__content__user-details__header__search__form__col modal__content__user-details__header__search__form__col--half">
                                    <label htmlFor="modal__content__user-details__header__search__form__ate" className="modal__content__user-details__header__search__form__col__label">Até:</label>
                                    <input type="datetime-local" defaultValue={this.datafiminteract} ref={input => this.dataFim = input} className="modal__content__user-details__header__search__form__col__input" id="modal__content__user-details__header__search__form__ate" />
                                    </div>
                                    <div className="block-header__search-box-nav">                    
                                        <div className="block-header__search-box-content-input">
                                        <input type="text" placeholder="Pesquisar mensagens..." onChange={e => this.setState({mensagem: e.target.value})} className="block-header__search-box-input" />
                                        </div>                                          
                                    </div>

                                    <button type="button" onClick={event => this.GetInteractions(event, this.state.numberinteract)} className="modal__content__form__group__button">Buscar</button>
                                </div>
                                </div>
                            </div>









                            <div className="modal__content__user-details__content">
                                <div className="modal__content__tabs__body__tab__result">
                                <div className="modal__content__tabs__body__tab__result__header">
                                    <div className="modal__content__tabs__body__tab__result__header__col modal__content__tabs__body__tab__result__header__col--2">Canal</div>
                                    <div className="modal__content__tabs__body__tab__result__header__col modal__content__tabs__body__tab__result__header__col--4"></div>
                                    <div className="modal__content__tabs__body__tab__result__header__col modal__content__tabs__body__tab__result__header__col--3">Operador</div>
                                    <div className="modal__content__tabs__body__tab__result__header__col modal__content__tabs__body__tab__result__header__col--2">Criticidade</div>
                                    <div className="modal__content__tabs__body__tab__result__header__col modal__content__tabs__body__tab__result__header__col--4">Data e Hora</div>
                                    <div className="modal__content__tabs__body__tab__result__header__col modal__content__tabs__body__tab__result__header__col--1"></div>
                                </div>








                                <div className="modal__content__tabs__body__tab__result__body">
                                {this.state.interactions.map((interaction,index) => (

                                    <div key={index} className="modal__content__tabs__body__tab__result__body__row">
                                    <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--2">
                                    {
                                        (() => {
                                            if(interaction.idmidia === 1){
                                                return ( 
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M0,0H20V20H0Z" fill="none"/><path  className="grey-mode" d="M18.82,14.632A10.572,10.572,0,0,1,15.5,14.1a.95.95,0,0,0-.95.223L12.5,16.372a14,14,0,0,1-6.133-6.133L8.416,8.178a.893.893,0,0,0,.232-.931,10.572,10.572,0,0,1-.531-3.322A.933.933,0,0,0,7.188,3H3.924A.933.933,0,0,0,3,3.931a15.819,15.819,0,0,0,15.822,15.82.933.933,0,0,0,.929-.931V15.556A.933.933,0,0,0,18.82,14.632Zm-.931-3.264h1.86A8.376,8.376,0,0,0,11.375,3V4.86a6.509,6.509,0,0,1,6.514,6.514Zm-3.723,0h1.86a4.655,4.655,0,0,0-4.652-4.645v1.86a2.788,2.788,0,0,1,2.792,2.792Z" transform="translate(-1.375 -1.375)" fill="#005daa"/></svg>
                                                );
                                            }else if(interaction.idmidia === 6){
                                                return ( 
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.009" viewBox="0 0 20 20.009"><path d="M0,.961V19.047a.961.961,0,0,0,.961.961h9.693V12.283h-2.6V9.126h2.6V6.475a3.49,3.49,0,0,1,3.49-3.49h2.722V5.821H14.917a1.112,1.112,0,0,0-1.111,1.111V9.126h3.007L16.4,12.283H13.8v7.726h5.237A.961.961,0,0,0,20,19.047V.961A.961.961,0,0,0,19.039,0H.953A.959.959,0,0,0,0,.961Z" fill="#3b5998"  className="grey-mode"/></svg>
                                                );
                                            }else if(interaction.idmidia === 5){
                                                return ( 
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path  className="grey-mode" d="M-67.705-1207.71a9.912,9.912,0,0,1-5.5-1.656l-3.843,1.231,1.246-3.715a9.885,9.885,0,0,1-1.9-5.859,10.012,10.012,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.009,10.009,0,0,1-67.705-1207.71Zm-3.769-15.43a1.458,1.458,0,0,0-1.024.36l-.029.03a3.2,3.2,0,0,0-1,2.4,5.363,5.363,0,0,0,1.17,2.991l.018.024c.011.014.03.041.057.081l.006.008a11.887,11.887,0,0,0,4.918,4.31,8.551,8.551,0,0,0,2.934.819,2.694,2.694,0,0,0,.571-.065,2.819,2.819,0,0,0,1.96-1.411,2.507,2.507,0,0,0,.173-1.4c-.055-.094-.185-.157-.381-.251l-.014-.007-.164-.08c-.216-.108-1.713-.848-1.991-.947a.735.735,0,0,0-.252-.049.564.564,0,0,0-.468.268l-.092.13a10.08,10.08,0,0,1-.689.905.556.556,0,0,1-.414.169.752.752,0,0,1-.288-.059l-.074-.03a7.346,7.346,0,0,1-2.271-1.416,8.959,8.959,0,0,1-1.62-2.016.455.455,0,0,1,.108-.61l.009-.011c.093-.119.183-.215.279-.316.053-.056.1-.11.155-.168l.016-.018a1.62,1.62,0,0,0,.308-.439.613.613,0,0,0-.043-.544c-.049-.1-.343-.817-.6-1.448l0-.011-.044-.107-.246-.6c-.194-.456-.336-.48-.637-.491l-.1,0C-71.314-1223.136-71.391-1223.14-71.474-1223.14Z" transform="translate(77.71 1227.71)" fill="#25d366"/></svg>
                                                );
                                            }
                                        })()
                                    }
                                    </div>
                                    <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--4">
                                    {
                                        (() => {
                                                if(interaction.idmidia === 1){
                                                    return 'Chamada de Voz'
                                                }else if(interaction.mensagem === null || interaction.mensagem === '' || interaction.mensagem === "") {
                                                    return 'Sem mensagem de texto'  
                                                }else{
                                                    if (isJson(interaction.mensagem) === true){
                                                        let json = JSON.parse(interaction.mensagem);
                                                        let options = json.options;
                                                        let i = 1;
                                                        var opcoes = [];
                                                        for (i in options) {
                                                            opcoes.push(i+" - "+options[i][1]);
                                                        }
                                                        return json.msg+" \r\n "
                                                    }else{
                                                        var mensagem_tratada = interaction.mensagem;
                                                        let valor = 1
                                                        try{
                                                        mensagem_tratada = '{"'+valor+'": [{"mensagem_tratada":"'+mensagem_tratada+'"}]}';
                                                        var obj = JSON.parse(mensagem_tratada);
                                                        mensagem_tratada = obj[1][0].mensagem_tratada
                                                        } catch(e){
                                                        mensagem_tratada = interaction.mensagem; 
                                                        }
                                                        return mensagem_tratada
                                                    }
                                                }
                                        })()
                                    }
                                    </div>
                                    <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--3">
                                        {interaction.username}
                                    </div>
                                    <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--2">
                                        <div className="criticidade normal" data-tippy="Normal" tabIndex="0">•</div>
                                    </div>
                                    <div className={interaction.idmidia === 1 ? "modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--3 modal__content__tabs__body__tab__result__body__col--pull-left":"modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--8 modal__content__tabs__body__tab__result__body__col--pull-left"}>
                                        {interaction.datarec}
                                    </div>
                                    
                                        {
                                            (() => {
                                                    if(interaction.idmidia === 1){
                                                        var url = interaction.filerecord
                                                        var name = 'Sem arquivo'
                                                        if(url){
                                                            url = url.replace("192.168.178.2", "\\"+interaction.change_path);
                                                        }
                                                        return <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--6 modal__content__tabs__body__tab__result__body__col--pull-left">
                                                                    <div className="modal__content__tabs__body__tab__result__body__actions modal__content__tabs__body__tab__result__body__actions--audio">
                                                                            <div className="actions-media">
                                                                                <audio className="actions-media__audio" controls>
                                                                                    <source src={connection_platform.type_connect+'://'+ipcurrent+url} type="audio/ogg" />
                                                                                </audio>                                          
                                                                            </div>
                                                                    </div>
                                                               </div>
                                                    }else{
                                                        return <div className="modal__content__tabs__body__tab__result__body__col modal__content__tabs__body__tab__result__body__col--1 modal__content__tabs__body__tab__result__body__col--pull-left">
                                                                    <div className="modal__content__tabs__body__tab__result__body__actions">
                                                                        <a onClick={event => this.ShowHistory(event, interaction.idcdr, interaction.datarc)} className="modal__content__tabs__body__tab__result__body__actions__action"><i className="material-icons">forum</i></a>
                                                                    </div>
                                                               </div> 
                                                    }
                                            })()
                                        }
                                    </div>  
                                ))}
                                </div>
                                </div>
                            </div>
                            </main>
                            <footer className="modal__footer modal__footer--pull-right">
                           
                            <a onClick={event => this.ShowContactDisplay(event, this.state.interactcontact)} className="modal__btn modal__btn-primary">Ver contato</a>
                            <a className="modal__btn modal__btn-secondary" onClick={event => this.ExitModal(event, 'modal__agenda-pf__cliente__interacoes')}>Voltar</a>
                            </footer>
                        </div>
                    </div>
                </div> */}

        {parseInt(modeStorage) === 4 &&
        modeTabShit === "teams" &&
        modeScreen === "Gestor2" ? (
          ""
        ) : (
          <ModalsDetails.InteractionsHistoricModal displayscreen="contact" />
        )}
        {/* <div
          className="modal micromodal-slide"
          id="modal__agenda-pf__cliente__interacoes"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__agenda-pf__cliente__interacoes__title"
            >
              <header className="modal__header">
                <h2
                  className="modal__title"
                  id="modal__agenda-pf__cliente__interacoes__title"
                >
                  Interações
                </h2>
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  onClick={(event) =>
                    this.ExitModal(
                      event,
                      "modal__agenda-pf__cliente__interacoes"
                    )
                  }
                ></button>
              </header>
              <main
                className="modal__content"
                id="modal__agenda-pf__cliente__interacoes__content"
              >
                <div className="modal__content__user-details__header">
                  <div className="modal__content__user-details__header__info">
                    {(() => {
                      if (this.state.pathfile) {
                        if (this.state.pathfile.length === 1) {
                          return (
                            <div className="photo-container-one active">
                              <Topover
                                interactive={true}
                                content={this.renderPopoverPhotoContact(
                                  this,
                                  connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    this.state.pathfile[0].pathfile
                                )}
                              >
                                <div className="photo-container-one__item">
                                  <img
                                    src={
                                      this.state.pathfile[0].pathfile ===
                                        null || ""
                                        ? DEFAULT
                                        : connection_platform.type_connect +
                                          "://" +
                                          ipcurrent +
                                          this.state.pathfile[0].pathfile
                                    }
                                  />
                                  <div className="photo-container__list__item__social">
                                    {(() => {
                                      if (
                                        this.state.pathfile[0].midiaid === 1
                                      ) {
                                        return (
                                          <img
                                            width="22"
                                            height="22"
                                            src={CALLCHAT}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 3
                                      ) {
                                        return (
                                          <img
                                            width="22"
                                            height="22"
                                            src={MIDIAEMAIL}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 4
                                      ) {
                                        return (
                                          <img
                                            width="22"
                                            height="22"
                                            src={MIDIAFACE}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 5
                                      ) {
                                        return (
                                          <img
                                            width="22"
                                            height="22"
                                            src={MIDIAZAP}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 6
                                      ) {
                                        return (
                                          <img
                                            width="22"
                                            height="22"
                                            src={INSTAGRAM}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 8
                                      ) {
                                        return (
                                          <img
                                            width="22"
                                            height="22"
                                            src={MIDIATELEGRAM}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 9
                                      ) {
                                        return (
                                          <img
                                            width="22"
                                            height="22"
                                            src={TWITTER}
                                          />
                                        );
                                      } else if (
                                        this.state.pathfile[0].midiaid === 10
                                      ) {
                                        return (
                                          <img
                                            width="22"
                                            height="22"
                                            src={LINKEDIN}
                                          />
                                        );
                                      }
                                    })()}
                                  </div>
                                </div>
                              </Topover>
                            </div>
                          );
                        } else {
                          return (
                            <div className="photo-container active">
                              {this.state.pathfile.slice(0, 1).map((path) => (
                                <div className="photo-container__img">
                                  <div className="photo-container__img__s2"></div>
                                  <div className="photo-container__img__s1"></div>
                                  <div className="wrapper-photo">
                                    <img
                                      src={
                                        path.pathfile === null || ""
                                          ? DEFAULT
                                          : connection_platform.type_connect +
                                            "://" +
                                            ipcurrent +
                                            path.pathfile
                                      }
                                    />
                                    <div className="photo-container__list__item__social">
                                      {(() => {
                                        if (path.midiaid === 1) {
                                          return (
                                            <img
                                              width="22"
                                              height="22"
                                              src={CALLCHAT}
                                            />
                                          );
                                        } else if (path.midiaid === 3) {
                                          return (
                                            <img
                                              width="22"
                                              height="22"
                                              src={MIDIAEMAIL}
                                            />
                                          );
                                        } else if (path.midiaid === 4) {
                                          return (
                                            <img
                                              width="22"
                                              height="22"
                                              src={MIDIAFACE}
                                            />
                                          );
                                        } else if (path.midiaid === 5) {
                                          return (
                                            <img
                                              width="22"
                                              height="22"
                                              src={MIDIAZAP}
                                            />
                                          );
                                        } else if (path.midiaid === 6) {
                                          return (
                                            <img
                                              width="22"
                                              height="22"
                                              src={INSTAGRAM}
                                            />
                                          );
                                        } else if (path.midiaid === 8) {
                                          return (
                                            <img
                                              width="22"
                                              height="22"
                                              src={MIDIATELEGRAM}
                                            />
                                          );
                                        } else if (path.midiaid === 9) {
                                          return (
                                            <img
                                              width="22"
                                              height="22"
                                              src={TWITTER}
                                            />
                                          );
                                        } else if (path.midiaid === 10) {
                                          return (
                                            <img
                                              width="22"
                                              height="22"
                                              src={LINKEDIN}
                                            />
                                          );
                                        }
                                      })()}
                                    </div>
                                  </div>
                                </div>
                              ))}
                              <div className="photo-container__list">
                                {this.state.pathfile
                                  .slice(1, this.state.pathfile.length)
                                  .map((path) => (
                                    <>
                                      <div className="photo-container__list__item">
                                        <img
                                          src={
                                            path.pathfile === null || ""
                                              ? DEFAULT
                                              : connection_platform.type_connect +
                                                "://" +
                                                ipcurrent +
                                                path.pathfile
                                          }
                                        />
                                        <div className="photo-container__list__item__social">
                                          {(() => {
                                            if (path.midiaid === 1) {
                                              return (
                                                <img
                                                  width="22"
                                                  height="22"
                                                  src={CALLCHAT}
                                                />
                                              );
                                            } else if (path.midiaid === 3) {
                                              return (
                                                <img
                                                  width="22"
                                                  height="22"
                                                  src={MIDIAEMAIL}
                                                />
                                              );
                                            } else if (path.midiaid === 4) {
                                              return (
                                                <img
                                                  width="22"
                                                  height="22"
                                                  src={MIDIAFACE}
                                                />
                                              );
                                            } else if (path.midiaid === 5) {
                                              return (
                                                <img
                                                  width="22"
                                                  height="22"
                                                  src={MIDIAZAP}
                                                />
                                              );
                                            } else if (path.midiaid === 6) {
                                              return (
                                                <img
                                                  width="22"
                                                  height="22"
                                                  src={INSTAGRAM}
                                                />
                                              );
                                            } else if (path.midiaid === 8) {
                                              return (
                                                <img
                                                  width="22"
                                                  height="22"
                                                  src={MIDIATELEGRAM}
                                                />
                                              );
                                            } else if (path.midiaid === 9) {
                                              return (
                                                <img
                                                  width="22"
                                                  height="22"
                                                  src={TWITTER}
                                                />
                                              );
                                            } else if (path.midiaid === 10) {
                                              return (
                                                <img
                                                  width="22"
                                                  height="22"
                                                  src={LINKEDIN}
                                                />
                                              );
                                            }
                                          })()}
                                        </div>
                                      </div>
                                    </>
                                  ))}
                              </div>
                            </div>
                          );
                        }
                      } else {
                        return (
                          <div className="modal__content__user-details__header__info__photo">
                            person
                          </div>
                        );
                      }
                    })()}
                    <div className="modal__content__user-details__header__info__text">
                      <div className="modal__content__user-details__header__info__name">
                        {this.state.person}
                      </div>
                      <div className="modal__content__user-details__header__info__phone">
                        {this.state.numberC}
                      </div>
                    </div>
                  </div>
                  <div className="modal__content__user-details__header__search">
                    <div className="modal__content__user-details__header__search__title">
                      Deseja buscar as interações de qual período?
                    </div>
                    <a className="modal__content__user-details__header__search__form">
                      <div className="modal__content__user-details__header__search__form__col modal__content__user-details__header__search__form__col--half">
                        <label
                          htmlFor="modal__content__user-details__header__search__form__de"
                          className="modal__content__user-details__header__search__form__col__label"
                        >
                          De:
                        </label>
                        <input
                          type="datetime-local"
                          defaultValue={this.datainitinteract}
                          ref={(input) => (this.dataInit = input)}
                          className="modal__content__user-details__header__search__form__col__input"
                          id="modal__content__user-details__header__search__form__de"
                        />
                      </div>
                      <div className="modal__content__user-details__header__search__form__col modal__content__user-details__header__search__form__col--half">
                        <label
                          htmlFor="modal__content__user-details__header__search__form__ate"
                          className="modal__content__user-details__header__search__form__col__label"
                        >
                          Até:
                        </label>
                        <input
                          type="datetime-local"
                          defaultValue={this.datafiminteract}
                          ref={(input) => (this.dataFim = input)}
                          className="modal__content__user-details__header__search__form__col__input"
                          id="modal__content__user-details__header__search__form__ate"
                        />
                      </div>

                      <div className="block-header__search-box-nav">
                        <div className="block-header__search-box-content-input">
                          <input
                            type="text"
                            placeholder="Pesquisar mensagens..."
                            onChange={(e) =>
                              this.setState({ mensagem: e.target.value })
                            }
                            className="block-header__search-box-input"
                          />
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={(event) =>
                          this.GetInteractions(event, this.state.numberinteract)
                        }
                        className="modal__content__form__group__button"
                      >
                        Buscar
                      </button>
                    </a>
                  </div>
                </div>
                <div className="modal__content__user-details__content">
                  <div className="modal__content__tabs__body__tab__result">
                    <div className="modal__content__tabs__body__tab__result__header modal__content__tabs__body__tab__result__header--interacao">
                      <div className="modal__content__tabs__body__tab__result__header__col">
                        Canal
                      </div>
                      <div className="modal__content__tabs__body__tab__result__header__col"></div>
                      <div className="modal__content__tabs__body__tab__result__header__col">
                        Operador
                      </div>
                      <div className="modal__content__tabs__body__tab__result__header__col ">
                        Criticidade
                      </div>
                      <div className="modal__content__tabs__body__tab__result__header__col ">
                        Data e Hora
                      </div>
                      <div className="modal__content__tabs__body__tab__result__header__col"></div>
                    </div>
                    <div className="modal__content__tabs__body__tab__result__body">
                      {this.state.interactions.map((interaction, index) => (
                        <>
                          <Tooltippy
                            content={
                              interaction.subservico !== null
                                ? interaction.subservico
                                : "Saída"
                            }
                          >
                            <div className="modal__content__tabs__body__tab__result__body__row modal__content__tabs__body__tab__result__body__row--interacao">
                              <div className="modal__content__tabs__body__tab__result__body__col ">
                                {(() => {
                                  if (interaction.idmidia === 1) {
                                    return (
                                      <img
                                        src={CALLCHAT}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />

                                      
                                    );
                                  } else if (interaction.idmidia === 2) {
                                    return (
                                      <img
                                        src={MIDIAWEB}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                    );
                                  } else if (interaction.idmidia === 6) {
                                    return (
                                      <img
                                        src={INSTAGRAM}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />

                                      
                                    );
                                  } else if (interaction.idmidia === 5) {
                                    return (
                                      <img
                                        src={MIDIAZAP}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                      
                                    );
                                  } else if (interaction.idmidia === 3) {
                                    return (
                                      <img
                                        src={MIDIAEMAIL}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                      
                                    );
                                  } else if (interaction.idmidia === 4) {
                                    return (
                                      <img
                                        src={MIDIAFACE}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                      
                                    );
                                  } else if (interaction.idmidia === 8) {
                                    return (
                                      <img
                                        src={MIDIATELEGRAM}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                      
                                    );
                                  } else if (interaction.idmidia === 9) {
                                    return (
                                      <img
                                        src={TWITTER}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                      
                                    );
                                  } else if (interaction.idmidia === 10) {
                                    return (
                                      <img
                                        src={LINKEDIN}
                                        width="26"
                                        style={{ marginLeft: "-3px" }}
                                      />
                                     
                                    );
                                  }
                                })()}
                              </div>
                              <div className="modal__content__tabs__body__tab__result__body__col ">
                                {(() => {
                                  if (interaction.idmidia === 1) {
                                    return "Chamada de Voz";
                                  } else if (
                                    interaction.mensagem === null ||
                                    interaction.mensagem === "" ||
                                    interaction.mensagem === ""
                                  ) {
                                    return "Sem mensagem de texto";
                                  } else {
                                    if (isJson(interaction.mensagem) === true) {
                                      let json = JSON.parse(
                                        interaction.mensagem
                                      );
                                      let options = json.options;
                                      let i = 1;
                                      var opcoes = [];
                                      for (i in options) {
                                        opcoes.push(i + " - " + options[i][1]);
                                      }
                                      return json.msg + " \r\n ";
                                    } else {
                                      var mensagem_tratada =
                                        interaction.mensagem;
                                      let valor = 1;
                                      try {
                                        mensagem_tratada =
                                          '{"' +
                                          valor +
                                          '": [{"mensagem_tratada":"' +
                                          mensagem_tratada +
                                          '"}]}';
                                        var obj = JSON.parse(mensagem_tratada);
                                        mensagem_tratada =
                                          obj[1][0].mensagem_tratada;
                                      } catch (e) {
                                        mensagem_tratada = interaction.mensagem;
                                      }
                                      return mensagem_tratada;
                                    }
                                  }
                                })()}
                              </div>
                              <div className="modal__content__tabs__body__tab__result__body__col ">
                                {interaction.username}
                              </div>
                              <div className="modal__content__tabs__body__tab__result__body__col ">
                                <div
                                  className="criticidade normal"
                                  data-tippy="Normal"
                                  tabIndex="0"
                                >
                                  •
                                </div>
                              </div>
                              <div className="modal__content__tabs__body__tab__result__body__col  ">
                                {interaction.datarec}
                              </div>

                              {(() => {
                                if (interaction.idmidia === 1) {
                                  var url = interaction.filerecord;
                                  var name = "Sem arquivo";
                                  var namefile;
                                  if (url) {
                                    url = url.replace(
                                      "192.168.178.2",
                                      "\\" + interaction.change_path
                                    );
                                    namefile = url
                                      .split("\\")
                                      .pop()
                                      .split("#")[0]
                                      .split("?")[0];
                                  }

                                  return (() => {
                                    if (InfoUsers.permreproduce === true) {
                                      return (
                                        <div className="modal__content__tabs__body__tab__result__body__col  ">
                                          <div className="modal__content__tabs__body__tab__result__body__actions modal__content__tabs__body__tab__result__body__actions--audio">
                                            <div className="actions-media">
                                              <audio
                                                src={
                                                  connection_platform.type_connect +
                                                  "://" +
                                                  ipcurrent +
                                                  url
                                                }
                                                controls="controls"
                                                controlslist="nofullscreen nodownload noremoteplayback foobar"
                                                className="actions-media__audio"
                                              ></audio>
                                              
                                              {(() => {
                                                if (
                                                  InfoUsers.permdownload ===
                                                  true
                                                ) {
                                                  return (
                                                    <a
                                                      className="download-media"
                                                      onClick={(event) =>
                                                        this.download(
                                                          connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            url,
                                                          namefile
                                                        )
                                                      }
                                                    >
                                                      <i className="material-icons">
                                                        get_app
                                                      </i>
                                                    </a>
                                                  );
                                                }
                                              })()}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  })();
                                } else {
                                  return (
                                    <div className="modal__content__tabs__body__tab__result__body__col  ">
                                      <div className="modal__content__tabs__body__tab__result__body__col  modal__content__tabs__body__tab__result__body__col--end">
                                        <div className="modal__content__tabs__body__tab__result__body__actions">
                                          <a
                                            onClick={(event) =>
                                              this.ShowHistory(
                                                event,
                                                interaction.idcdr,
                                                interaction.datarc
                                              )
                                            }
                                            className="modal__content__tabs__body__tab__result__body__actions__action"
                                          >
                                            <i className="material-icons">
                                              forum
                                            </i>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              })()}
                            </div>
                          </Tooltippy>
                        </>
                      ))}
                    </div>
                  </div>
                </div>
              </main>
              <footer className="modal__footer modal__footer--pull-right">
                <a
                  onClick={(event) =>
                    this.ShowContactDisplay(event, this.state.interactcontact)
                  }
                  className="modal__btn modal__btn-primary"
                >
                  Ver contato
                </a>
                <a
                  className="modal__btn modal__btn-secondary"
                  onClick={(event) =>
                    this.ExitModal(
                      event,
                      "modal__agenda-pf__cliente__interacoes"
                    )
                  }
                >
                  Voltar
                </a>
              </footer>
            </div>
          </div>
        </div> */}

        <input id="click_button" type="hidden" />
      </div>
    );
  }
  exportPDFWithMethod = () => {
    savePDF(ReactDOM.findDOMNode(this.pdfExportComponent), {
      paperSize: "A4",
      margin: 10,
      fileName: this.state.cliente + "_" + this.state.clientpdf + ".pdf",
    });
  };
  exportPDFWithComponent = () => {
    this.pdfExportComponent.save();
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Modals);
